import React, { useState, useEffect } from 'react';
import RoleSection from './JobDetails/RoleDetailsForm';
import PersonalDetails from './personalDetails/PersonalDetails';
import AddressDetails from './AddressDetails/AddressDetails';
import EducationalDetails from './EducationalDetails/EducationalDetails';
import ProfessionalDetails from './ProfessionalDetails/professionalDetails';
import ResearchDetails from './ResearchDetails/ResearchDetails';
import '../../css/Form.css';
import '../../css/Login.css';
import ApiGateway from '../../helper/ApiGateway';
import ERPUtils from '../../helper/Utils';
import Popup from '../../helper/SuccessPopup';
import ConfirmPopup from '../../helper/ConfirmationPopup';
import Loader from '../../helper/Loader';
import useStateCallback from '../../helper/asyncSetState.ts';
import OrcidPopup from '../../helper/orcidPopup';
import { toast } from 'react-toastify';
import { reject } from 'q';
import Utils from '../../helper/Utils';
import { CleaningServices } from '@mui/icons-material';
import ResumePopup from './ResumePopup';
import { useParams } from 'react-router-dom';

// Max value Restriction for Research details:

const FormContainer = (props) => {
	const {
		SubmitSuccess,
		popupOnDraftSuccess,
		CallDraft,
		CallDraftApplNo,
		setCallDraft,
		setCallDraftApplNo,
		ApplicationLoadingError,
		applyNew,
		dashboardHandler,
		LockDashboard,
		registrationId,
		// setTimerRunning,
		timePeriodOver,
		setTimePeriodOver,
		jobCode,
		// LogMeOut
	} = props;
	const [addInfoEnteredVal, setAddInfoEnteredVal] = useState(0);
	const [addEnteredValue, setAddEnteredValue] = useState(0);
	const [isSave, setIsSave] = useState(false);

	const [commonApiResponse, setCommonApiResponses] = useState()

	// eslint-disable-next-line no-unused-vars
	const [addInfoMaxVal, setAddInfoMaxVal] = useState(5000);
	// eslint-disable-next-line no-unused-vars
	const [addMaxValue, setAddMaxValue] = useState(5000);
	const [editable, setEditable] = useState(true);
	// Popup state:
	//popup state For others Current State and city start:
	const [showCurrStatePopup, setCurrShowStatePopup] = useState(false);
	const [currStateConfirmPopup, setCurrStateConfirmPopup] = useState(false);
	const [showCurrCityPopup, setShowCurrCityPoup] = useState(false);
	const [currCityConfirmPoup, setCurrCityConfirmPoup] = useState(false);

	const [showPermStatePopup, setPermShowStatePopup] = useState(false);
	const [permStateConfirmPopup, setPermStateConfirmPopup] = useState(false);
	const [showPermCityPopup, setShowPermCityPoup] = useState(false);
	const [permCityConfirmPoup, setPermCityConfirmPoup] = useState(false);
	const [saveDraftData, setSaveDraftData] = useState(null);
	const [ErrorPopup, setErrorPopup] = useState(false);
	const [ErrorMsg, setErrorMsg] = useState('');
	const [EmpTypeAlert, setEmpTypeAlert] = useState(false);
	// const [TimerAlert, setTimerAlert] = useState(false);

	//For others Current State and city start:

	const [ReqFieldsAlert, setReqFieldsAlert] = useState(false);
	const [ValidationAlert, setValidationAlert] = useState(false);
	const [showAddressPopup, setAddressPopup] = useState(false);
	const [OpenConfirmPopup, setOpenConfirmPopup] = useState(false);
	const [storeData, setStoreData] = useState({
		param1: '',
		param2: '',
		param3: ''
	});
	// const [CountryCodePopup, setCountryCodePopup] = useState(false);
	const [countryCodeConfirmPopup, setCountryCodeConfirmPopup] = useState(false);
	const [wrongPincode, setWrongPincode] = useStateCallback(false);

	//Loader:
	const [LoaderActive, setLoaderActive] = useState(false);
	// Resume Upload Popup:
	const [parseResumeData, setParseResumeData] = useState(false);

	// DropDown states Start:
	// Role Details:
	const [posts, setPosts] = useState([]);
	const [subjects, setSubjects] = useState([]);
	const [specialize, setSpecialize] = useState([]);
	const [Campus, setCampus] = useState([]);
	const [jobCategory, setJobCategory] = useState([]);

	// Personal Details:
	const [Nationalities, setNationalities] = useState([]);
	const [Genders, setGenders] = useState([]);
	const [maritalStatus, setMaritalStatus] = useState([]);
	const [Religions, setReligions] = useState([]);
	const [bloodGroups, setBloodGroups] = useState([]);
	const [Reservations, setReservations] = useState([]);
	const [DifferentlyAbledOpt, setDifferentlyAbledOpt] = useState([]);
	// Educational Details:
	const [EducationList, SetEducationList] = useState([]);
	const [Years, SetYears] = useState([]);
	const [EligibilityTests, setEligibilityTests] = useState([]);
	const [states, setStates] = useState([]);

	const EducationStatus = [{ value: '1', label: 'Pursuing' }, { value: '2', label: 'Completed' }];

	// Professional Details:
	const [experiences, setExperiences] = useState([]);
	const [functionalAreas, setFunctionalAreas] = useState({
		CurrentFunctional: [],
		PreviousFunctional: [[]]
	});
	const employmentType = [{ value: 'parttime', label: 'Part-time' }, { value: 'fulltime', label: 'Full-time' }];

	//Research Details:
	const [vacancySources, setVacancySources] = useState([]);
	const [ResearchData, setResearchData] = useState([]);

	//Upload prereq
	const [uploadProcessCode] = useState([
		"EMPLOYEE_APP_EDN_CLASSX",
		"EMPLOYEE_APP_EDN_CLASSXII",
		"EMPLOYEE_APP_EDN_UG",
		"EMPLOYEE_APP_EDN_PG",
		"EMPLOYEE_APP_EDN_MPHIL",
		"EMPLOYEE_APP_EDN_DIPLOMA",
		"EMPLOYEE_APP_EDN_PHD",
		"EMPLOYEE_APP_EDN_OTHERS",
		"EMPLOYEE_APP_EDN_ELIGIBILITY_TEST",
		"EMPLOYEE_APP_PROFESSIONAL_EXP",
		"EMPLOYEE_APP_PHOTO",
		"EMP_RESUME_UPLOAD"
	])
	const [UploadData, setUploadData] = useState([]);

	// Address Details:
	const [statesCur, setCurStates] = useState([]);
	const [statesPer, setPerStates] = useState([]);
	const [countries, setCountries] = useState([]);
	const [CountryCodes, setCountryCodes] = useState([]);
	const [currentCities, setCurrentCities] = useState([]);
	const [permanentCities, setPermanentCities] = useState([]);
	const [boardList, setBoardList] = useState({});
	const [institutionList, setInstitutionList] = useState({});
	// DropDowns State End:

	// To show Specialization Based on api results:
	const [showSpecialization, setShowSpecialization] = useState(false);
	const campusPrefArray = [
		{
			campusPreference: {
				value: null,
				label: null,
			}
		},
		{
			campusPreference: {
				value: null,
				label: null,
			}
		},
		{
			campusPreference: {
				value: null,
				label: null,
			}
		}
	]
	const [campusPref, setCampusPref] = useState(campusPrefArray)

	// Form State:
	const [userDetails, setUserDetails] = useStateCallback({
		// Role Details:
		Post: '',
		Subject: [],
		Specialization: [],
		// Location: [],
		empApplnCampusPrefDTOList1: [],
		empApplnCampusPrefDTOList2: [],
		empApplnCampusPrefDTOList3: [],
		category: '',
		jobCategoryDTO: {},
		//Personal Details:
		Name: props.username === null ? '' : props.username,
		Gender: '',
		FatherName: '',
		MotherName: '',
		DOB: '',
		Email: props.Email === null ? '' : props.Email,
		CountryCode: '',
		CountryCodeEnt: '',
		mobileNo: '',
		AltNo: '',
		AadharNo: '',
		marital: '',
		Nationality: '',
		Religion: '',
		BloodGroup: '',
		Reservation: '',
		DiffAbled: '',
		DifferentlyAbledType: '',
		Minority: '',
		PassportNo: '',
		profilePhoto: [],
		resume: null,
		// Current Address:
		currentLine1: '',
		currentLine2: '',
		currentCountry: '',
		currentState: '',
		otherCurrState: '',
		currentCity: '',
		otherCurrCity: '',
		currentPincode: '',
		curAddSameAsPer: false,
		// permanent Address:
		permanentLine1: '',
		permanentLine2: '',
		permanentCountry: '',
		permanentState: '',
		otherPermState: '',
		permanentCity: '',
		otherPermCity: '',
		permanentPincode: '',
		// Educational Details:
		HighestQualification: '',
		EducationDetailsObj: {},
		others: [],
		EligibilityTest: [
			{
				EligibilityTestName: '',
				EligibilityYearOfComp: '',
				Documents: []
			}
		],
		// Professional details:
		currentWorking: '',
		currentExperienceType: '',
		currentFunctionalArea: '',
		currentOtherFunctionalArea: '',
		currentEmpType: '',
		currentFromDate: '',
		currentToDate: new Date(),
		currentTotalYears: 0,
		currentTotalMonths: 0,
		currentDesignation: '',
		currentInstitute: '',
		currentNoticePeriod: '',
		currentSalary: '',
		majorAchievements: '',
		CurrentExpDocuments: [
		],
		PrevExpDocuments: [
		],
		expSalary: '',
		TotalFullTimeYearsExp: 0,
		TotalFullTimeMonthsExp: 0,
		TotalPartTimeYearsExp: 0,
		TotalPartTimeMonthsExp: 0,

		//Research Details:
		ResearchExperience: '',
		orcidId: '',
		vidwanId: '',
		scopusPaperNumber: '',
		hIndex: '',
		interviewedBefore: '',
		vacancySource: '',
		SourceOthers: '',
		OtherInformation: '',
		ResearchDetailsData: {},
		InterviewedDept: '',
		InterviewedYear: '',
		InterviewedApplNo: '',
		InterviewedSubject: '',
		ResearchDetailsImg: [
			{
				Documents: []
			}
		]
	});

	// Professional details state Object:
	const [professionalDetails, setProfessionalDetails] = useStateCallback([
		{
			ExperienceType: '',
			functionalArea: '',
			EmpType: '',
			fromDate: '',
			ToDate: '',
			TotalYears: 0,
			TotalMonths: 0,
			designation: '',
			institution: '',
			OtherFunctionalArea: ''
		}
	]);

	const [toggle, setToggle] = useStateCallback(false); // category toggle state

	// Active Tab Component state:
	const [renderComp, setRenderComp] = useStateCallback({
		RoleDetails: true,
		PersonalDetails: false,
		AddressDetails: false,
		EducationDetails: false,
		ProfessionalExperience: false,
		ResearchDetails: false
	});

	// Form Errors State:
	const [ValidationError, setValidationError] = useStateCallback({
		mobileNoError: false,
		AltNoError: false,
		AadharNoError: false,
		EmailError: false,
		currentPincodeError: false,
		permanentPincodeError: false,
		expSalaryError: false,
		vidwanIdError: false,
		scopusPaperNumberError: false,
		hIndexError: false,
		ResearchDetailsImgError: false,
		InterviewedYearError: false,
		InterviewedApplNoError: false,
		currentPincodeLengthError: false,
		permanentPincodeLengthError: false,
		currentSalaryError: false,
		orcidIdError: false,
		PucPercentageError: false,
	});

	// Save Draft Error Count:
	let addReqErrors = {};

	const saveDraftMand = {};

	// const [EducationStatusData, setEducationStatusData] = useState({});

	const [requiredFields, setRequiredFields] = useStateCallback({
		commonErrors: [
			{
				PostReqError: false,
				jobCategoryDTOReqError: false,
				categoryReqError: false,
				SubjectReqError: false,
				SpecializationReqError: false,
				empApplnCampusPrefDTOList1ReqError: false,
				NameReqError: false,
				GenderReqError: false,
				DOBReqError: false,
				mobileNoReqError: false,
				CountryCodeReqError: false,
				EmailReqError: false, //NEWELY ADDED
				// AltNoReqError: false,
				AadharNoReqError: false,
				maritalReqError: false,
				NationalityReqError: false,
				ReligionReqError: false,
				ReservationReqError: false,
				PassportNoReqError: false,
				currentLine1ReqError: false,
				currentCountryReqError: false,
				currentStateReqError: false,
				currentCityReqError: false,
				currentPincodeReqError: false,
				permanentLine1ReqError: false,
				permanentCountryReqError: false,
				permanentStateReqError: false,
				permanentCityReqError: false,
				permanentPincodeReqError: false,
				HighestQualificationReqError: false,
				currentWorkingReqError: false,
				expSalaryReqError: false,
				currentOtherFunctionalAreaReqError: false,
				currentExperienceTypeReqError: false,
				currentFunctionalAreaReqError: false,
				currentEmpTypeReqError: false,
				currentDesignationReqError: false,
				currentFromDateReqError: false,
				currentNoticePeriodReqError: false,
				// currentSalaryReqError: false, //NOT REQUIRED -  R10 CHANGES
				currentInstituteReqError: false,
				// orcidIdReqError: false
				otherCurrStateReqError: false, //Newely added
				otherCurrCityReqError: false, //Newely added
				otherPermStateReqError: false, //Newely added
				otherPermCityReqError: false, //Newely added
			}
		],
		eduReq: false,
		profReq: [
			{
				otherFunctAreaReqError: false
			}
		],
		//temperrory
		Req: [
			{
				CourseError: false,
				StatusError: false,
				// SpecializationError: false,
				YearOfCompError: false,
				PercentageError: false,
				InstituteError: false,
				BoardError: false
			},
			{
				CourseError: false,
				StatusError: false,
				// SpecializationError: false,
				YearOfCompError: false,
				PercentageError: false,
				InstituteError: false,
				BoardError: false
			},
		]
	});

	// State for Required fields based on the selected post:
	const [ReqErrorOnPostSelect, setReqErrorOnPostSelect] = useStateCallback({
		jobCategoryDTOReqError: false,
		categoryReqError: false,
		SubjectReqError: false,
		SpecializationReqError: false
		// PassportNoReqError: false
	});

	// Education details Mandatory fields based on the Api:
	// const [EducationMandatory, setEducationMandatory] = useStateCallback({});

	// To call savedraft on next and previous button click
	const [saveTheData, setSaveTheData] = useState(false);

	// Method to call the Apis to get the dropDowns Data:
	const getDropDownsDataFromApi = () => {
		setLoaderActive(true);
		ApiGateway.getBuilder()
			// Personal Details DropDown Api's:
			.addPost('Common/getGender', {}) // To get genders Data 0 API -01
			.addPost('Common/getCountryAndNationality', {}) // To get Country and nationality Data 1 API -02
			.addPost('Common/getMaritalStatus', {}) // To get Marital status Data 2 API -03
			.addPost('Common/getReligion', {}) // To get Religion Data 3 API -04
			.addPost('Common/getReservationCategory', {}) // To get Reservation Category Data 4 API -05
			.addPost('Common/getBloodGroup', {}) // To get BloodGroup Data 5 API -06
			.addPost('Common/getDifferentlyAbled', {}) // To get Differently Data 6 API -07
			// Educational Details DropDown Api's:
			.addPost('Common/getQualificationLevel', {}) // To get Qualification Level Data 1 API -08
			.addPost('Employee/CommonEmployee/getEmpEligibilityExamList', {}) // To get the eligibility Test List 2 API -09
			// Job Details Details DropDown Api's:
			.addPost('Employee/CommonEmployee/getEmployeeCategory', {}) // To get the Post data 1 API -10
			// .addPost('Common/getLocation', {}) // To get Location Data 2 API -11
			// .addPost('Common/getCampus', {}) // To get Location Data 2 API -11
			// Experience Details DropDown Api's:
			.addPost('Common/getApplnWorkExperienceType', {}) // To get the Experience Type Data 1 API -12
			.addPost('Common/getGeneratedYear', {}) // API -13
			// Research Details DropDown Api's:
			.addPost('Common/getApplnVacancyInformation', {})  //API -14
			.addPost('Employee/CommonEmployee/getResearchDetails', {}) //API -15
			// Address Details Dropdown Api's:
			// .addPost('Common/getState', {})
			// .addPost('Admission/CommonAdmissionController/getUniversityOrBoard', {})
			// .addPost('Common/getInstitutionList', {})
			.addPost('Common/getDepartments', {}) //API -17
			.addPost(`Common/getFolderListForMenu?processCode=${[...uploadProcessCode]}`, {}) //API -17
			.execute((responses) => {
				try {
					setCommonApiResponses(responses)
					setLoaderActive(false);
					// Personal Details:
					let GenderData = [];
					let countryAndNationalityData = [];
					let MaritalData = [];
					let ReligionData = [];
					let ReservationCategoryData = [];
					let BloodGroupData = [];
					let DifferentlyAbledData = [];
					// Educational Details:
					let qualificationData = [];
					let EligibilityData = [];
					// Job Details:
					let PostsData = [];
					// let campusData = [];
					// Experience Details:
					let workExperienceTypeData = [];
					let YearsData = [];
					// Research Details:
					let vacancyInformation = [];
					let ResearchDisplayData = [];
					//Upload prereq
					let UploadData = [];
					// Address Details:
					// let States = [];
					// let universityOrBoardList = [];
					// let institutionList = []
					if (
						ERPUtils.isUndefinedOrNull(responses) === false &&
						ERPUtils.isUndefinedOrNull(responses?.length) === false
					) {
						if (responses.length > 0) {
							try {
								callSaveDraftApi(responses);
								LoadPrevData(responses);
								// Personal Details:
								GenderData = responses[0]?.data || [];
								countryAndNationalityData = responses[1]?.data || [];
								MaritalData = responses[2]?.data || [];
								ReligionData = responses[3]?.data || [];
								ReservationCategoryData = responses[4].data || [];
								BloodGroupData = responses[5].data || [];
								DifferentlyAbledData = responses[6].data || [];
								// Educational Details:
								qualificationData = responses[7].data || [];
								EligibilityData = responses[8].data || [];
								// Job Details:
								PostsData = responses[9].data || [];
								// campusData = responses[10].data || [];
								// Experience Details:
								workExperienceTypeData = responses[10].data || [];
								YearsData = responses[11].data || [];
								// Research Details:
								vacancyInformation = responses[12].data || [];
								ResearchDisplayData = responses[13].data || [];
								// Address Details:
								// States = responses[15].data || [];
								// cities = responses[16].data || [];
								// universityOrBoardList = responses[15]?.data || []
								// institutionList = responses[16]?.data || []
								UploadData = responses[15].data || [];
								// Form Country Codes:
								if (ERPUtils.isUndefinedOrNull(countryAndNationalityData.dto) === false) {
									MakeCountryCodes(countryAndNationalityData.dto);
								}
								// filter Post Data:
								if (ERPUtils.isUndefinedOrNull(PostsData.dto) === false) {
									FilterPostData(PostsData.dto);
								}
								// nationality Data:
								if (ERPUtils.isUndefinedOrNull(countryAndNationalityData.dto) === false) {
									MakeNationalityData(countryAndNationalityData.dto);
								}
							} catch (ex) {
								setLoaderActive(false);
							}
						}
					} else {
						ApplicationLoadingError('CommonApis');
					}
					// Job Details State:
					// setPosts(ERPUtils.isUndefinedOrNull(PostsData.dto) === false ? PostsData.dto : []);
					// setCampus(ERPUtils.isUndefinedOrNull(campusData.dto) === false ? campusData.dto : []);
					// Personal Details State:
					setGenders(ERPUtils.isUndefinedOrNull(GenderData.dto) === false ? GenderData.dto : []);
					setMaritalStatus(ERPUtils.isUndefinedOrNull(MaritalData.dto) === false ? MaritalData.dto : []);
					setReligions(ERPUtils.isUndefinedOrNull(ReligionData.dto) === false ? ReligionData.dto : []);
					setBloodGroups(ERPUtils.isUndefinedOrNull(BloodGroupData.dto) === false ? BloodGroupData.dto : []);
					setReservations(
						ERPUtils.isUndefinedOrNull(ReservationCategoryData.dto) === false
							? ReservationCategoryData.dto
							: []
					);
					setDifferentlyAbledOpt(
						ERPUtils.isUndefinedOrNull(DifferentlyAbledData.dto) === false ? DifferentlyAbledData.dto : []
					);
					// Experience Details:
					setExperiences(
						ERPUtils.isUndefinedOrNull(workExperienceTypeData.dto) === false
							? workExperienceTypeData.dto
							: []
					);
					// Research Details:
					setVacancySources(
						ERPUtils.isUndefinedOrNull(vacancyInformation.dto) === false ? vacancyInformation.dto : []
					);
					setResearchData(
						ERPUtils.isUndefinedOrNull(ResearchDisplayData.dto) === false ? ResearchDisplayData.dto : []
					);
					setUploadData(
						ERPUtils.isUndefinedOrNull(UploadData) === false ? UploadData : []
					);
					// Educational Details:
					SetEducationList(
						ERPUtils.isUndefinedOrNull(qualificationData.dto) === false ? qualificationData.dto : []
					);
					SetYears(ERPUtils.isUndefinedOrNull(YearsData) === false ? YearsData.dto : []);
					setEligibilityTests(
						ERPUtils.isUndefinedOrNull(EligibilityData.dto) === false ? EligibilityData.dto : []
					);
					// Address Details:
					// setCities(ERPUtils.isUndefinedOrNull(cities.dto) === false ? cities.dto : []);
					// setStates(ERPUtils.isUndefinedOrNull(States.dto) === false ? States.dto : []);
					// setBoardList(ERPUtils.isUndefinedOrNull(universityOrBoardList) === false ? universityOrBoardList : [])
					// setInstitutionList(ERPUtils.isUndefinedOrNull(institutionList) === false ? institutionList : [])
					setCountries(
						ERPUtils.isUndefinedOrNull(countryAndNationalityData.dto) === false
							? countryAndNationalityData.dto
							: []
					);
					setLoaderActive(false);

				} catch (ex) {
					setLoaderActive(false);
					ApplicationLoadingError('CommonApis', 'Error! while loading the data');
				}
			});
	};

	const AlertError = () => {
		setErrorPopup(true);
	};

	const ErrorPopupHandler = () => {
		setErrorPopup(!ErrorPopup);
	};

	const EmpTypeAlertPopupHandler = () => {
		setEmpTypeAlert(!EmpTypeAlert)
	}

	// const closeResumePopup = () => {
	// 	setShowResumePopup(false);
	// }

	// const timerAlert = () => {
	// 	setTimerAlert(true);
	// };

	// const timerAlertHandler = () => {
	// 	setTimerAlert(!TimerAlert);
	// 	setTimeout(() => LogMeOut(), 100)
	// };

	//
	// Making nationality data:
	const MakeNationalityData = (ApiData) => {
		const data = [];
		ApiData.map((el, index) => {
			let newObj = {
				value: '',
				label: ''
			};
			newObj.value = el.value;
			newObj.label = el.nationality;
			return (data[index] = newObj);
		});
		setNationalities(data);
	};
	// Making country codes based on nationality Data:
	const MakeCountryCodes = (ApiData) => {
		const countryCodesData = [];
		ApiData.map((el, index) => {
			if (!ERPUtils.isNullorWhiteSpace(el.phoneCode)) {
				let newObj = {
					value: '',
					label: ''
				};
				newObj.value = el.phoneCode;
				newObj.label = el.phoneCode;
				return (countryCodesData[index] = newObj);
			}
			return countryCodesData
		});
		countryCodesData.push({ value: 'Other', label: 'Other' });
		setCountryCodes(countryCodesData);
	};

	// To filter posts dropdown data based on the application:
	const FilterPostData = (ApiData) => {
		const postsData = [];
		ApiData.map((el) => {
			if (el?.isShowInAppln === true) {
				return postsData.push(el);
			}
			return '';
		});
		setPosts(postsData);
		return '';
	};

	const CloseCountryCodeInput = () => {
		// let opt = { value: '91', label: '91' };
		const target1 = 'CountryCode';
		const target2 = 'CountryCodeEnt';
		const ModifyData = { ...userDetails };
		ModifyData[target1] = '';
		ModifyData[target2] = '';
		setUserDetails(ModifyData);
	};

	//Method to call the Api based on the Selected Options:
	const callApiWithPrevData = (data, url, target, nestedState, id) => {
		setLoaderActive(true);
		ApiGateway.post(url + data, {}, (response) => {
			try {
				setLoaderActive(false);
				let newData = [];
				if (ERPUtils.isUndefinedOrNull(response) === false) {
					try {
						newData = response.data;
					} catch (ex) { }
				}
				if (target === "jobCategory") {
					let tempArray = []
					if (!ERPUtils.isNullOrEmpty(newData.dto)) {
						tempArray = newData.dto.filter((item) => item?.showInAppln)
					}
					setJobCategory(tempArray)
				}
				if (target === 'subjects') {
					setSubjects(newData.dto !== null ? newData.dto : []);
					// ChangeSpecStatus(newData.dto !== null ? true : false);
				}
				if (target === 'specialization') {
					setSpecialize(newData.dto !== null ? newData.dto : []);
					ChangeSpecStatus(newData.dto !== null ? true : false);
				}
				if (target === 'FunctionalArea') {
					const oldObj = { ...functionalAreas };
					oldObj[nestedState] = newData.dto !== null ? newData.dto : [];
					oldObj[nestedState].push({ value: 'Others', label: 'Others' });
					setFunctionalAreas(oldObj);
				}
				if (target === 'PreviousFunctionalArea') {
					const oldObj = { ...functionalAreas };
					oldObj[nestedState][id] = newData.dto !== null ? newData.dto : [];
					oldObj[nestedState][id].push({ value: 'Others', label: 'Others' });
					setFunctionalAreas(oldObj);
				}
			} catch (ex) {
				setLoaderActive(false);
			}
		});
	};

	const ChangeSpecStatus = (requiredStatus) => {
		setShowSpecialization(requiredStatus);
		ChangeRequiredStatus('Subject', requiredStatus);
	};

	const ProfesionalSelectHandler = (option, target) => {
		setSaveTheData(true);
		let name = target;
		let value = option;
		let oldData = { ...userDetails };
		if (name === 'currentFunctionalArea') {
			oldData[name] = value;
			oldData['currentOtherFunctionalArea'] = '';
		} else {
			oldData[name] = value;
		}
		setUserDetails(oldData, () => {
			if (name === 'currentEmpType') {
				const oldData = userDetails;
				oldData['currentEmpType'] = value;
				if (userDetails.currentFromDate !== (null || '')) {
					calculateCurrExperience(userDetails.currentFromDate, userDetails.currentToDate, '', 'currentExp');
				}
			}
			if (name === 'currentExperienceType') {
				let url = 'Employee/CommonEmployee/getApplnSubjectCategory?isAcademic=';
				callApiWithPrevData(option.isExperienceTypeAcademic, url, 'FunctionalArea', 'CurrentFunctional');
			}
		});
		if (option !== null) {
			RemoveReqFieldErrors(target, '', '');
		}
	};

	const camPrefApi = (optionsData) => {
		ApiGateway.post(`Employee/CommonEmployee/getCampusBySubjectCategory?subjectCategoryId=${optionsData}`, {}, (response) => {
			try {
				setLoaderActive(false);
				setCampus(ERPUtils.isUndefinedOrNull(response.data) === false ? response.data : []);
			} catch (ex) { setLoaderActive(false); }
		}, "Protected")
	}

	const JobDetailsSubjectSelect = (option, target) => {
		setCampus([])
		setCampusPref(campusPrefArray)
		setSaveTheData(true);
		let name = target;
		let value = option !== null ? option : [];
		if (option !== null) {
			RemoveReqFieldErrors(name, '', '');
		}
		let url = 'Employee/CommonEmployee/getApplnSubjectCategorySpecialization?subjectCategoryId=';
		let optionsData = [];
		value.map((el) => {
			return optionsData.push(el.value);
		});
		let newSpecs = [];
		let name1 = 'Specialization';
		optionsData.map((el) => {
			userDetails.Specialization.map((item) => {
				if (el === item.subjectCategoryId) {
					newSpecs.push(item);
				}
				return '';
			});
			return '';
		});
		const newState = Utils.cloneState(userDetails)
		newState.empApplnCampusPrefDTOList1 = []
		newState.empApplnCampusPrefDTOList2 = []
		newState.empApplnCampusPrefDTOList3 = []
		newState[name1] = newSpecs
		newState[name] = value
		setUserDetails(newState);
		callApiWithPrevData(optionsData, url, 'specialization');
		setLoaderActive(true);
		camPrefApi(optionsData);
	};

	const [isPassportRequired, setIsPassportRequired] = useState(null)
	function passportCountryMendatoryFlag(value) {
		return new Promise((resolve, reject) => {
			setLoaderActive(true);
			ApiGateway.post(`Common/getPassPortNotRequired?erpCountryId=${value?.value}`, {}, (response) => {
				try {
					const flagUpdate = response?.data
					setIsPassportRequired(flagUpdate)
					resolve(flagUpdate)
				} catch (ex) {
					reject(ex)
				}
				setLoaderActive(false);

			});
		})
	}
	// Handler for React select DropDowns:
	const SelectHandler = (option, target, index) => {
		setSaveTheData(true);
		let name = target;
		let value = option !== null ? option : [];
		let oldData = { ...userDetails };
		if (name === "Nationality") {
			passportCountryMendatoryFlag(value)
		}
		if (option !== null && name !== 'HighestQualification') {
			RemoveReqFieldErrors(name, '', '');
		}

		if (name === 'Subject') {
			let url = 'Employee/CommonEmployee/getApplnSubjectCategorySpecialization?subjectCategoryId=';
			let optionsData = [];
			value.map((el) => {
				return optionsData.push(el.value);
			});
			callApiWithPrevData(optionsData, url, 'specialization');
		}
		if (name === 'Religion') {
			let change = 'Minority';
			// let oldData = { ...userDetails };
			oldData[change] = option.isMinority === true ? 'Yes' : 'No';
			oldData[name] = value;
			setUserDetails(oldData);
			return '';
		}
		if (name === 'HighestQualification') {
			// let oldData = { ...userDetails };
			oldData[name] = value;
			oldData = removeOldEducationState(name, value, oldData);
			RemoveReqFieldErrors(name, '', value);
			setUserDetails(oldData);
			// setMandatoryFields(value);
			return '';
		}
		if (name === 'CountryCode') {
			if (option.label === 'Other') {
				// setCountryCodePopup(true);
				oldData['CountryCode'] = option;
				oldData['CountryCodeEnt'] = ''
			} else {
				oldData['CountryCode'] = option;
				oldData['CountryCodeEnt'] = ''
			}
		}
		if (name === 'currentCountry') {
			callStateApi("current", value)
			if (userDetails.curAddSameAsPer === 'Yes') {
				oldData['currentCountry'] = value;
				oldData['permanentCountry'] = value;
				oldData['currentState'] = "";
				oldData['permanentState'] = "";
				oldData['currentPincode'] = "";
				oldData['tPincode'] = "";
				oldData['currentCity'] = '';
				oldData['permanentCity'] = '';
				oldData['otherCurrCity'] = '';
				oldData['otherCurrState'] = '';
				setCurrentCities([]);
				setPermanentCities([]);
				setUserDetails(oldData);
			} else {
				oldData[name] = value;
				oldData['currentState'] = "";
				oldData['currentCity'] = '';
				oldData['currentPincode'] = "";
				oldData['otherCurrCity'] = '';
				oldData['otherCurrState'] = '';
				setCurrentCities([]);
				setUserDetails(oldData);
			}


		} else if (name === 'currentState') {
			if (userDetails.curAddSameAsPer === 'Yes') {
				oldData['currentState'] = value;
				oldData['permanentState'] = value;
				oldData['currentCity'] = '';
				oldData['permanentCity'] = '';
				setUserDetails(oldData);
			} else {
				oldData[name] = value;
				oldData['currentCity'] = '';
				setUserDetails(oldData);
			}
		} else if (name === 'currentCity') {
			if (userDetails.curAddSameAsPer === 'Yes') {
				oldData['currentCity'] = value;
				oldData['permanentCity'] = value;
				oldData['currentState'] = value?.stateDto;
				oldData['permanentState'] = value?.stateDto;
				setUserDetails(oldData);
			} else {
				oldData[name] = value;
				oldData['currentState'] = value?.stateDto;
				setUserDetails(oldData);
			}
		} else if (name === 'permanentCity') {
			oldData[name] = value;
			oldData['permanentState'] = value?.stateDto;
			setUserDetails(oldData);
		}
		else if (name === 'permanentState') {
			oldData[name] = value;
			oldData['permanentCity'] = '';
			setUserDetails(oldData);
		} else if (name === "permanentCountry") {
			oldData[name] = value;
			oldData['permanentState'] = "";
			oldData['permanentCity'] = '';
			oldData['permanentPincode'] = "";
			oldData['otherPermState'] = '';
			setUserDetails(oldData);
			callStateApi("permanent", value)
		} else {
			if (!ERPUtils.isUndefinedOrNull(index)) {
				const newPref = ERPUtils.cloneState(campusPref);
				newPref[index].campusPreference = value;
				setCampusPref(newPref);
				oldData[name] = [value]
			} else {
				oldData[name] = value;
			}
			if (name === "category") {
				oldData.empApplnCampusPrefDTOList1 = []
				oldData.empApplnCampusPrefDTOList2 = []
				oldData.empApplnCampusPrefDTOList3 = []
				camPrefApi(option.value)
			}
			setUserDetails(oldData);
		}
		// if (name === 'currentState') {
		// 	callCityApi('current', value);
		// }
		// if (name === 'permanentState') {
		// 	callCityApi('permanent', value);
		// }
	};

	const callStateApi = (target, val) => {
		setLoaderActive(true);
		ApiGateway.post('Common/getStatesByCountry?countryId=' + val.value, {}, (response) => {
			try {
				setLoaderActive(false);
				if (target === 'current') {
					let States = response.data.dto !== null ? response.data.dto : [];
					setCurStates(States);
				}
				if (target === 'permanent') {
					let States = response.data.dto !== null ? response.data.dto : [];
					setPerStates(States);
				}
			} catch (ex) {
				setLoaderActive(false);
			}

		});
	}

	// const callCityApi = (target, val) => {
	// 	setLoaderActive(true);
	// 	ApiGateway.post('Common/getCity?stateId=' + val.value, {}, (response) => {
	// 		try {
	// 			setLoaderActive(false);
	// 			if (target === 'current') {
	// 				let cities = response.data.dto !== null ? response.data.dto : [];
	// 				setCurrentCities(cities);
	// 			}
	// 			if (target === 'permanent') {
	// 				let cities = response.data.dto !== null ? response.data.dto : [];
	// 				setPermanentCities(cities);
	// 			}
	// 		} catch (ex) {
	// 			setLoaderActive(false);
	// 		}
	// 	});
	// };

	const removeOldEducationState = (target, val, data,) => {
		EducationList.map((el) => {
			if (el.qualificationLevelDegreeOrder > val.qualificationLevelDegreeOrder) {
				data.EducationDetailsObj[el.value] = [
					// {
					// 	Qualification: '',
					// 	Status: '',
					// 	Course: '',
					// 	Specialization: '',
					// 	YearOfComp: '',
					// 	Percentage: '',
					// 	Institute: '',
					// 	Board: '',
					// 	countryId: '',
					// 	stateId: '',
					// 	stateOther: '',
					// 	Documents: []
					// }
				];
			}
			return '';
		});
		return data;
	};

	// Toggle handler for Category:
	const toggleHandler = (option, target) => {
		let name1 = 'ResearchDetailsData';
		if (option !== null) {
			RemoveReqFieldErrors(target, '', '');
		}
		let url = 'Employee/CommonEmployee/getApplnSubjectCategory?isAcademic=';
		let url1 = 'Employee/CommonEmployee/getEmployeeJobCategory?employeeCategoryID='
		if (option.isEmployeeCategoryAcademic) {
			let change = 'category';
			let change1 = 'ResearchExperience';
			let change2 = 'jobCategoryDTO'
			let change3 = 'Subject';
			let change4 = 'Specialization';
			setToggle(false);
			setUserDetails({
				...userDetails,
				[target]: option,
				[change]: '',
				[change1]: 'Yes',
				[change2]: [],
				[change3]: [],
				[change4]: [],
				empApplnCampusPrefDTOList1: [],
				empApplnCampusPrefDTOList2: [],
				empApplnCampusPrefDTOList3: [],
				[name1]: {}
			});
			callApiWithPrevData(option.isEmployeeCategoryAcademic, url, 'subjects');
			callApiWithPrevData(option.value, url1, 'jobCategory');
			ChangeRequiredStatus('Teaching');
		} else {
			let change1 = 'Subject';
			let change2 = 'Specialization';
			let change3 = 'ResearchExperience';
			let change4 = 'jobCategoryDTO'
			setToggle(true);
			setUserDetails({
				...userDetails,
				[target]: option,
				[change1]: [],
				[change2]: [],
				[change3]: 'No',
				[change4]: [],
				empApplnCampusPrefDTOList1: [],
				empApplnCampusPrefDTOList2: [],
				empApplnCampusPrefDTOList3: [],
				[name1]: {}
			});
			callApiWithPrevData(option.isEmployeeCategoryAcademic, url, 'subjects');
			callApiWithPrevData(option.value, url1, 'jobCategory');
			ChangeRequiredStatus('Non-Teaching');
		}
		setSaveTheData(true);
	};

	const ChangeRequiredStatus = (name, ShowStatus) => {
		let changeStatus = { ...ReqErrorOnPostSelect };
		let oldErrors = { ...requiredFields };
		if (name === 'Teaching') {
			changeStatus.SubjectReqError = true;
			changeStatus.categoryReqError = false;
			oldErrors.commonErrors[0].categoryReqError = false;
		}
		if (name === 'Non-Teaching') {
			changeStatus.categoryReqError = true;
			changeStatus.SubjectReqError = false;
			changeStatus.SpecializationReqError = false;
			oldErrors.commonErrors[0].SubjectReqError = false;
			oldErrors.commonErrors[0].SpecializationReqError = false;
		}
		if (name === 'Subject') {
			changeStatus.SpecializationReqError = ShowStatus;
			oldErrors.commonErrors[0].SpecializationReqError = false;
		}
		if (name === "specialization") {
			changeStatus.SpecializationReqError = true
			oldErrors.commonErrors[0].SpecializationReqError = false
		}
		if (name === "validateSubject") {
			changeStatus.SubjectReqError = true
			oldErrors.commonErrors[0].SubjectReqError = false
		}
		setReqErrorOnPostSelect(changeStatus);
		setRequiredFields(oldErrors, () => {
			RemoveReqTabStyling('');
		});
	};

	const ValidationErrorHandler = (name, removeError, secondTarget, isIndian) => {
		let target = name;
		let comName = 'Error';
		let stateName = target + comName;
		let target2 = name + 'LengthError';
		const oldData = { ...ValidationError };
		if (removeError) {
			if (name === 'currentPincode' || 'permanentPincode') {
				if (secondTarget) {
					oldData[stateName] = false;
					oldData[target2] = true;
				} else {
					oldData[stateName] = true;
					oldData[target2] = false;
				}
			} else {
				oldData[stateName] = true;
			}
		} else {
			if (name === 'currentPincode' || 'permanentPincode') {
				if (secondTarget) {
					oldData[stateName] = false;
					if (isIndian) oldData[target2] = true;
				} else {
					oldData[stateName] = false;
					oldData[target2] = false;
				}
			} else {
				oldData[stateName] = false;
			}
		}
		setValidationError(oldData);
	};

	// Change for only ResearchDetails:
	const ResearchDetailsHandler = (event) => {
		setSaveTheData(true);
		const name = event.target.name;
		const val = event.target.value;
		const ObjName = event.target.id;
		let ErrorName = ObjName + name;
		const pattern = '^[0-9]*$';
		let result = val.match(pattern);
		if (result !== null) {
			let arrayObj = { ...userDetails.ResearchDetailsData };
			const modify = { ...arrayObj[ObjName] };
			modify[name] = val;
			arrayObj[ObjName] = modify;
			setUserDetails({
				...userDetails,
				ResearchDetailsData: arrayObj
			});
			ValidationErrorHandler(ErrorName, false);
		} else {
			ValidationErrorHandler(ErrorName, true);
		}
	};

	// Change Handler for checkboxes:
	const checkboxHandler = (event) => {
		setSaveTheData(true);
		const name = event.target.name;
		const val = event.target.checked === true ? 'Yes' : 'No';
		const oldData = { ...userDetails };
		oldData[name] = val;
		setUserDetails(oldData);
		if (name === 'curAddSameAsPer') {
			mapTheAddressData(val);
		}
	};

	const mapTheAddressData = (value) => {
		const AddressMapping = { ...userDetails };
		if (value === 'Yes') {
			let Check1 = ERPUtils.isNullorWhiteSpace(userDetails['currentLine1']) === false;
			let Check2 = ERPUtils.isNullorWhiteSpace(userDetails['currentCountry']) === false;

			// let Check3 = ERPUtils.isNullorWhiteSpace(userDetails['currentState']) === false;
			// let Check4 = ERPUtils.isNullorWhiteSpace(userDetails['currentCity']) === false;

			let Check5 = ERPUtils.isNullorWhiteSpace(userDetails['currentPincode']) === false;

			let Check6 = ERPUtils.isNullorWhiteSpace(userDetails['currentState']) ?
				(userDetails?.currentCountry?.nationality === "Indian") ? false : true
				: true;
			let Check7 = ERPUtils.isNullorWhiteSpace(userDetails['currentCity']) ?
				(userDetails?.currentCountry?.nationality === "Indian") ? false : true
				: true;
			if (Check1 && Check2 && Check5 && Check6 && Check7) {
				AddressMapping['permanentLine1'] = userDetails['currentLine1'];
				AddressMapping['permanentLine2'] = userDetails['currentLine2'];
				AddressMapping['permanentCountry'] = userDetails['currentCountry'];
				AddressMapping['permanentState'] = userDetails['currentState'];
				AddressMapping['otherPermState'] = userDetails['otherCurrState'];
				AddressMapping['permanentCity'] = userDetails['currentCity'];
				AddressMapping['otherPermCity'] = userDetails['otherCurrCity'];
				AddressMapping['permanentPincode'] = userDetails['currentPincode'];
				AddressMapping['curAddSameAsPer'] = value;
				RemoveReqFieldErrors('CurAddSameAsPerAdd', '', '');
				removeInvalidError();
			} else {
				setAddressPopup(true);
			}
		} else {
			AddressMapping['permanentLine1'] = '';
			AddressMapping['permanentLine2'] = '';
			AddressMapping['permanentCountry'] = '';
			AddressMapping['permanentState'] = '';
			AddressMapping['otherPermState'] = '';
			AddressMapping['permanentCity'] = '';
			AddressMapping['otherPermCity'] = '';
			AddressMapping['permanentPincode'] = '';
			AddressMapping['curAddSameAsPer'] = value;
		}
		setUserDetails(AddressMapping);
	};

	const removeInvalidError = () => {
		const oldData = { ...ValidationError };
		oldData['permanentPincodeError'] = false;
		oldData['permanentPincodeLengthError'] = false;
		setValidationError(oldData);
	};

	// Educational Details Handler:
	const EducationDetailsHandler = (event, data, type) => {
		setSaveTheData(true);
		let newState = { ...userDetails };
		const CombinedId = event.target.id;
		const id = CombinedId.charAt(0);
		const name = event.target.name;
		const val = event.target.value;
		// const stateName = event.target.title;
		const check = /^[0-9]{1,3}([.][0-9]{0,2}|)$/;
		const finalOutput = val === '' ? '' : val.match(check);
		if (type === 'number') {
			if (finalOutput !== null) {
				const initialState = newState.EducationDetailsObj[data];
				const modify = initialState[id];
				modify[name] = val;
				modify['Qualification'] = data;
				setUserDetails(newState);
			}
		} else if (type === 'grade') {
			const regex = /^[0-9a-zA-Z\-./+]+$/
			if (regex.test(val) || ERPUtils.isNullorWhiteSpace(val)) {
				const initialState = newState.EducationDetailsObj[data];
				const modify = initialState[id];
				modify[name] = val;
				modify['isMandatory'] = true
				modify['Qualification'] = data;
				setUserDetails(newState);
			}
		} else {
			const initialState = newState.EducationDetailsObj[data];
			const modify = initialState[id];
			modify[name] = val;
			modify['isMandatory'] = true
			modify['Qualification'] = data;
			setUserDetails(newState);
		}
		if (val !== null && isSave) {
			// RemoveReqFieldErrors(name, stateName, id);			
			validateEducationalData({ ...requiredFields }, true)

		}
	};
	const EducationDetailsSelectHandler = async (event, data, id, name, title, qualificationItem) => {
		setSaveTheData(true);
		let newState = { ...userDetails };
		const val = event?.value;
		// const stateName = title;
		const initialState = newState.EducationDetailsObj[data];
		const modify = initialState[id];

		if (name === "Board" || name === "Institute") {
			if (name === "Board") {
				modify[name] = event?.label;
				if (event?.label !== event?.value) {
					modify["erpBoardOrUniversity"] = event;
				} else {
					modify["erpBoardOrUniversity"] = ""
				}
			} else {
				modify[name] = event?.label;
				if (event?.label !== event?.value) {
					modify["erpInstitute"] = event;
				} else {
					modify["erpInstitute"] = ""
				}
			}
		} else {
			modify[name] = val;
		}

		modify['Qualification'] = data;
		if (name === "countryId") {
			modify["stateId"] = null;
			modify["stateOther"] = null;
			modify["Institute"] = null;
			modify["Board"] = null;
			modify["erpBoardOrUniversity"] = null;
			modify["erpInstitute"] = null
			callEducationStateApi(val)
			await getBoardOrInstitueList(event, data, id, name, title, qualificationItem, false)
		} else if (name === "stateId") {
			modify["Institute"] = null;
			modify["Board"] = null
			modify["erpBoardOrUniversity"] = null;
			modify["erpInstitute"] = null
			let boardList = []
			setBoardList(boardList)
			await getBoardOrInstitueList(event, data, id, name, title, qualificationItem, false)
		}

		// await timer(100)
		setUserDetails(newState);
		if (val !== null && isSave) {
			// RemoveReqFieldErrors(name, stateName, id);
			validateEducationalData({ ...requiredFields }, true)
		}
	};

	function getBoardOrInstitueList(event, data, id, name, title, qualificationItem, initialData) {
		return new Promise((resolve, reject) => {
			// const value = typeof event === "string" ? event : "";
			let newState = { ...userDetails };
			const initialState = initialData ? qualificationItem : newState.EducationDetailsObj[data][id];
			let url = "";
			let { countryId, stateId } = initialState;

			if (ERPUtils.isUndefinedOrNull(stateId)) {
				stateId = "";
			}

			const boardType = (initialData ? event.boardType : qualificationItem?.boardType) || "";
			const boardUrl = `Common/getUniversityBoardList?countryId=${parseInt(countryId, 10)}&stateId=${parseInt(stateId, 10) || ""}&boardType=${boardType}`;

			if (!ERPUtils.isUndefinedOrNull(countryId)) {
				if (name === "Board" || name === "Institute") {
					if (name === "Board") {
						url = boardUrl;
						ApiGateway.post(url, {}, (response) => {
							try {
								const responseData = ERPUtils.isNullOrEmpty(response?.data) ? [] : response?.data;
								if (name === "Board") {
									let tempBoard = boardList;
									tempBoard[data][id] = responseData;
									setBoardList(tempBoard);
								} else {
									let tempInst = institutionList;
									tempInst[data][id] = responseData;
									setInstitutionList(tempInst);
								}
								resolve(responseData);
							} catch (ex) {
								reject(ex);
							}
						}, "Protected");
					}
				} else {
					ApiGateway.getBuilder()
						.addPost(boardUrl, {}, "Protected")
						.execute((responses) => {
							try {
								const boardData = ERPUtils.isNullOrEmpty(responses[0].data) ? [] : responses[0].data;

								if (initialData) {
									let tempBoard = boardList;
									let tempInst = institutionList;
									if (ERPUtils.isUndefinedOrNull(tempBoard[data])) {
										tempBoard[data] = [];
										tempBoard[data][id] = boardData;
									} else {
										tempBoard[data][id] = [];
										tempBoard[data][id] = boardData;
									}
									setBoardList(tempBoard);
								} else {
									let tempBoardList = boardList;
									tempBoardList[data][id] = boardData;
									setBoardList(tempBoardList);
								}
								resolve(boardData);
							} catch (ex) {
								reject(ex);
							}
						});
				}
			} else if (initialData) {
				let tempBoard = boardList;
				if (ERPUtils.isUndefinedOrNull(tempBoard[data])) {
					tempBoard[data] = [];
					tempBoard[data][0] = [];
				} else {
					tempBoard[data][0] = [];
					tempBoard[data][0] = [];
				}
				setBoardList(tempBoard);
				resolve(tempBoard[data][0]);
			} else {
				resolve();
			}
		});
	}


	// async function getBoardOrInstitueList(event, data, id, name, title, qualificationItem, initialData) {
	// 	// await timer(1000)
	// 	const value = typeof (event) === "string" ? event : ""
	// 	let newState = { ...userDetails };
	// 	const initialState = initialData ? qualificationItem : newState.EducationDetailsObj[data][id];
	// 	let url = ""
	// 	let { countryId, stateId } = initialState
	// 	if (ERPUtils.isUndefinedOrNull(stateId)) {
	// 		stateId = ""
	// 	}
	// 	const boardType = (initialData ? event.boardType : qualificationItem?.boardType) || ""
	// 	const boardUrl = `Common/getUniversityBoardList?countryId=${parseInt(countryId, 10)}&stateId=${parseInt(stateId, 10) || ""}&boardType=${boardType}`
	// 	// const instUrl = `Common/getInstitutionList?countryId=${countryId}&stateId=${stateId}&boardType=${boardType}&name=${value}`
	// 	if (!ERPUtils.isUndefinedOrNull(countryId)) {
	// 		if (name === "Board" || name === "Institute") {
	// 			if (name === "Board") {
	// 				url = boardUrl
	// 			} else {
	// 				// url = instUrl
	// 			}
	// 			ApiGateway.post(url, {}, (response) => {
	// 				try {
	// 					const responseData = ERPUtils.isNullOrEmpty(response?.data) ? [] : response?.data
	// 					if (name === "Board") {
	// 						let tempBoard = {...boardList}
	// 						tempBoard[data][id] = responseData
	// 						setBoardList(tempBoard)
	// 					} else {
	// 						let tempInst = institutionList
	// 						tempInst[data][id] = responseData
	// 						setInstitutionList(tempInst)
	// 					}
	// 				} catch (ex) {
	// 				}
	// 			}, "Protected")
	// 		} else {
	// 			ApiGateway.getBuilder()
	// 				.addPost(boardUrl, {}, "Protected")
	// 				// .addPost(instUrl, {}, "Protected")
	// 				.execute((responses) => {
	// 					try {
	// 						const boardData = ERPUtils.isNullOrEmpty(responses[0].data) ? [] : responses[0].data
	// 						// const instituteData = ERPUtils.isNullOrEmpty(responses[1].data) ? [] : responses[1].data
	// 						if (initialData) {
	// 							let tempBoard = {...boardList}
	// 							let tempInst = institutionList
	// 							if (ERPUtils.isUndefinedOrNull(tempBoard[data])) {
	// 								tempBoard[data] = []
	// 								tempBoard[data][id] = boardData
	// 							} else {
	// 								tempBoard[data][id] = []
	// 								tempBoard[data][id] = boardData
	// 							}
	// 							// if (ERPUtils.isUndefinedOrNull(tempInst[data])) {
	// 							// 	tempInst[data] = []
	// 							// 	tempInst[data][id] = instituteData
	// 							// } else {
	// 							// 	tempInst[data][id] = []
	// 							// 	tempInst[data][id] = instituteData
	// 							// }
	// 							setBoardList(tempBoard)
	// 							// setInstitutionList(tempInst)
	// 						} else {
	// 							let tempBoardList = {...boardList}
	// 							// let tempInstituteList = institutionList
	// 							tempBoardList[data][id] = boardData
	// 							// tempInstituteList[data][id] = instituteData
	// 							setBoardList(tempBoardList)
	// 							// setInstitutionList(tempInstituteList)
	// 						}
	// 					} catch (ex) {
	// 						setLoaderActive(false)
	// 					}
	// 				})
	// 		}
	// 	} else if (initialData) {
	// 		let tempBoard = boardList
	// 		// let tempInst = institutionList
	// 		if (ERPUtils.isUndefinedOrNull(tempBoard[data])) {
	// 			tempBoard[data] = []
	// 			tempBoard[data][0] = []
	// 		} else {
	// 			tempBoard[data][0] = []
	// 			tempBoard[data][0] = []
	// 		}
	// 		// if (ERPUtils.isUndefinedOrNull(tempInst[data])) {
	// 		// 	tempInst[data] = []
	// 		// 	tempInst[data][0] = []
	// 		// } else {
	// 		// 	tempInst[data][0] = []
	// 		// 	tempInst[data][0] = []
	// 		// 	// tempInst = { ...tempBoard[data][id], instituteData }
	// 		// }
	// 		setBoardList(tempBoard)
	// 		// setInstitutionList(tempInst)
	// 	}
	// }


	// const timer = ms => new Promise(res => setTimeout(res, ms)) // TO CREATE DELAY IN UPDATION AFTER API CALL **

	async function getBoardOrUniversityOnLoad(saveData, prevData) {
		const tempEducationList = prevData[7]?.data?.dto
		const EducationalData = saveData.EducationDetailsObj
		const keys = Object.keys(EducationalData)
		let qualificationItem = ""
		if (ERPUtils.isNullOrEmpty(keys)) {
			for (let j = 0; j < tempEducationList.length; j++) {
				let key = tempEducationList[j].value
				await getBoardOrInstitueList("", key, "", "", "", "", true)
			}
		}
		for (let i = 0; i < keys.length; i++) {
			const key = keys[i];
			if (EducationalData[key].length > 0) {
				for (let index = 0; index < EducationalData[key].length; index++) {
					for (let j = 0; j < tempEducationList.length; j++) {
						const element = tempEducationList[j];
						if (parseInt(element.value, 10) === parseInt(key, 10)) {
							qualificationItem = element
						}
					}
					const element = EducationalData[key][index];
					// await timer(200)
					await getBoardOrInstitueList(qualificationItem, key, index, "", "", element, true)
				}
			} else {
				await getBoardOrInstitueList("", key, "", "", "", "", true)
			}
		}
	}

	const callEducationStateApi = (val) => {
		if (ERPUtils.isUndefinedOrNull(states[val]) || ERPUtils.isNullorWhiteSpace(states[val])) {
			setLoaderActive(true);
			ApiGateway.post('Common/getStatesByCountry?countryId=' + val, {}, (response) => {
				try {
					let States = response.data.dto !== null ? response.data.dto : [];
					// let newState ={...states}
					// newState[val] = States;
					// newState={...newState,[val]:States}
					setStates(prevState => ({ ...prevState, [val]: States }));
					setLoaderActive(false);
				} catch (ex) {
					setLoaderActive(false);
				}
			});
		}
	}
	const EducationOtherDetailsHandler = (event, index, type) => {
		let value = event.target.value;
		let name = event.target.name;
		let newState = { ...userDetails }
		const initialState = [...newState["others"]];
		const modify = initialState[index];
		const check = /^[0-9]{1,3}([.][0-9]{0,2}|)$/;
		const finalOutput = value === '' ? '' : value.match(check);
		if (type === "number") {
			if (finalOutput !== null) {
				modify[name] = value;
				setUserDetails(newState);
			}
		} else if (type === 'grade') {
			const regex = /^[0-9a-zA-Z\-./+]+$/
			if (regex.test(value) || ERPUtils.isNullorWhiteSpace(value)) {
				modify[name] = value;
				setUserDetails(newState);
			}
		} else {
			modify[name] = value;
			setUserDetails(newState);
		}
	}
	const EducationalDetailsDropDownHandler = (option, id, name, title, target1, target2, qualificationName, isFromEducation) => {
		setSaveTheData(true);
		const val = option;
		let newState = { ...userDetails }
		if (isFromEducation) {
			const initialState = newState.EducationDetailsObj[qualificationName];
			const modify = initialState[id];
			modify[name] = val;
			modify['isMandatory'] = true
			modify['Qualification'] = qualificationName;
			if (name === target1) {
				modify[target2] = '';
				modify['YearOfComp'] = ""
				setUserDetails(newState);
			} else {
				setUserDetails(newState);
			}
		} else {
			const stateName = title;
			const initialState = [...userDetails[stateName]];
			const modify = initialState[id];
			modify[name] = val;
			modify[title + 'Qualification'] = qualificationName;
			if (name === target1) {
				modify[target2] = '';
				setUserDetails({
					...userDetails,
					[stateName]: initialState
				});
			} else {
				setUserDetails({
					...userDetails,
					[stateName]: initialState
				});
			}
		}
		if (val !== null && isSave) {
			// **************************************** below method
			// RemoveReqFieldErrors(name, title, id);
			validateEducationalData({ ...requiredFields }, true)
		}
		return '';
	};

	const educationDecimalCheck = (event, data) => {
		const CombinedId = event.target.id;
		let newState = { ...userDetails }
		const id = CombinedId.charAt(0);
		const name = event.target.name;
		const val = event.target.value;
		let check = val.split('.');
		if (check.length >= 1) {
			if (check[1] !== undefined) {
				if (check[1].length < 1) {
					const initialState = newState.EducationDetailsObj[data];
					const modify = initialState[id];
					modify[name] = check[0];
					modify['Qualification'] = data;
					setUserDetails(newState);
				}
			} else {
				const initialState = newState.EducationDetailsObj[data];
				const modify = initialState[id];
				modify[name] = check[0];
				modify['Qualification'] = data;
				setUserDetails(newState);
			}
		}
	};

	const setMandatoryFields = (selected) => {
		let setMandatory = {};

		let statusDisplay = {};

		EducationList.map((el) => {
			if (el.qualificationLevelDegreeOrder <= selected.qualificationLevelDegreeOrder) {
				let target = el.value;
				if (el.isMandatory) {
					setMandatory[target] = true;
				}
				if (el.isStatusDisplay) {
					statusDisplay[target] = true;
				}
			}
			return '';
		});
		// setEducationMandatory(setMandatory);
		// setEducationStatusData(statusDisplay);
		return '';
	};

	const GenerateRemovePopup = (target, id, stateName, StateHeader) => {
		setSaveTheData(true);
		const oldData = { ...storeData };
		if (target === 'EducationPopup') {
			if (id !== null) {
				oldData.param1 = id;
				oldData.param2 = stateName;
				oldData.param3 = StateHeader;
				setStoreData(oldData);
			}
			setOpenConfirmPopup(true);
		}
		if (target === 'CountryCode') {
			setCountryCodeConfirmPopup(true);
		}
		if (target === 'currStatePopup') {
			setCurrStateConfirmPopup(true);
		}
		if (target === 'CurCityPopup') {
			setCurrCityConfirmPoup(true);
		}
		if (target === 'permStatePopup') {
			setPermStateConfirmPopup(true);
		}
		if (target === 'permCityPopup') {
			setPermCityConfirmPoup(true);
		}
		if (target === 'Professional') {
			if (id !== null) {
				oldData.param1 = id;
				oldData.param2 = stateName;
				oldData.param3 = StateHeader;
				setStoreData(oldData);
			}
			setOpenConfirmPopup(true);
		}
	};

	const DoItHandler = (name) => {
		setSaveTheData(true);
		if (name === 'Educational') {
			setOpenConfirmPopup(false);
			removeHandler(storeData.param1, storeData.param2, storeData.param3);
		}
		if (name === 'CountryCode') {
			setCountryCodeConfirmPopup(false);
			CloseCountryCodeInput();
		}
		if (name === 'professional') {
			setOpenConfirmPopup(false);
			removeHandler(storeData.param1, storeData.param2, storeData.param3);
		}
		if (name === 'currStateConfirm') {
			setCurrStateConfirmPopup(false);
			changeAddressData('currState');
		}
		if (name === 'currCityConfirm') {
			setCurrCityConfirmPoup(false);
			changeAddressData('currCity');
		}
		if (name === 'permStateConfirm') {
			setPermStateConfirmPopup(false);
			changeAddressData('permState');
		}
		if (name === 'permCityConfirm') {
			setPermCityConfirmPoup(false);
			changeAddressData('permCity');
		}
	};

	const CancelHandler = (name) => {
		if (name === 'Educational') {
			setOpenConfirmPopup(false);
		}
		if (name === 'CountryCode') {
			setCountryCodeConfirmPopup(false);
		}
		if (name === 'professional') {
			setOpenConfirmPopup(false);
		}
		if (name === 'currStateConfirm') {
			setCurrStateConfirmPopup(false);
		}
		if (name === 'currCityConfirm') {
			setCurrCityConfirmPoup(false);
		}
		if (name === 'permStateConfirm') {
			setPermStateConfirmPopup(false);
		}
		if (name === 'permCityConfirm') {
			setPermCityConfirmPoup(false);
		}
	};

	const changeAddressData = (target) => {
		const oldObj = { ...userDetails };
		if (target === 'currState') {
			oldObj['currentState'] = '';
			oldObj['otherCurrState'] = '';
		}
		if (target === 'currCity') {
			oldObj['currentCity'] = '';
			oldObj['otherCurrCity'] = '';
		}
		if (target === 'permState') {
			oldObj['permanentState'] = '';
			oldObj['otherPermState'] = '';
		}
		if (target === 'permCity') {
			oldObj['permanentCity'] = '';
			oldObj['otherPermCity'] = '';
		}
		setUserDetails(oldObj);
	};

	// Remove Handler (To Remove the state that are added dynamically):
	const removeHandler = (id, name, target) => {
		removeRequiredFields(id, name, target); // To remove the state for checking the required fields
		if (name === 'ProfessionalDetails') {
			const values = [...professionalDetails];
			let TotalYears = values[id].TotalYears;
			let TotalMonths = values[id].TotalMonths;
			//CalculateTotalExp(values[id].TotalYears, values[id].TotalMonths, id, 'REMOVE');
			values.splice(id, 1);
			setProfessionalDetails(values, () => {
				CalculateTotalExp(TotalYears, TotalMonths, id, 'REMOVE', '', '', '', 'previous');
			});
		}
		if (name === 'ProfessionalDetails') {
			const newState = { ...userDetails }
			const values = newState.PrevExpDocuments
			values.splice(id, 1);
			setUserDetails(newState)
			// setUserDetails({
			// 	...userDetails,
			// 	[stateName]: values
			// });
		}
		if (name === 'ProfessionalDetails') {
			let oldObj = { ...functionalAreas };
			let values = oldObj['PreviousFunctional'];
			values.splice(id, 1);
			setFunctionalAreas(oldObj);
		}
		if (name === 'Education') {
			if (target === 'others') {
				const stateName = 'others';
				const values = [...userDetails.others];
				values.splice(id, 1);
				setUserDetails({
					...userDetails,
					[stateName]: values
				});
			}
			else if (target === 'Eligibility') {
				const stateName = 'EligibilityTest';
				const values = [...userDetails.EligibilityTest];
				values.splice(id, 1);
				setUserDetails({
					...userDetails,
					[stateName]: values
				});
			} else {
				let newState = { ...userDetails }
				const values = newState.EducationDetailsObj[target]
				values.splice(id, 1);
				setUserDetails(newState);
			}
		}
	};

	// Handler for addMore button (for adding components state dynamically on click of addMore button):
	const addComponent = (name, target, isFromEducation) => {
		setSaveTheData(true);
		addRequiredFields(name, target); // To add the state for checking the required fields
		if (name === 'ProfessionalDetails') {
			const render = [...professionalDetails];
			const lastItem = render[render.length - 1]
			if (!ERPUtils.isNullOrEmpty(render) && (ERPUtils.isNullorWhiteSpace(lastItem.EmpType)
				&& ERPUtils.isNullorWhiteSpace(lastItem.ExperienceType) && ERPUtils.isNullorWhiteSpace(lastItem.functionalArea)
				&& ERPUtils.isNullorWhiteSpace(lastItem.designation) && ERPUtils.isNullorWhiteSpace(lastItem.fromDate)
				&& ERPUtils.isNullorWhiteSpace(lastItem.ToDate) && ERPUtils.isNullorWhiteSpace(lastItem.institution)
			)
			) {
				setErrorMsg("Fill out the existing experience details to add more")
				setErrorPopup(true)
			} else {
				render.push({
					ExperienceType: '',
					functionalArea: '',
					EmpType: '',
					fromDate: '',
					ToDate: '',
					TotalYears: 0,
					TotalMonths: 0,
					designation: '',
					institution: '',
					OtherFunctionalArea: ''
				});
				setProfessionalDetails(render);
			}
		}
		if (name === 'ProfessionalDetails') {
			const render = [...userDetails.PrevExpDocuments];
			let stateName = 'PrevExpDocuments';
			render.push({
				Documents: []
			});
			setUserDetails({
				...userDetails,
				[stateName]: render
			});
		}
		if (name === 'ProfessionalDetails') {
			setFunctionalAreas(prev => {
				const newPrev = [...prev['PreviousFunctional'], []];
				return { ...prev, PreviousFunctional: newPrev };
			});
		}
		if (name === 'Education') {
			if (target === 'others') {
				let StateName = 'others';
				const render = [...userDetails.others];
				const lastItem = render[render.length - 1]
				if (!ERPUtils.isNullOrEmpty(render) && (ERPUtils.isNullorWhiteSpace(lastItem.otherQualification)
					&& ERPUtils.isNullorWhiteSpace(lastItem.otherStatus) && ERPUtils.isNullorWhiteSpace(lastItem.otherYearOfComp)
					&& ERPUtils.isNullorWhiteSpace(lastItem.otherCourse) && ERPUtils.isNullorWhiteSpace(lastItem.otherInstitute)
					&& ERPUtils.isNullorWhiteSpace(lastItem.otherBoard)
					// || ERPUtils.isNullorWhiteSpace(lastItem.otherPercentage)
				)
				) {
					setErrorMsg("Fill out the existing qualification details to add more ")
					setErrorPopup(true)
				} else {
					render.push({
						otherQualification: '',
						otherStatus: '',
						otherCourse: '',
						otherSpecialization: '',
						otherYearOfComp: '',
						otherPercentage: '',
						otherInstitute: '',
						otherBoard: '',
						othercountryId: '',
						otherstateId: '',
						otherstateOther: '',
						Documents: []
					});
					setUserDetails({
						...userDetails,
						[StateName]: render
					});
				}
			}
			else if (target === 'Eligibility') {
				let StateName = 'EligibilityTest';
				const render = [...userDetails.EligibilityTest];
				const lastItem = render[render.length - 1]
				if (!ERPUtils.isNullOrEmpty(render) && (ERPUtils.isNullorWhiteSpace(lastItem.EligibilityTestName)
					|| ERPUtils.isNullorWhiteSpace(lastItem.EligibilityYearOfComp)
				)
				) {
					setErrorMsg("Fill out the existing eligibility qualification details to add more ")
					setErrorPopup(true)
				} else {
					render.push({
						EligibilityTestName: '',
						EligibilityYearOfComp: '',
						Documents: []
					});
					setUserDetails({
						...userDetails,
						[StateName]: render
					});
				}
			}
			else if (isFromEducation) {
				let newState = { ...userDetails }
				const render = newState.EducationDetailsObj[target];
				const lastItem = render[render.length - 1]
				if (ERPUtils.isNullorWhiteSpace(lastItem.Qualification)
					&& ERPUtils.isNullorWhiteSpace(lastItem.countryId) && ERPUtils.isNullorWhiteSpace(lastItem.YearOfComp)
					&& (ERPUtils.isNullorWhiteSpace(lastItem.stateId) && ERPUtils.isNullorWhiteSpace(lastItem.stateOther))
					&& ERPUtils.isNullorWhiteSpace(lastItem.Board) && ERPUtils.isNullorWhiteSpace(lastItem.Institute)
					// || ERPUtils.isNullorWhiteSpace(lastItem.Percentage)
				) {
					setErrorMsg("Fill out the existing qualification details to add more ")
					setErrorPopup(true)
				} else {
					render.push({
						Qualification: '',
						Status: '',
						Course: '',
						Specialization: '',
						YearOfComp: '',
						Percentage: '',
						Institute: '',
						Board: '',
						countryId: '',
						stateId: '',
						stateOther: '',
						Documents: []
					});
					setUserDetails(newState);
				}
			}
		}
	};

	// To add the state for checking the required fields:
	const addRequiredFields = (name, target) => {
		const RenderErrors = { ...requiredFields };
		if (name === 'ProfessionalDetails') {
			let StateName = 'profReq';
			RenderErrors[StateName].push({
				otherFunctAreaReqError: false
			});
		}
		if (name === 'Education') {
			RenderErrors.eduReq = false
		}
		setRequiredFields(RenderErrors);
	};

	// Remove Handler To remove the state for checking the required fields:
	const removeRequiredFields = (id, name, target) => {
		const values = { ...requiredFields };
		if (name === 'ProfessionalDetails') {
			const stateName = 'profReq';
			values[stateName].splice(id, 1);
		}
		setRequiredFields(values, () => {
			RemoveReqTabStyling('');
		});
	};

	// Handler for add method states for only Professional details (To maintain the state of dynamically added states):
	const ProfessionalDetailsHandler = (event) => {
		setSaveTheData(true);
		const CombinedId = event.target.id;
		const i = CombinedId.charAt(0);
		let name = event.target.name;
		const values = [...professionalDetails];
		const modified = values[i];
		modified[name] = event.target.value;
		setProfessionalDetails(values);
		if (event.target.value !== null) {
			RemoveReqFieldErrors('otherFunctAreaReqError', 'prof', i);
		}
	};

	const ProfessionalDetailsDropDownHandler = (option, target, id) => {
		setSaveTheData(true);
		let name = target;
		let value = option;
		let i = id;
		const values = [...professionalDetails];
		const modified = values[i];
		if (name === 'functionalArea') {
			modified[name] = value;
			modified['OtherFunctionalArea'] = '';
		} else {
			modified[name] = value;
		}
		setProfessionalDetails(values);
		if (name === 'ExperienceType') {
			if (!ERPUtils.isNullorWhiteSpace(option)) {
				let url = 'Employee/CommonEmployee/getApplnSubjectCategory?isAcademic=';
				callApiWithPrevData(
					option.isExperienceTypeAcademic,
					url,
					'PreviousFunctionalArea',
					'PreviousFunctional',
					i
				);
			}
		}
		if (name === 'EmpType') {
			calculatePrevExperience(values[i].fromDate, values[i].ToDate, i, 'Professional');
		}
		if (option !== null && name === 'functionalArea') {
			RemoveReqFieldErrors('otherFunctAreaReqError', 'prof', i);
		}
	};

	const [orcidState, setOrcidState] = useState({
		openWindow: false,
		changedOrcidId: '',
		updateId: false
	});

	const loadOrcidData = () => {
		setLoaderActive(true);
		ApiGateway.getOrcidData(userDetails.orcidId, (response) => {
			try {
				if (response.status === 'SUCCESS') {
					let oldData = { ...orcidState };
					oldData['openWindow'] = true;
					oldData['changedOrcidId'] = userDetails.orcidId;
					oldData['updateId'] = true;
					setOrcidState(oldData);
					setLoaderActive(false);
				} else {
					setErrorMsg('Invalid ORCID');
					AlertError();
					setLoaderActive(false);
				}
			} catch (ex) {
				setLoaderActive(false);
			}
		});
	};

	const closeWindowPortal = () => {
		let oldData = { ...orcidState };
		oldData['openWindow'] = false;
		setOrcidState(oldData);
	};
	const updateId = () => {
		let oldData = { ...orcidState };
		oldData['updateId'] = false;
		setOrcidState(oldData);
	};

	// change handler for from inputs state management:
	const onChangeHandler = async (event, isIndian) => {
		setSaveTheData(true);
		const oldData = { ...userDetails };
		const val = event.target.value;
		const name = event.target.name;
		const pattern = '^[0-9]*$';
		let result = "";
		// if (name === "permanentPincode" || name === "currentPincode") {
		// 	if (isIndian) {
		// 		result = event.target.value === '' ? '' : val.match(pattern)
		// 	} else result = event.target.value === '' ? '' : event.target.value

		// } else {
		// 	result = event.target.value === '' ? '' : val.match(pattern)
		// };
		if (
			name === 'mobileNo' ||
			name === 'AltNo' ||
			name === 'AadharNo' ||
			// name === 'expSalary' ||
			// name === 'vidwanId' ||
			// name === 'scopusPaperNumber' ||
			// name === 'hIndex' ||
			name === 'InterviewedApplNo' ||
			name === 'InterviewedYear'
			// name === 'currentSalary'
		) {
			if (result !== null) {
				oldData[name] = val;
				ValidationErrorHandler(
					name,
					false,
					''
				);
			} else {
				ValidationErrorHandler(name, true, false);
			}
		} else if (name === 'expSalary' || name === 'currentSalary') {
			let decimalCheck = /^[0-9]{1,12}([.][0-9]{0,2}|)$/;
			const validDec = val === '' ? '' : val.match(decimalCheck);
			if (validDec !== null) {
				oldData[name] = val;
				ValidationErrorHandler(name, false);
			} else {
				ValidationErrorHandler(name, true);
			}
		} else if (name === 'Email') {
			// eslint-disable-next-line
			// const EmailCheck = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
			// const validEmail = val === '' ? '' : val.match(EmailCheck);
			// if (validEmail !== null) {
			oldData[name] = val;
			// ValidationErrorHandler(name, false);
			// } else {
			// 	oldData[name] = val;
			// 	ValidationErrorHandler(name, true);
			// }
		} else if (name === 'OtherInformation') {
			setAddInfoEnteredVal(val.length);
			oldData[name] = val;
		} else if (name === 'majorAchievements') {
			setAddEnteredValue(val.length);
			oldData[name] = val;
		}
		else if (name === 'currentWorking') {
			if (val === 'No') {
				oldData['currentExperienceType'] = '';
				oldData['currentFunctionalArea'] = '';
				oldData['currentOtherFunctionalArea'] = '';
				oldData['currentEmpType'] = '';
				oldData['currentFromDate'] = '';
				oldData['currentTotalYears'] = '';
				oldData['currentTotalMonths'] = '';
				oldData['currentDesignation'] = '';
				oldData['currentSalary'] = '';
				oldData['currentNoticePeriod'] = '';
				oldData['currentInstitute'] = '';
				oldData['CurrentExpDocuments'] = [];
				oldData[name] = val;
				let stateName = 'CurrentFunctional';
				setFunctionalAreas({
					...functionalAreas,
					[stateName]: []
				});
				CalculateTotalExp(0, 0, '', 'CurrRemove', '', '', '', '', oldData);
			} else {
				oldData[name] = val;
			}
		} else if (name === 'currentPincode') {
			const pattern = '^[0-9]*$';
			setCurrentCities([]);
			let result = isIndian ? val.match(pattern) : val;
			if (userDetails.curAddSameAsPer === 'Yes') {
				oldData["permanentState"] = ""
				oldData["otherPermState"] = ""
				oldData["permanentCity"] = ""
				oldData["otherPermCity"] = ""
				oldData["currentState"] = ""
				oldData["otherCurrState"] = ""
				oldData["currentCity"] = ""
				oldData["otherCurrCity"] = ""
				let name1 = 'currentPincode';
				let name2 = 'permanentPincode';
				if (result !== null) {
					if (isIndian && result[0].length <= 6) {
						oldData[name1] = val;
						oldData[name2] = val;
					} else if (!isIndian) {
						oldData[name1] = val;
						oldData[name2] = val;
					}
					// else if (!isIndian) oldData[name1] = val;

					// if (isIndian && result[0].length <= 6) oldData[name2] = val;
					// else if (!isIndian) oldData[name2] = val;

					if (isIndian && (oldData[name1].length < 6 || oldData[name1].length > 6)) {
						oldData["currentState"] = "";
						oldData["currentCity"] = "";
						oldData["permanentState"] = "";
						oldData["permanentCity"] = "";
					}
					ValidationErrorHandler(name, false, isIndian ? ((oldData[name1].length < 6 || oldData[name1].length > 6) ? true : false) : false);
				} else {
					ValidationErrorHandler(name, true, isIndian ? ((oldData[name1].length < 6 || oldData[name1].length > 6) ? true : false) : false);
				}
			} else {
				oldData["currentState"] = ""
				oldData["otherCurrState"] = ""
				oldData["currentCity"] = ""
				oldData["otherCurrCity"] = ""
				if (result !== null) {
					if (isIndian && result[0].length <= 6) oldData[name] = val;
					else if (!isIndian) oldData[name] = val;
					ValidationErrorHandler(name, false, isIndian ? ((oldData[name].length < 6 || oldData[name].length > 6) ? true : false) : false);
				} else {
					ValidationErrorHandler(name, true, isIndian ? ((oldData[name].length < 6 || oldData[name].length > 6) ? true : false) : false);
				}
				if (isIndian && (oldData[name].length < 6)) {
					oldData["currentState"] = "";
					oldData["currentCity"] = "";
				}
			}
		}
		else if (name === 'permanentPincode') {
			setPermanentCities([])
			// const pattern = '^[0-9]*$';
			let result = isIndian ? val.match(pattern) : val;
			oldData["permanentState"] = ""
			oldData["otherPermState"] = ""
			oldData["permanentCity"] = ""
			oldData["otherPermCity"] = ""
			if (result !== null) {
				if (isIndian && result[0].length <= 6) oldData[name] = val;
				else if (!isIndian) oldData[name] = val;
				ValidationErrorHandler(name, false, isIndian ? ((oldData[name].length < 6 || oldData[name].length > 6) ? true : false) : false);
			} else {
				ValidationErrorHandler(name, true, isIndian ? ((oldData[name].length < 6 || oldData[name].length > 6) ? true : false) : false);
			}
			if (isIndian && (oldData[name].length < 6 || oldData[name].length > 6)) {
				oldData["permanentState"] = "";
				oldData["permanentCity"] = "";
			}
		}
		else if (name === 'currentLine2') {
			if (userDetails.curAddSameAsPer === 'Yes') {
				let name1 = 'currentLine2';
				let name2 = 'permanentLine2';
				oldData[name1] = val;
				oldData[name2] = val;
			} else {
				oldData[name] = val;
			}
		} else if (name === 'currentLine1') {
			if (userDetails.curAddSameAsPer === 'Yes') {
				let name1 = 'currentLine1';
				let name2 = 'permanentLine1';
				oldData[name1] = val;
				oldData[name2] = val;
			} else {
				oldData[name] = val;
			}
		} else if (name === 'otherCurrState') {
			//let result = event.target.value
			if (userDetails.curAddSameAsPer === 'Yes') {
				let name1 = 'otherCurrState';
				let name2 = 'otherPermState';
				oldData[name1] = val;
				oldData[name2] = val;
			} else {
				oldData[name] = val;
			}
		} else if (name === 'otherCurrCity') {
			if (userDetails.curAddSameAsPer === 'Yes') {
				let name1 = 'otherCurrCity';
				let name2 = 'otherPermCity';
				oldData[name1] = val;
				oldData[name2] = val;
			} else {
				oldData[name] = val;
			}
		} else if (name === 'orcidId' || name === 'vidwanId' || name === 'scopusPaperNumber' || name === 'hIndex') {
			let pattern = name === 'hIndex' ? /^\d+$/ : /^[0-9-aA-zZ]+$/;
			let result = event.target.value === '' ? '' : val.match(pattern);
			if (result !== null) {
				if (name === "orcidId") {
					const inputValue = val.replace(/\D/g, ''); // Remove non-digit characters
					const formatted = inputValue.replace(/(\d{4})(?=\d)/g, '$1-'); // Add hyphens every 4 digits
					oldData[name] = formatted;
				} else {
					oldData[name] = val;
				}
				ValidationErrorHandler(name, false);
			} else {
				ValidationErrorHandler(name, true);
			}
		} else if (name === 'Name') {
			let UpperCaseValue = String(val).toUpperCase();
			oldData[name] = UpperCaseValue;
		}
		else {
			oldData[name] = val;
		}

		setUserDetails(oldData);
		if (name === 'currentPincode' || name === 'permanentPincode') {
			const pattern = '^[0-9]*$';
			let result = event.target.value === '' ? '' : isIndian ? val.match(pattern) : val;
			if (ERPUtils.isNullorWhiteSpace(result) === false) {
				if (isIndian) {
					if (result[0].length === 6) {
						callPincodeApi(val, name);
					}
				} else {
					// callPincodeApi(val, name);
				}
			}
		}
		if (val !== null) {
			let targetName = name;
			// name === 'otherCurrState'
			// 	? 'currentState'
			// 	: name === 'otherCurrCity'
			// 		? 'currentCity'
			// 		: name === 'otherPermState'
			// 			? 'permanentState'
			// 			: name === 'otherPermCity' ? 'permanentCity' : name;
			RemoveReqFieldErrors(targetName, '', '', userDetails.curAddSameAsPer === 'Yes');
		}
		if (val !== null && name === 'currentWorking') {
			RemoveReqFieldErrors('currentWorking', '', '');
		}
	};

	const checkDecimal = (event) => {
		const oldData = { ...userDetails };
		const name = event.target.name;
		const val = event.target.value;
		let check = val.split('.');
		if (check.length >= 1) {
			if (check[1] !== undefined) {
				if (check[1].length < 1) {
					oldData[name] = check[0];
					setUserDetails(oldData);
				}
			} else {
				oldData[name] = check[0];
				setUserDetails(oldData);
			}
		}
	};

	const getCityandStateFromPincode = (Pincode, name, resData, SaveData) => {
		setLoaderActive(true);
		ApiGateway.post('Common/getPincodeDetailsOrValidate?pincode=' + Pincode + "&isPincodeList=" + false, {}, (response) => {
			try {
				if (ERPUtils.isUndefinedOrNull(response) === true || ERPUtils.isUndefinedOrNull(response?.data) === true) {
					toast.warn("Couldn't find city and state for the selected pincode.")
					setLoaderActive(false);
				} else {
					let pincodeData = response.data;
					// oldData[name] = Pincode
					if (pincodeData?.length > 0) {
						let citiesArrays = [];
						for (let index = 0; index < pincodeData.length; index++) {
							citiesArrays.push({
								value: pincodeData[index]?.id,
								label: pincodeData[index]?.cityName,
								stateDto: pincodeData[index].erpStateDTO
							})
						}
						if (name === 'currentPincode') {
							setCurrentCities(citiesArrays);
						}
						if (name === 'permanentPincode') {
							setPermanentCities(citiesArrays)
						}
						setLoaderActive(false);
					}
					if (pincodeData?.length === 1) {
						if (name === 'currentPincode') {
							resData.addressDetailDTO.currentCity = {
								value: pincodeData[0]?.id,
								label: pincodeData[0]?.cityName
							};
							resData.addressDetailDTO["currentState"] = pincodeData[0]?.erpStateDTO;
							if (resData.addressDetailDTO.isPermanentEqualsCurrent === "Yes") {
								resData.addressDetailDTO["permanentCity"] = {
									value: pincodeData[0]?.id,
									label: pincodeData[0]?.cityName
								};
								resData.addressDetailDTO["permanentState"] = pincodeData[0].erpStateDTO;
							}
						}
						if (name === 'permanentPincode') {
							resData.addressDetailDTO["permanentCity"] = {
								value: pincodeData[0]?.id,
								label: pincodeData[0]?.cityName
							};
							resData.addressDetailDTO["permanentState"] = pincodeData[0].erpStateDTO;
						}
						setLoaderActive(false);
					}
				}
			} catch (ex) {
				setLoaderActive(false);
			}
			return resData.addressDetailDTO
		});
	}

	const callPincodeApi = (Pincode, name) => {
		let typeFlag = ""
		setLoaderActive(true);
		ApiGateway.post('Common/getPincodeDetailsOrValidate?pincode=' + Pincode + "&isPincodeList=" + false, {}, (response) => {
			try {
				const oldData = { ...userDetails };
				setLoaderActive(false);
				if (ERPUtils.isUndefinedOrNull(response) === true || ERPUtils.isUndefinedOrNull(response?.data) === true) {
					oldData[name] = '';
					setWrongPincode(true, () => {
						setUserDetails(oldData);
					});
				} else {
					let pincodeData = response.data;
					// oldData[name] = Pincode
					if (pincodeData?.length > 1) {
						let citiesArrays = [];
						for (let index = 0; index < pincodeData.length; index++) {
							citiesArrays.push({
								value: pincodeData[index]?.id,
								label: pincodeData[index]?.cityName,
								stateDto: pincodeData[index].erpStateDTO
							})
						}
						if (name === 'currentPincode') {
							setCurrentCities(citiesArrays);
						}
						if (name === 'permanentPincode') {
							setPermanentCities(citiesArrays)
						}
					}
					if (pincodeData?.length === 1) {
						if (name === 'currentPincode') {
							oldData["currentCity"] = {
								value: pincodeData[0]?.id,
								label: pincodeData[0]?.cityName
							};
							oldData["currentState"] = pincodeData[0]?.erpStateDTO;
							typeFlag = "currentCityAndState"
							if (oldData.curAddSameAsPer === "Yes") {
								oldData["permanentCity"] = {
									value: pincodeData[0]?.id,
									label: pincodeData[0]?.cityName
								};
								oldData["permanentState"] = pincodeData[0]?.erpStateDTO;
								oldData["permanentPincode"] = Pincode;
								typeFlag = "CurAddSameAsPerAdd"
							}
						}
						if (name === 'permanentPincode') {
							oldData["permanentCity"] = {
								value: pincodeData[0]?.id,
								label: pincodeData[0]?.cityName
							};
							oldData["permanentState"] = pincodeData[0].erpStateDTO;
							typeFlag = "permanentCityAndState"
						}
					}
					oldData[name] = Pincode;
					setUserDetails(oldData, () =>
						RemoveReqFieldErrors(typeFlag)
					);
				}
			} catch (ex) {
				setLoaderActive(false);
			}
		});
	};

	// Handler for Date and Time:
	const DateChangeHandler = (date, target, id, stateName) => {
		setSaveTheData(true);
		let name = target;
		let i = id;
		let selected = date;
		if (stateName === 'Professional') {
			const values = [...professionalDetails];
			const modified = values[i];
			if (ERPUtils.isUndefinedOrNull(modified?.EmpType) || ERPUtils.isNullorWhiteSpace(modified?.EmpType)) {
				setEmpTypeAlert(true)
			} else {
				modified[name] = selected;
				setProfessionalDetails(values, () => {
					if (name === 'fromDate' || name === 'ToDate') {
						calculatePrevExperience(values[i].fromDate, values[i].ToDate, i, 'Professional');
					}
				});
			}
		}
		if (stateName === 'currentExp') {
			calculateCurrExperience(selected, userDetails.currentToDate, i, 'currentExp');
		}
		if (stateName === 'Personal') {
			setUserDetails({
				...userDetails,
				[name]: selected
			});
		}
		if (selected !== null) {
			RemoveReqFieldErrors(name, stateName, i);
		}
	};

	// method for calc the total years for individual experience:
	const calculatePrevExperience = (date1, date2, id, status) => {
		const values = [...professionalDetails];
		const modified = values[id];
		let name1 = 'TotalYears';
		let name2 = 'TotalMonths';
		if (date1 && date2 !== null && date1 && date2 !== '') {
			let startDate = new Date(date1);
			let diffDate = new Date(new Date(date2) - startDate);
			let years = diffDate.toISOString().slice(0, 4) - 1970;
			let months = diffDate.getMonth();
			modified[name1] = years;
			modified[name2] = months;
			setProfessionalDetails(values, () => {
				CalculateTotalExp(years, months, id, 'ADD', status, '', '', 'previous');
			});
		} else {
			modified[name1] = 0;
			modified[name2] = 0;
			CalculateTotalExp(0, 0, id, 'ADD', status, '', '', 'previous');
		}
	};

	const calculateCurrExperience = (date1, date2, id, status) => {
		if (date1 && date2 !== null && date1 && date2 !== '') {
			let startDate = new Date(date1);
			let diffDate = new Date(new Date(date2) - startDate);
			let years = diffDate.toISOString().slice(0, 4) - 1970;
			let months = diffDate.getMonth();
			CalculateTotalExp(years, months, id, '', status, date1, date2, 'current');
		}
	};

	// CalculateTotalExp(0, 0, '', 'CurrRemove');
	// Handler for calculating overall Total Exp (including all the previous experiences):
	const CalculateTotalExp = (y, m, id, type, status, date1, date2, target, state) => {
		let prevFullTimeYears = [];
		let PrevFullTimeMonths = [];
		let PrevPartTimeYears = [];
		let PrevPartTimeMonths = [];

		let name1 = 'TotalFullTimeYearsExp';
		let name2 = 'TotalFullTimeMonthsExp';
		let name3 = 'TotalPartTimeYearsExp';
		let name4 = 'TotalPartTimeMonthsExp';

		let z = professionalDetails.length;
		if (z >= 1) {
			for (let j = 0; j < z; j++) {
				if (professionalDetails[j]?.EmpType?.label === 'Full-time') {
					prevFullTimeYears[j] = professionalDetails[j]?.TotalYears;
					PrevFullTimeMonths[j] = professionalDetails[j]?.TotalMonths;
				}
				if (professionalDetails[j].EmpType?.label === 'Part-time') {
					PrevPartTimeYears[j] = professionalDetails[j].TotalYears;
					PrevPartTimeMonths[j] = professionalDetails[j].TotalMonths;
				}
			}
		}
		if (userDetails?.currentEmpType?.label !== '' && type !== 'CurrRemove' && target === 'current') {
			if (userDetails.currentEmpType.label === 'Full-time') {
				prevFullTimeYears.push(y);
				PrevFullTimeMonths.push(m);
			}
			if (userDetails?.currentEmpType?.label === 'Part-time') {
				PrevPartTimeYears.push(y);
				PrevPartTimeMonths.push(m);
			}
		} else if (userDetails.currentEmpType.label !== '' && type !== 'CurrRemove') {
			if (userDetails.currentEmpType.label === 'Full-time') {
				prevFullTimeYears.push(userDetails.currentTotalYears);
				PrevFullTimeMonths.push(userDetails.currentTotalMonths);
			}
			if (userDetails.currentEmpType.label === 'Part-time') {
				PrevPartTimeYears.push(userDetails.currentTotalYears);
				PrevPartTimeMonths.push(userDetails.currentTotalMonths);
			}
		} else {
			if (userDetails.currentEmpType.label === 'Full-time') {
				prevFullTimeYears.push(0);
				PrevFullTimeMonths.push(0);
			}
			if (userDetails.currentEmpType.label === 'Part-time') {
				PrevPartTimeYears.push(0);
				PrevPartTimeMonths.push(0);
			}
		}

		const fullTimeYears = [...prevFullTimeYears];
		const fullTimeMonths = [...PrevFullTimeMonths];
		const PartTimeYears = [...PrevPartTimeYears];
		const PartTimeMonths = [...PrevPartTimeMonths];

		let totalFullTimeYears = 0;
		let totalFullTimeMonths = 0;
		let totalPartTimeYears = 0;
		let totalPartTimeMonths = 0;

		if (id !== (null || '')) {
			if (type === 'ADD') {
				if (professionalDetails[id].EmpType.label === 'Full-time') {
					fullTimeYears[id] = y;
					fullTimeMonths[id] = m;
				}
				if (professionalDetails[id].EmpType.label === 'Part-time') {
					PartTimeYears[id] = y;
					PartTimeMonths[id] = m;
				}
			}
			if (type === 'REMOVE') {
				if (professionalDetails[id].EmpType.label === 'Full-time') {
					fullTimeYears.splice(id, 1);
					fullTimeMonths.splice(id, 1);
				}
				if (professionalDetails[id].EmpType.label === 'Part-time') {
					PartTimeYears.splice(id, 1);
					PartTimeMonths.splice(id, 1);
				}
			}
		}

		fullTimeYears.map((el) => {
			if (el !== (undefined && null)) {
				return (totalFullTimeYears = totalFullTimeYears + parseInt(el));
			}
			return '';
		});

		fullTimeMonths.map((el) => {
			if (el !== (undefined && null)) {
				return (totalFullTimeMonths = totalFullTimeMonths + parseInt(el));
			}
			return '';
		});

		PartTimeYears.map((el) => {
			if (el !== (undefined && null)) {
				totalPartTimeYears = totalPartTimeYears + parseInt(el);
			}
			return '';
		});

		PartTimeMonths.map((el) => {
			if (el !== (undefined && null)) {
				totalPartTimeMonths = totalPartTimeMonths + parseInt(el);
			}
			return '';
		});

		let i = 0;
		while (i < 1) {
			if (totalFullTimeMonths >= 12) {
				let newFullTimeMonths = totalFullTimeMonths - 12;
				totalFullTimeYears++;
				totalFullTimeMonths = newFullTimeMonths;
			} else {
				i++;
			}
		}
		let k = 0;
		while (k < 1) {
			if (totalPartTimeMonths >= 12) {
				let newPartTimeMonths = totalPartTimeMonths - 12;
				totalPartTimeYears++;
				totalPartTimeMonths = newPartTimeMonths;
			} else {
				k++;
			}
		}



		if (type === 'CurrRemove') {
			// const oldData = { ...userDetails };
			state['currentExperienceType'] = '';
			state['currentFunctionalArea'] = '';
			state['currentOtherFunctionalArea'] = '';
			state['currentEmpType'] = '';
			state['currentFromDate'] = '';
			state['currentTotalYears'] = '';
			state['currentTotalMonths'] = '';
			state['currentDesignation'] = '';
			state['currentSalary'] = '';
			state['currentNoticePeriod'] = '';
			state['currentInstitute'] = '';
			state['CurrentExpDocuments'] = [];
			state['currentWorking'] = 'No';
			state['TotalFullTimeYearsExp'] = totalFullTimeYears;
			state['TotalFullTimeMonthsExp'] = totalFullTimeMonths;
			state['TotalPartTimeYearsExp'] = totalPartTimeYears;
			state['TotalPartTimeMonthsExp'] = totalPartTimeMonths;
			// setUserDetails(oldData);
			// setUserDetails({
			// 	...userDetails,
			// 	[name1]: totalFullTimeYears,
			// 	[name2]: totalFullTimeMonths,
			// 	[name3]: totalPartTimeYears,
			// 	[name4]: totalPartTimeMonths,
			// 	currentExperienceType: '',
			// 	currentFunctionalArea: '',
			// 	currentOtherFunctionalArea: '',
			// 	currentEmpType: '',
			// 	currentFromDate: '',
			// 	currentTotalYears: 0,
			// 	currentTotalMonths: 0,
			// 	currentDesignation: '',
			// 	currentInstitute: '',
			// 	currentWorking: 'No'
			// });
		}
		if (target === 'current') {
			let CurrentFromDate = 'currentFromDate';
			let nameYears = 'currentTotalYears';
			let nameMonths = 'currentTotalMonths';

			setUserDetails({
				...userDetails,
				[CurrentFromDate]: date1,
				[nameYears]: y,
				[nameMonths]: m,
				[name1]: totalFullTimeYears,
				[name2]: totalFullTimeMonths,
				[name3]: totalPartTimeYears,
				[name4]: totalPartTimeMonths
			});
		}

		if (target === 'previous') {
			setUserDetails({
				...userDetails,
				[name1]: totalFullTimeYears,
				[name2]: totalFullTimeMonths,
				[name3]: totalPartTimeYears,
				[name4]: totalPartTimeMonths
			});
		}
	};

	// Handler for active tab component (To Active the selected tab):
	const handleRenderComp = (val) => {
		// const val = ERPUtils.isUndefinedOrNull(event.target.name) ? event.currentTarget.name : event.target.name;
		if (!ERPUtils.isUndefinedOrNull(val)) {
			let newobj = {};
			Object.keys(renderComp).map((el) => {
				if (el === val) {
					newobj[el] = true;
				} else {
					newobj[el] = false;
				}
				return '';
			});
			setRenderComp(newobj);
			AddClass(val);
			topFunction();
			closeDropDown();
			if (saveTheData) {
				saveDraft();
			}
		}
		return '';
	};

	const AddClass = (name) => {
		let load = document.getElementsByClassName('active')[0];
		if (load !== undefined) {
			load.classList.remove('active');
		}
		document.getElementsByName(name)[0].classList.add('active');
	};

	// Handler when user clicks on the nav-icons:
	const IconClick = (event) => {
		event.stopPropagation();
		const val = event.target.title;
		let newobj = {};
		Object.keys(renderComp).map((el) => {
			if (el === val) {
				newobj[el] = true;
			} else {
				newobj[el] = false;
			}
			return '';
		});
		setRenderComp(newobj);
		AddClass(val);
		topFunction();
		closeDropDown();
		return '';
	};

	// To close the burger icon dropdown on select for mobile view:
	const closeDropDown = () => {
		let selected = document.getElementById('collapsibleNavbar');
		let changeClass = document.getElementById('burgerBtn');
		selected.className = 'collapse navbar-collapse';
		changeClass.className = 'navbar-toggler BurgerIcon collapsed';
		return '';
	};

	// To display the Top and down buttons for scroll:
	// window.onscroll = function () {
	// 	scrollTopFunction();
	// 	scrollBottomFunction();
	// 	navFix();
	// };

	//FUNCTION TO NAVIGATE INSIDE PAGE -SCROLL
	const scrollHandler = () => {
		scrollTopFunction();
		scrollBottomFunction();
		navFix();
	}

	// Function for scrolling to top:
	const scrollTopFunction = () => {
		let myButton = document.getElementById('myBtnUp');
		let formContainer = document.getElementById("APP-FORM")
		if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20 || formContainer.scrollTop > 20) {
			return myButton !== null ? (myButton.style.display = 'block') : null;
		} else {
			return myButton !== null ? (myButton.style.display = 'none') : null;
		}
	};

	// Function for scrolling to Bottom:
	const scrollBottomFunction = () => {
		let myButton = document.getElementById('myBtnDown');
		let formContainer = document.getElementById("APP-FORM")
		if (formContainer.scrollTop > 20) {
			return myButton !== null ? (myButton.style.display = 'block') : null;
		} else {
			return myButton !== null ? (myButton.style.display = 'none') : null;
		}
	};

	// Function to fix the navbar to top after scroll:
	const navFix = () => {
		let myButton = document.getElementsByClassName('navbar');
		if (document.body.scrollTop > 280 || document.documentElement.scrollTop > 280) {
			return myButton.length > 0 ? myButton[0].classList.add('sticky') : null;
		} else {
			return myButton.length > 0 ? myButton[0].classList.remove('sticky') : null;
		}
	};

	// To bring the page to top on load:
	const topFunction = () => {
		setTimeout(() => {
			// window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
			var myDiv = document?.getElementById('APP-FORM');
			myDiv.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
		}, 10);
		return '';
	};

	// To bring the page to bottom on load:
	function scrollToBottom() {
		// window.scrollTo(0, document.body.scrollHeight);
		var myDiv = document.getElementById('APP-FORM');
		myDiv.scrollTo(0, myDiv.scrollHeight)
		return '';
	}

	const CheckRequired = () => {
		const checkThese = [
			'Post',
			'empApplnCampusPrefDTOList1',
			'jobCategoryDTO',
			'Subject',
			'Name',
			'Gender',
			'DOB',
			'mobileNo',
			'CountryCode',
			'Email',
			// 'AadharNo',
			'marital',
			'Nationality',
			'Religion',
			'Reservation',
			'currentLine1',
			'currentCountry',
			'currentState',
			'currentCity',
			'otherCurrState',
			'otherCurrCity',
			'currentPincode',
			'permanentLine1',
			'permanentCountry',
			'permanentState',
			'permanentCity',
			'permanentPincode',
			'otherPermState',
			'otherPermCity',
			'currentWorking',
			'expSalary',
			//'orcidId',
			'PassportNo'
		];
		// const EducationCheck = [
		// 	'Status',
		// 	'Course',
		// 	// 'Specialization',
		// 	"countryId",
		// 	"stateId",
		// 	"stateOther",
		// 	'YearOfComp',
		// 	'Percentage',
		// 	'Institute',
		// 	'Board'
		// ];

		const currentWorkingChecks = [
			'currentExperienceType',
			'currentFunctionalArea',
			'currentEmpType',
			'currentDesignation',
			'currentFromDate',
			'currentNoticePeriod',
			// 'currentSalary', REMOVED AS R10 HOT FIX
			'currentInstitute'
		];

		const ReqErrors = { ...requiredFields };
		const PostReqErrors = {
			category: ReqErrorOnPostSelect.categoryReqError,
			Subject: ReqErrorOnPostSelect.SubjectReqError,
			Specialization: ReqErrorOnPostSelect.SpecializationReqError
			// PassportNo: ReqErrorOnPostSelect.PassportNoReqError
		};

		checkThese.map((el) => {
			// if (el === 'orcidId') {
			// 	// if (userDetails.ResearchExperience === 'Yes' && userDetails.Post.isEmployeeCategoryAcademic) {
			// 	// 	if (
			// 	// 		ERPUtils.isUndefinedOrNull(userDetails[el]) === true ||
			// 	// 		ERPUtils.isNullOrEmpty(userDetails[el]) === true ||
			// 	// 		ERPUtils.isNullorWhiteSpace(userDetails[el]) === true
			// 	// 	) {
			// 	// 		let name = el + 'ReqError';
			// 	// 		ReqErrors.commonErrors[0][name] = true;
			// 	// 	} else {
			// 	// 		let name = el + 'ReqError';
			// 	// 		ReqErrors.commonErrors[0][name] = false;
			// 	// 	}
			// 	// }
			// } 
			// else
			if (el === 'PassportNo') {
				if (ERPUtils.isNullorWhiteSpace(userDetails.Nationality) === false) {
					if (isPassportRequired) {
						let name = el + 'ReqError';
						ReqErrors.commonErrors[0][name] = false;
					} else {
						if (
							ERPUtils.isUndefinedOrNull(userDetails[el]) === true ||
							ERPUtils.isNullOrEmpty(userDetails[el]) === true ||
							ERPUtils.isNullorWhiteSpace(userDetails[el]) === true
						) {
							let name = el + 'ReqError';
							ReqErrors.commonErrors[0][name] = true;
						} else {
							let name = el + 'ReqError';
							ReqErrors.commonErrors[0][name] = false;
						}
					}
				}
			} else if (el === 'currentState' || el === 'currentCity') {
				if (userDetails["currentCountry"].nationality === "Indian") {
					if (
						ERPUtils.isUndefinedOrNull(userDetails[el]) === true ||
						ERPUtils.isNullOrEmpty(userDetails[el]) === true ||
						ERPUtils.isNullorWhiteSpace(userDetails[el]) === true
					) {
						let name = el + 'ReqError';
						ReqErrors.commonErrors[0][name] = true;
					} else {
						let name = el + 'ReqError';
						ReqErrors.commonErrors[0][name] = false;
					}
				}
			}
			else if (el === 'permanentState' || el === 'permanentCity') {
				if (userDetails["permanentCountry"].nationality === "Indian") {
					if (
						ERPUtils.isUndefinedOrNull(userDetails[el]) === true ||
						ERPUtils.isNullOrEmpty(userDetails[el]) === true ||
						ERPUtils.isNullorWhiteSpace(userDetails[el]) === true
					) {
						let name = el + 'ReqError';
						ReqErrors.commonErrors[0][name] = true;
					} else {
						let name = el + 'ReqError';
						ReqErrors.commonErrors[0][name] = false;
					}
				}
			} else if (el === 'otherCurrState' || el === 'otherCurrCity') {
				if (userDetails["currentCountry"].nationality !== "Indian") {
					if (
						ERPUtils.isUndefinedOrNull(userDetails[el]) === true ||
						ERPUtils.isNullOrEmpty(userDetails[el]) === true ||
						ERPUtils.isNullorWhiteSpace(userDetails[el]) === true
					) {
						let name = el + 'ReqError';
						ReqErrors.commonErrors[0][name] = true;
					} else {
						let name = el + 'ReqError';
						ReqErrors.commonErrors[0][name] = false;
					}
				}
			} else if (el === 'otherPermState' || el === 'otherPermCity') {
				if (userDetails["permanentCountry"].nationality !== "Indian") {
					if (
						ERPUtils.isUndefinedOrNull(userDetails[el]) === true ||
						ERPUtils.isNullOrEmpty(userDetails[el]) === true ||
						ERPUtils.isNullorWhiteSpace(userDetails[el]) === true
					) {
						let name = el + 'ReqError';
						ReqErrors.commonErrors[0][name] = true;
					} else {
						let name = el + 'ReqError';
						ReqErrors.commonErrors[0][name] = false;
					}
				}
			} else if (el === 'CountryCode') {
				let name = el + 'ReqError';
				if (
					ERPUtils.isUndefinedOrNull(userDetails[el]) === true ||
					ERPUtils.isNullOrEmpty(userDetails[el]) === true ||
					ERPUtils.isNullorWhiteSpace(userDetails[el]) === true
				) {
					ReqErrors.commonErrors[0][name] = true
				} else {
					ReqErrors.commonErrors[0][name] = false;
				}
			} else if (el === 'mobileNo') {
				if (
					ERPUtils.isUndefinedOrNull(userDetails[el]) === true ||
					ERPUtils.isNullOrEmpty(userDetails[el]) === true ||
					ERPUtils.isNullorWhiteSpace(userDetails[el]) === true
				) {
					let name = el + 'ReqError';
					ReqErrors.commonErrors[0][name] = true;
				} else {
					let name = el + 'ReqError';
					if (userDetails?.CountryCode?.value === '91') {
						if (userDetails[el].length !== 10) {
							ReqErrors.commonErrors[0][name] = true;
						} else {
							ReqErrors.commonErrors[0][name] = false;
						}
					} else {
						ReqErrors.commonErrors[0][name] = false;
					}
				}
			}
			else if (el === 'AadharNo') {
				// if (
				// 	ERPUtils.isUndefinedOrNull(userDetails[el]) === true ||
				// 	ERPUtils.isNullOrEmpty(userDetails[el]) === true ||
				// 	ERPUtils.isNullorWhiteSpace(userDetails[el]) === true
				// )
				// //  {
				// // 	let name = el + 'ReqError';
				// // 	ReqErrors.commonErrors[0][name] = false;
				// // } else 
				// {
				// 	let name = el + 'ReqError';
				// 	if (userDetails[el].length !== 12) {
				// 		ReqErrors.commonErrors[0][name] = true;
				// 	} else {
				// 		ReqErrors.commonErrors[0][name] = false;
				// 	}
				// }

			} else if (el === "Email") {
				// eslint-disable-next-line
				const EmailCheck = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
				if (
					ERPUtils.isUndefinedOrNull(userDetails[el]) === true ||
					ERPUtils.isNullOrEmpty(userDetails[el]) === true ||
					ERPUtils.isNullorWhiteSpace(userDetails[el]) === true ||
					ValidationError.EmailError ||
					userDetails[el].match(EmailCheck) === null
				) {
					let name = el + 'ReqError';
					ReqErrors.commonErrors[0][name] = true;
				} else {
					let name = el + 'ReqError';
					ReqErrors.commonErrors[0][name] = false;
				}
			} else if (el === "jobCategoryDTO") {
				if (!ERPUtils.isNullOrEmpty(jobCategory)) {
					if (
						ERPUtils.isUndefinedOrNull(userDetails[el]) === true ||
						ERPUtils.isNullOrEmpty(userDetails[el]) === true ||
						ERPUtils.isNullorWhiteSpace(userDetails[el]) === true
					) {
						let name = el + 'ReqError';
						ReqErrors.commonErrors[0][name] = true;
					} else {
						let name = el + 'ReqError';
						ReqErrors.commonErrors[0][name] = false;
					}
				} else {
					let name = el + 'ReqError';
					ReqErrors.commonErrors[0][name] = false;
				}
			}
			else if (el === "Subject") {
				if (userDetails.Post.isEmployeeCategoryAcademic) {
					if (
						ERPUtils.isUndefinedOrNull(userDetails[el]) === true ||
						ERPUtils.isNullOrEmpty(userDetails[el]) === true ||
						ERPUtils.isNullorWhiteSpace(userDetails[el]) === true
					) {
						let name = el + 'ReqError';
						ReqErrors.commonErrors[0][name] = true;
					} else {
						let name = el + 'ReqError';
						ReqErrors.commonErrors[0][name] = false;
					}
				} else {
					let name = el + 'ReqError';
					ReqErrors.commonErrors[0][name] = false;
				}
			}
			else {
				if (
					ERPUtils.isUndefinedOrNull(userDetails[el]) === true ||
					ERPUtils.isNullOrEmpty(userDetails[el]) === true ||
					ERPUtils.isNullorWhiteSpace(userDetails[el]) === true
				) {
					let name = el + 'ReqError';

					ReqErrors.commonErrors[0][name] = true;
				} else {
					let name = el + 'ReqError';
					ReqErrors.commonErrors[0][name] = false;
				}
			}
			return '';
		});


		if (userDetails.currentWorking === 'Yes') {
			currentWorkingChecks.map((el) => {
				if (ERPUtils.isNullorWhiteSpace(userDetails[el])) {
					let name = el + 'ReqError';
					ReqErrors.commonErrors[0][name] = true;
				} else {
					let name = el + 'ReqError';
					ReqErrors.commonErrors[0][name] = false;
				}
				return '';
			});
		}

		professionalDetails.map((el, index) => {
			if (ERPUtils.isUndefinedOrNull(el.functionalArea) === false) {
				if (el.functionalArea.label === 'Others') {
					if (el.OtherFunctionalArea === '' && ERPUtils.isUndefinedOrNull(el.OtherFunctionalArea) === false) {
						let name = 'otherFunctAreaReqError';
						ReqErrors.profReq[index][name] = true;
					} else {
						let name = 'otherFunctAreaReqError';
						ReqErrors.profReq[index][name] = false;
					}
				} else {
					let name = 'otherFunctAreaReqError';
					ReqErrors.profReq[index][name] = false;
				}
			}
			return '';
		});

		Object.keys(PostReqErrors).map((el) => {
			if (PostReqErrors[el]) {
				if (
					ERPUtils.isUndefinedOrNull(userDetails[el]) === true ||
					ERPUtils.isNullOrEmpty(userDetails[el]) === true ||
					ERPUtils.isNullorWhiteSpace(userDetails[el]) === true
				) {
					let name = el + 'ReqError';
					ReqErrors.commonErrors[0][name] = true;
				}
			}
			// else {
			// 	let name = el + 'ReqError';
			// 	ReqErrors.commonErrors[0][name] = false;
			// }
			return '';
		});
		// ReqErrors.eduReq = false;
		// Object.keys(userDetails.EducationDetailsObj).map(el => {
		// 	if(EducationMandatory[el]){
		// 		userDetails.EducationDetailsObj[el].map((els) => {
		// 		return	EducationCheck.map((item) => {
		// 			if(item === "stateId" || item === "stateOther"){
		// 				if((ERPUtils.isUndefinedOrNull(els["stateId"]) || ERPUtils.isNullOrEmpty(els["stateId"])) &&
		// 				( ERPUtils.isUndefinedOrNull(els["stateOther"]) || ERPUtils.isNullOrEmpty(els["stateOther"]))){
		// 					ReqErrors.eduReq = true;
		// 				}
		// 			}else {
		// 				if (item === 'Status') {
		// 					if (EducationStatusData[el]) {
		// 						if (
		// 							ERPUtils.isUndefinedOrNull(els[item]) === true ||
		// 							ERPUtils.isNullOrEmpty(els[item]) === true ||
		// 							ERPUtils.isNullorWhiteSpace(els[item]) === true
		// 						) {
		// 							ReqErrors.eduReq = true;
		// 						}
		// 					}
		// 				} else {
		// 					if (
		// 						ERPUtils.isUndefinedOrNull(els[item]) === true ||
		// 						ERPUtils.isNullOrEmpty(els[item]) === true ||
		// 						ERPUtils.isNullorWhiteSpace(els[item]) === true
		// 					) {
		// 						ReqErrors.eduReq = true;
		// 					}
		// 				}						
		// 			}
		// 				return '';
		// 			})
		// 		});
		// 	}
		// 	return null;
		// })
		// if (EducationMandatory.CheckPuc) {
		// 	userDetails.Puc.map((el, index) => {
		// 		EducationCheck.map((item) => {
		// 			let checkName = 'Puc';
		// 			if (item === 'Status') {
		// 				if (EducationStatusData.CheckPuc) {
		// 					if (
		// 						ERPUtils.isUndefinedOrNull(userDetails.Puc[index][checkName + item]) === true ||
		// 						ERPUtils.isNullOrEmpty(userDetails.Puc[index][checkName + item]) === true ||
		// 						ERPUtils.isNullorWhiteSpace(userDetails.Puc[index][checkName + item]) === true
		// 					) {
		// 						let stateName = checkName + item + 'Error';
		// 						ReqErrors.pucReq[index][stateName] = true;
		// 					} else {
		// 						let stateName = checkName + item + 'Error';
		// 						ReqErrors.pucReq[index][stateName] = false;
		// 					}
		// 				}
		// 			} else {
		// 				if (
		// 					ERPUtils.isUndefinedOrNull(userDetails.Puc[index][checkName + item]) === true ||
		// 					ERPUtils.isNullOrEmpty(userDetails.Puc[index][checkName + item]) === true ||
		// 					ERPUtils.isNullorWhiteSpace(userDetails.Puc[index][checkName + item]) === true
		// 				) {
		// 					let stateName = checkName + item + 'Error';
		// 					ReqErrors.pucReq[index][stateName] = true;
		// 				} else {
		// 					let stateName = checkName + item + 'Error';
		// 					ReqErrors.pucReq[index][stateName] = false;
		// 				}
		// 			}
		// 			return '';
		// 		});
		// 		return '';
		// 	});
		// }

		setRequiredFields(ReqErrors, () => {
			validateEducationalData(ReqErrors, false);
		});
		return '';
	};

	const getMandatoryEduLIst = () => {
		let mandatory = {};
		let status = {}
		EducationList.map((el) => {
			let target = el.value;
			if (el.isMandatory) {
				mandatory[target] = true;
			}
			if (el.isStatusDisplay) {
				status[target] = true;
			}
			return '';
		});
		return {
			mandatory, status
		}
	}

	const validateEducationalData = (ReqErrors, isFromField) => {
		const EducationCheck = [
			'Status',
			'Course',
			// 'Specialization',
			"countryId",
			"stateId",
			"stateOther",
			'YearOfComp',
			'Percentage',
			'Institute',
			'Board'
		];
		let mandatoryEduListObj = getMandatoryEduLIst()
		ReqErrors.eduReq = false;
		if (ERPUtils.isNullorWhiteSpace(userDetails['HighestQualification']) ||
			ERPUtils.isNullOrEmpty(userDetails['HighestQualification'])) {
			ReqErrors.eduReq = true
			ReqErrors.commonErrors[0].HighestQualificationReqError = true
		} else {
			ReqErrors.eduReq = false
			ReqErrors.commonErrors[0].HighestQualificationReqError = false
		}
		const qualification = EducationList.filter((item) => item.label !== "MPhil" && item.label !== "PhD")
		Object.keys(userDetails.EducationDetailsObj).map(el => {
			if (mandatoryEduListObj.mandatory[el] || userDetails.HighestQualification?.value === el) {
				if (!ERPUtils.isNullOrEmpty(userDetails.EducationDetailsObj[el])) {
					userDetails.EducationDetailsObj[el].map((els) => {

						return EducationCheck.map((item) => {
							if (item === "stateId" || item === "stateOther") {
								if ((ERPUtils.isUndefinedOrNull(els["stateId"]) || ERPUtils.isNullOrEmpty(els["stateId"])) &&
									(ERPUtils.isUndefinedOrNull(els["stateOther"]) || ERPUtils.isNullOrEmpty(els["stateOther"]))) {
									ReqErrors.eduReq = true;
								}
							} else if (item === 'Status') {
								if (mandatoryEduListObj.status[el]) {
									if (
										ERPUtils.isUndefinedOrNull(els[item]) === true ||
										ERPUtils.isNullOrEmpty(els[item]) === true ||
										ERPUtils.isNullorWhiteSpace(els[item]) === true
									) {
										ReqErrors.eduReq = true;
									}
								}
							}

							else if (item === 'Percentage') {
								const qualification2 = qualification.filter((item) => parseInt(item.value, 10) === parseInt(el, 10))
								if (qualification2[0]?.value === el && !ERPUtils.isNullOrEmpty(qualification2[0].value)) {
									if (
										(ERPUtils.isUndefinedOrNull(els[item]) === true ||
											ERPUtils.isNullOrEmpty(els[item]) === true ||
											ERPUtils.isNullorWhiteSpace(els[item]) === true)) {
										ReqErrors.eduReq = true;
									}
								}

							}
							else if (
								(ERPUtils.isUndefinedOrNull(els[item]) === true ||
									ERPUtils.isNullOrEmpty(els[item]) === true ||
									ERPUtils.isNullorWhiteSpace(els[item]) === true)) {
								ReqErrors.eduReq = true;
							}
							return '';
						})
					});
				}
				// else {
				// 	ReqErrors.eduReq = true;
				// }
			}
			return null;
		})
		if (ReqErrors.eduReq === false) {
			if (isFromField) {
				removeTabStylingInEducation(ReqErrors);
			} else {
				CheckForErrors(ReqErrors);
			}
		} else {
			if (isFromField) {
				removeTabStylingInEducation(ReqErrors);
			} else {
				CheckForErrors(ReqErrors);
			}
		}
	}

	const removeTabStylingInEducation = (ReqErrors) => {
		const listingReqTabs = { ...ReqTabsStyle };
		if (ReqErrors.commonErrors[0].HighestQualificationReqError === false && ReqErrors.eduReq === false) {
			listingReqTabs.EducationalDetails = false;
		}
		setReqTabsStyle(listingReqTabs);
	}

	// Handler to remove the Required field Error messages:
	const RemoveReqFieldErrors = (target, header, id, checkPermanent) => {
		const removeReqErrors = { ...requiredFields };
		const checkError = target + 'ReqError';
		const ErrorHeader = header?.toLowerCase() + 'Req';
		// if (target === 'HighestQualification') {
		// 	removeReqErrors.eduReq = false
		// }
		if (ErrorHeader === 'profReq') {
			if (removeReqErrors.profReq[id][target]) {
				removeReqErrors.profReq[id][target] = false;
			}
		}
		if (removeReqErrors.commonErrors[0][checkError]) {
			removeReqErrors.commonErrors[0][checkError] = false;
		}
		if (target === 'Nationality') {
			removeReqErrors.commonErrors[0]['PassportNoReqError'] = false;
		}
		// if (target === 'ResearchExperience') {
		// 	removeReqErrors.commonErrors[0]['orcidIdReqError'] = false;
		// }
		if (target === 'currentWorking') {
			removeReqErrors.commonErrors[0].currentExperienceTypeReqError = false;
			removeReqErrors.commonErrors[0].currentFunctionalAreaReqError = false;
			removeReqErrors.commonErrors[0].currentOtherFunctionalAreaReqError = false;
			removeReqErrors.commonErrors[0].currentEmpTypeReqError = false;
			removeReqErrors.commonErrors[0].currentDesignationReqError = false;
			removeReqErrors.commonErrors[0].currentFromDateReqError = false;
			removeReqErrors.commonErrors[0].currentNoticePeriodReqError = false;
			// removeReqErrors.commonErrors[0].currentSalaryReqError = false;
			removeReqErrors.commonErrors[0].currentInstituteReqError = false;
		}
		if (checkPermanent) {
			if (target === 'currentState') {
				let CheckThis = 'permanentStateReqError';
				if (removeReqErrors.commonErrors[0][CheckThis]) {
					removeReqErrors.commonErrors[0][CheckThis] = false;
				}
			}
			if (target === 'currentCity') {
				let CheckThis = 'permanentCityReqError';
				if (removeReqErrors.commonErrors[0][CheckThis]) {
					removeReqErrors.commonErrors[0][CheckThis] = false;
				}
			}
			if (target === 'currentPincode') {
				let CheckThis = 'permanentPincodeReqError';
				if (removeReqErrors.commonErrors[0][CheckThis]) {
					removeReqErrors.commonErrors[0][CheckThis] = false;
				}
			}
			if (target === 'currentLine1') {
				let CheckThis = 'permanentLine1ReqError';
				if (removeReqErrors.commonErrors[0][CheckThis]) {
					removeReqErrors.commonErrors[0][CheckThis] = false;
				}
			}
		}
		if (target === 'CurAddSameAsPerAdd') {
			removeReqErrors.commonErrors[0]['currentCityReqError'] = false;
			removeReqErrors.commonErrors[0]['currentStateReqError'] = false;
			removeReqErrors.commonErrors[0]['otherCurrCityReqError'] = false;
			removeReqErrors.commonErrors[0]['otherCurrStateReqError'] = false;
			removeReqErrors.commonErrors[0]['permanentLine1ReqError'] = false;
			removeReqErrors.commonErrors[0]['permanentCountryReqError'] = false;
			removeReqErrors.commonErrors[0]['permanentStateReqError'] = false;
			removeReqErrors.commonErrors[0]['permanentCityReqError'] = false;
			removeReqErrors.commonErrors[0]['permanentPincodeReqError'] = false;
			removeReqErrors.commonErrors[0]['otherPermCityReqError'] = false;
			removeReqErrors.commonErrors[0]['otherPermStateReqError'] = false;
		}
		if (target === "currentCityAndState") {
			const target1 = "currentCityReqError";
			const target2 = "currentStateReqError";
			const target3 = "otherCurrCityReqError";
			const target4 = "otherCurrStateReqError";
			removeReqErrors.commonErrors[0][target1] = false;
			removeReqErrors.commonErrors[0][target2] = false;
			removeReqErrors.commonErrors[0][target3] = false;
			removeReqErrors.commonErrors[0][target4] = false;
		}
		if (target === "permanentCityAndState") {
			const target1 = "permanentCityReqError";
			const target2 = "permanentStateReqError";
			const target3 = "otherPermCityReqError";
			const target4 = "otherPermStateReqError";
			removeReqErrors.commonErrors[0][target1] = false;
			removeReqErrors.commonErrors[0][target2] = false;
			removeReqErrors.commonErrors[0][target3] = false;
			removeReqErrors.commonErrors[0][target4] = false;
		}
		// if(target === "empApplnCampusPrefDTOList"){
		// 	removeReqErrors.commonErrors[0]["empApplnCampusPrefDTOListReqError"]= false;
		// 	// removeReqErrors.commonErrors[0]["LocationReqError"]= false;
		// }
		setRequiredFields(removeReqErrors, () => {
			RemoveReqTabStyling(removeReqErrors);
		});
	};

	const CheckForErrors = (ReqErrors) => {
		let allVals = [];
		Object.keys(ReqErrors).map((el) => {
			if (typeof ReqErrors[el] === 'object' && ReqErrors[el] !== null) {
				ReqErrors[el].map((item, index) => {
					Object.keys(item).map((innerItem) => {
						allVals.push(ReqErrors[el][index][innerItem]);
						return '';
					});
					return '';
				});
			} else {
				if (ReqErrors[el]) {
					allVals.push(true)
				}
			}
			return '';
		});
		if (allVals.indexOf(true) !== -1) {
			// setReqFieldsAlert(true);
			SetReqTabsStyling(ReqErrors);
		} else {
			FrameEducationData('save');
			// frameImagesData('save');
		}
		return '';
	};

	const closeReqFieldAlert = (name) => {
		if (name === 'RequiredFieldsAlert') {
			setReqFieldsAlert(false);
		}
		if (name === 'validationAlert') {
			setValidationAlert(false);
		}
		if (name === 'AddressNote') {
			setAddressPopup(false);
		}
		// if (name === 'CountryCodeHelper') {
		// 	setCountryCodePopup(false);
		// }
		if (name === 'incorrectPincode') {
			setWrongPincode(false);
		}
		if (name === 'currState') {
			setCurrShowStatePopup(false);
		}
		if (name === 'currCity') {
			setShowCurrCityPoup(false);
		}
		if (name === 'permState') {
			setPermShowStatePopup(false);
		}
		if (name === 'permCity') {
			setShowPermCityPoup(false);
		}
		return '';
	};

	const [ReqTabsStyle, setReqTabsStyle] = useStateCallback({
		jobDetails: false,
		PersonalDetails: false,
		AddressDetails: false,
		EducationalDetails: false,
		professionalDetails: false,
		ResearchDetails: false,
		ProfessionalDetails: false
	});

	const SetReqTabsStyling = (ReqErrors) => {
		const listReqTabs = { ...ReqTabsStyle };
		if (
			ReqErrors.commonErrors[0].PostReqError ||
			ReqErrors.commonErrors[0].jobCategoryDTOReqError ||
			ReqErrors.commonErrors[0].categoryReqError ||
			ReqErrors.commonErrors[0].SubjectReqError ||
			ReqErrors.commonErrors[0].SpecializationReqError ||
			ReqErrors.commonErrors[0].empApplnCampusPrefDTOList1ReqError

		) {
			listReqTabs.jobDetails = true;
		}
		if (
			ReqErrors.commonErrors[0].NameReqError ||
			ReqErrors.commonErrors[0].GenderReqError ||
			ReqErrors.commonErrors[0].DOBReqError ||
			ReqErrors.commonErrors[0].CountryCodeReqError ||
			ReqErrors.commonErrors[0].mobileNoReqError ||
			ReqErrors.commonErrors[0].EmailReqError ||
			ReqErrors.commonErrors[0].AadharNoReqError ||
			ReqErrors.commonErrors[0].maritalReqError ||
			ReqErrors.commonErrors[0].NationalityReqError ||
			ReqErrors.commonErrors[0].ReligionReqError ||
			ReqErrors.commonErrors[0].ReservationReqError ||
			ReqErrors.commonErrors[0].PassportNoReqError ||
			ValidationError.AadharNoError ||
			ValidationError.AltNoError ||
			ValidationError.EmailError
		) {
			listReqTabs.PersonalDetails = true;
		}
		if (
			ReqErrors.commonErrors[0].currentLine1ReqError ||
			ReqErrors.commonErrors[0].currentCountryReqError ||
			ReqErrors.commonErrors[0].currentStateReqError ||
			ReqErrors.commonErrors[0].currentCityReqError ||
			ReqErrors.commonErrors[0].currentPincodeReqError ||
			ReqErrors.commonErrors[0].permanentLine1ReqError ||
			ReqErrors.commonErrors[0].permanentCountryReqError ||
			ReqErrors.commonErrors[0].permanentStateReqError ||
			ReqErrors.commonErrors[0].permanentCityReqError ||
			ReqErrors.commonErrors[0].permanentPincodeReqError ||
			ReqErrors.commonErrors[0].otherCurrStateReqError ||
			ReqErrors.commonErrors[0].otherCurrCityReqError ||
			ReqErrors.commonErrors[0].otherPermStateReqError ||
			ReqErrors.commonErrors[0].otherPermCityReqError
		) {
			listReqTabs.AddressDetails = true;
		}
		if (ReqErrors.commonErrors[0].HighestQualificationReqError || ReqErrors.eduReq) {
			listReqTabs.EducationalDetails = true;
		}
		if (
			ReqErrors.commonErrors[0].currentWorkingReqError ||
			ReqErrors.commonErrors[0].expSalaryReqError ||
			ReqErrors.commonErrors[0].currentOtherFunctionalAreaReqError ||
			ReqErrors.commonErrors[0].currentExperienceTypeReqError ||
			ReqErrors.commonErrors[0].currentFunctionalAreaReqError ||
			ReqErrors.commonErrors[0].currentEmpTypeReqError ||
			ReqErrors.commonErrors[0].currentFromDateReqError ||
			ReqErrors.commonErrors[0].currentNoticePeriodReqError ||
			// ReqErrors.commonErrors[0].currentSalaryReqError ||
			ReqErrors.commonErrors[0].currentInstituteReqError ||
			ReqErrors.commonErrors[0].currentDesignationReqError
		) {
			listReqTabs.ProfessionalDetails = true;
		}
		ReqErrors.profReq.map((el) => {
			if (el.otherFunctAreaReqError) {
				listReqTabs.ProfessionalDetails = true;
			}
			return '';
		});
		// if (ReqErrors.eduReq) {
		// 	listReqTabs.EducationalDetails = true;
		// }

		// if (ReqErrors.commonErrors[0].orcidIdReqError) {
		// 	listReqTabs.ResearchDetails = true;
		// }
		setReqTabsStyle(listReqTabs, () => moveToReqTab(listReqTabs));
		return '';
	};

	const moveToReqTab = (tabList) => {
		let renderObj = { ...renderComp };
		if (!ERPUtils.isNullorWhiteSpace(tabList) && !ERPUtils.isNullOrEmpty(tabList)) {
			let keys = Object.keys(tabList);
			let targetKeys = Object.keys(renderObj);
			for (let index = 0; index < targetKeys.length; index++) {
				renderObj[targetKeys[index]] = false;
			}
			for (let index = 0; index < keys.length; index++) {
				if (tabList[keys[index]]) {
					if (keys[index] === "jobDetails") {
						renderObj["RoleDetails"] = true;
						AddClass("RoleDetails")
					}
					if (keys[index] === "PersonalDetails") {
						renderObj["PersonalDetails"] = true;
						AddClass("PersonalDetails")
					}
					if (keys[index] === "AddressDetails") {
						renderObj["AddressDetails"] = true;
						AddClass("AddressDetails")
					}
					if (keys[index] === "EducationalDetails") {
						renderObj["EducationDetails"] = true;
						AddClass("EducationDetails")
					}
					if (keys[index] === "ProfessionalDetails") {
						renderObj["ProfessionalExperience"] = true;
						AddClass("ProfessionalExperience")
					}
					if (keys[index] === "ResearchDetails") {
						renderObj["ResearchDetails"] = true;
						AddClass("ResearchDetails")
					}
					break;
				}

			}
		}
		setRenderComp(renderObj);

	}

	const RemoveReqTabStyling = (data) => {
		const listingReqTabs = { ...ReqTabsStyle };
		let profErrorArray = [];

		let CheckRequiredFields = data !== '' ? data : requiredFields;

		if (
			(CheckRequiredFields.commonErrors[0].PostReqError ||
				CheckRequiredFields.commonErrors[0].jobCategoryDTOReqError ||
				CheckRequiredFields.commonErrors[0].categoryReqError ||
				CheckRequiredFields.commonErrors[0].SubjectReqError ||
				CheckRequiredFields.commonErrors[0].SpecializationReqError ||
				CheckRequiredFields.commonErrors[0].empApplnCampusPrefDTOList1ReqError) === false
		) {
			listingReqTabs.jobDetails = false;
		}

		if (
			(CheckRequiredFields.commonErrors[0].NameReqError ||
				CheckRequiredFields.commonErrors[0].GenderReqError ||
				CheckRequiredFields.commonErrors[0].DOBReqError ||
				CheckRequiredFields.commonErrors[0].CountryCodeReqError ||
				CheckRequiredFields.commonErrors[0].mobileNoReqError ||
				CheckRequiredFields.commonErrors[0].EmailReqError ||
				CheckRequiredFields.commonErrors[0].maritalReqError ||
				CheckRequiredFields.commonErrors[0].NationalityReqError ||
				CheckRequiredFields.commonErrors[0].ReligionReqError ||
				CheckRequiredFields.commonErrors[0].ReservationReqError ||
				CheckRequiredFields.commonErrors[0].PassportNoReqError ||
				ValidationError.EmailError ||
				ValidationError.AadharNoError ||
				ValidationError.AltNoError
			) === false
		) {
			listingReqTabs.PersonalDetails = false;
		}

		if (
			(CheckRequiredFields.commonErrors[0].currentLine1ReqError ||
				CheckRequiredFields.commonErrors[0].currentCountryReqError ||
				CheckRequiredFields.commonErrors[0].currentStateReqError ||
				CheckRequiredFields.commonErrors[0].currentCityReqError ||
				CheckRequiredFields.commonErrors[0].currentPincodeReqError ||
				CheckRequiredFields.commonErrors[0].otherCurrStateReqError ||
				CheckRequiredFields.commonErrors[0].otherCurrCityReqError ||
				CheckRequiredFields.commonErrors[0].otherPermStateReqError ||
				CheckRequiredFields.commonErrors[0].otherPermCityReqError ||
				CheckRequiredFields.commonErrors[0].permanentLine1ReqError ||
				CheckRequiredFields.commonErrors[0].permanentCountryReqError ||
				CheckRequiredFields.commonErrors[0].permanentStateReqError ||
				CheckRequiredFields.commonErrors[0].permanentCityReqError ||
				CheckRequiredFields.commonErrors[0].permanentPincodeReqError) === false
		) {
			listingReqTabs.AddressDetails = false;
		}
		if (CheckRequiredFields.commonErrors[0].HighestQualificationReqError === false && CheckRequiredFields.eduReq === false) {
			listingReqTabs.EducationalDetails = false;
		}

		if (
			(CheckRequiredFields.commonErrors[0].currentWorkingReqError ||
				CheckRequiredFields.commonErrors[0].expSalaryReqError ||
				CheckRequiredFields.commonErrors[0].currentOtherFunctionalAreaReqError ||
				CheckRequiredFields.commonErrors[0].currentExperienceTypeReqError ||
				CheckRequiredFields.commonErrors[0].currentFunctionalAreaReqError ||
				CheckRequiredFields.commonErrors[0].currentEmpTypeReqError ||
				CheckRequiredFields.commonErrors[0].currentDesignationReqError ||
				CheckRequiredFields.commonErrors[0].currentFromDateReqError ||
				CheckRequiredFields.commonErrors[0].currentNoticePeriodReqError ||
				// CheckRequiredFields.commonErrors[0].currentSalaryReqError ||
				CheckRequiredFields.commonErrors[0].currentInstituteReqError) === false
		) {
			profErrorArray.push(false);
		} else {
			profErrorArray.push(true);
		}

		CheckRequiredFields.profReq.map((el) => {
			if (el.otherFunctAreaReqError === false) {
				profErrorArray.push(false);
			} else {
				profErrorArray.push(true);
			}
			return '';
		});

		if (profErrorArray.indexOf(true) !== -1) {
			listingReqTabs.ProfessionalDetails = true;
		} else {
			listingReqTabs.ProfessionalDetails = false;
		}
		// if (CheckRequiredFields.eduReq === false &&
		// 		CheckRequiredFields.commonErrors[0].HighestQualificationReqError === false) {
		// 			listingReqTabs.EducationalDetails = false;
		// } else {
		// 	listingReqTabs.EducationalDetails = true;
		// }

		// CheckRequiredFields.pucReq.map((el) => {
		// 	if (
		// 		(el.PucCourseError ||
		// 			el.PucStatusError ||
		// 			// el.PucSpecializationError ||
		// 			el.PucYearOfCompError ||
		// 			el.PucPercentageError ||
		// 			el.PucInstituteError ||
		// 			el.PucBoardError ||
		// 			CheckRequiredFields.commonErrors[0].HighestQualificationReqError) === false
		// 	) {
		// 		EducationList.puc.push(false);
		// 	} else {
		// 		EducationList.puc.push(true);
		// 	}
		// 	return '';
		// });	

		// if (CheckRequiredFields.commonErrors[0].orcidIdReqError === false) {
		// 	listingReqTabs.ResearchDetails = false;
		// }
		setReqTabsStyle(listingReqTabs);
		return '';
	};

	const checkForValidationErrors = (type) => {
		const CheckValidationErrorsData = { ...ValidationError };
		let validationErrorsFound = [];
		Object.keys(CheckValidationErrorsData).map((el) => {
			validationErrorsFound.push(ValidationError[el]);
			return '';
		});
		if (validationErrorsFound.indexOf(true) !== -1) {
			setValidationAlert(true);
			CheckRequired();
		} else {
			if (type === 'save') {
				CheckRequired()
			}
		}
		return '';
	};

	const openImageInTab = (event) => {
		window.open(event.target.src);
	};

	//File upload:
	// eslint-disable-next-line
	// const onFileChange = (event, parent, isFromEducation) => {
	// 	setSaveTheData(true);
	// 	let id = event.target.id;
	// 	if (!ERPUtils.isUndefinedOrNull(event.target.files.length > 0)) {
	// 		Object.keys(event.target.files).map((el) => {
	// 			const name = event.target.files[el].name;
	// 			const lastDot = name.lastIndexOf('.');
	// 			const fileName = name.substring(0, lastDot);
	// 			const extension = name.substring(lastDot + 1);
	// 			setFileForUpload(event.target.files[el], fileName, extension, parent, id, isFromEducation);
	// 			return '';
	// 		});
	// 	}
	// 	event.target.value = null;
	// 	return '';
	// };

	// const setFileForUpload = (file, fileName, extension, parent, id, isFromEducation) => {
	// 	let newState = { ...userDetails };
	// 	let UploadedImages = isFromEducation ?
	// 		newState.EducationDetailsObj[parent][id].Documents :
	// 		newState[parent][id].Documents;
	// 	const url = URL.createObjectURL(file);
	// 	if (parent === "ResearchDetailsImg") {
	// 		UploadedImages.splice(0,)
	// 	}
	// 	UploadedImages.push({
	// 		file,
	// 		url,
	// 		fileName,
	// 		extension,
	// 		recordStatus: 'A',
	// 		newFile: true
	// 	});
	// 	if (isFromEducation) {
	// 		newState.EducationDetailsObj[parent][id].Documents = UploadedImages;
	// 	} else {
	// 		newState[parent][id].Documents = UploadedImages;
	// 	}
	// 	setUserDetails(newState);
	// };

	const imageRemoveHandler = (event, name, idx, isFromEducation) => {
		setSaveTheData(true);
		let index = event.target.id;
		let fileArray = { ...userDetails };
		let newArray = isFromEducation ? fileArray.EducationDetailsObj[name][idx].Documents :
			fileArray[name][idx].Documents;
		if (index !== -1) {
			if (ERPUtils.isUndefinedOrNull(newArray[index].id) === true) {
				newArray.splice(index, 1);
			} else {
				newArray[index].recordStatus = 'D';
			}
			setUserDetails(fileArray);
		}
	};

	// const frameImagesData = (type) => {
	// 	let EducationDataImages = new FormData();
	// 	let ProfessionalDataImages = new FormData();
	// 	let ResearchImages = new FormData();

	// 	// Educational details:
	// 	Object.keys(userDetails.EducationDetailsObj).map(el => {
	// 		userDetails.EducationDetailsObj[el].map((els) => {
	// 			els.Documents.map((item) => {
	// 				EducationDataImages.append('files', item.file, el + "_" + item.fileName + '.' + item.extension);
	// 				return '';
	// 			});
	// 			return '';
	// 		})
	// 		return ''
	// 	})
	// 	// userDetails.Tenth.map((el) => {
	// 	// 	el.Documents.map((item) => {
	// 	// 		EducationDataImages.append('files', item.file, 'Tenth_' + item.fileName + '.' + item.extension);
	// 	// 		return '';
	// 	// 	});
	// 	// 	return '';
	// 	// });

	// 	userDetails.others.map((el) => {
	// 		el.Documents.map((item) => {
	// 			EducationDataImages.append('files', item.file, 'Others_' + item.fileName + '.' + item.extension);
	// 			return '';
	// 		});
	// 		return '';
	// 	});
	// 	userDetails.EligibilityTest.map((el) => {
	// 		el.Documents.map((item) => {
	// 			EducationDataImages.append(
	// 				'files',
	// 				item.file,
	// 				'EligibilityTest_' + item.fileName + '.' + item.extension
	// 			);
	// 			return '';
	// 		});
	// 		return '';
	// 	});

	// 	// Profile image:
	// 	userDetails.ResearchDetailsImg.map((el) => {
	// 		el.Documents.map((item) => {
	// 			ResearchImages.append('files', item.file, 'Research_' + item.fileName + '.' + item.extension);
	// 			return '';
	// 		});
	// 		return '';
	// 	});

	// 	// Professional details:
	// 	if (userDetails.currentWorking === 'Yes') {
	// 		userDetails.CurrentExpDocuments.map((el) => {
	// 			el.Documents.map((item) => {
	// 				ProfessionalDataImages.append(
	// 					'files',
	// 					item.file,
	// 					'professional_' + item.fileName + '.' + item.extension
	// 				);
	// 				return '';
	// 			});
	// 			return '';
	// 		});
	// 	}

	// 	userDetails.PrevExpDocuments.map((el) => {
	// 		el.Documents.map((item) => {
	// 			ProfessionalDataImages.append(
	// 				'files',
	// 				item.file,
	// 				'professional_' + item.fileName + '.' + item.extension
	// 			);
	// 			return '';
	// 		});
	// 		return '';
	// 	});

	// 	SendUploadImagesToApi(EducationDataImages, ProfessionalDataImages, ResearchImages, type);
	// };

	// const [ ImagesHashedData, setImagesHashedData ] = useStateCallback({
	// 	ProfileImgData: '',
	// 	educationImgData: '',
	// 	professionalImgData: ''
	// });

	// const SendUploadImagesToApi = (Education, professional, ResearchImages, type) => {
	// 	let oldData = {
	// 		ProfileImgData: '',
	// 		educationImgData: '',
	// 		professionalImgData: ''
	// 	};
	// 	if (ResearchImages.getAll('files').length > 0) {
	// 		setLoaderActive(true);
	// 		ApiGateway.postFiles(
	// 			'Employee/Recruitment/EmployeeApplicationControler/employeeApplicantPhotoUpload',
	// 			ResearchImages,
	// 			(response) => {
	// 				if (response.status === 'SUCCESS') {
	// 					oldData['ProfileImgData'] = response.data.dto;

	// 					if (Education.getAll('files').length > 0) {
	// 						ApiGateway.postFiles(
	// 							'Employee/Recruitment/EmployeeApplicationControler/educationalDetailsFilesUpload',
	// 							Education,
	// 							(response) => {
	// 								if (response.status === 'SUCCESS') {
	// 									oldData['educationImgData'] = response.data.dto;
	// 									if (professional.getAll('files').length > 0) {
	// 										ApiGateway.postFiles(
	// 											'Employee/Recruitment/EmployeeApplicationControler/professionalExperienceFilesUpload',
	// 											professional,
	// 											(response) => {
	// 												setLoaderActive(false);
	// 												if (response.status === 'SUCCESS') {
	// 													oldData['professionalImgData'] = response.data.dto;
	// 													mapHashvalue(oldData, type);
	// 												} else {
	// 													setLoaderActive(false);
	// 												}
	// 											}
	// 										);
	// 									} else {
	// 										setLoaderActive(false);
	// 										mapHashvalue(oldData, type);
	// 									}
	// 								} else {
	// 									setLoaderActive(false);
	// 								}
	// 							}
	// 						);
	// 					} else if (professional.getAll('files').length > 0) {
	// 						setLoaderActive(true);
	// 						ApiGateway.postFiles(
	// 							'Employee/Recruitment/EmployeeApplicationControler/professionalExperienceFilesUpload',
	// 							professional,
	// 							(response) => {
	// 								setLoaderActive(false);
	// 								if (response.status === 'SUCCESS') {
	// 									oldData['professionalImgData'] = response.data.dto;
	// 									mapHashvalue(oldData, type);
	// 								} else {
	// 									setLoaderActive(false);
	// 								}
	// 							}
	// 						);
	// 					} else {
	// 						setLoaderActive(false);
	// 						mapHashvalue(oldData, type);
	// 					}
	// 				} else {
	// 					setLoaderActive(false);
	// 				}
	// 			}
	// 		);
	// 	} else if (Education.getAll('files').length > 0) {
	// 		setLoaderActive(true);
	// 		ApiGateway.postFiles(
	// 			'Employee/Recruitment/EmployeeApplicationControler/educationalDetailsFilesUpload',
	// 			Education,
	// 			(response) => {
	// 				setLoaderActive(false);
	// 				if (response.status === 'SUCCESS') {
	// 					oldData['educationImgData'] = response.data.dto;
	// 					if (professional.getAll('files').length > 0) {
	// 						ApiGateway.postFiles(
	// 							'Employee/Recruitment/EmployeeApplicationControler/professionalExperienceFilesUpload',
	// 							professional,
	// 							(response) => {
	// 								setLoaderActive(false);
	// 								if (response.status === 'SUCCESS') {
	// 									oldData['professionalImgData'] = response.data.dto;
	// 									mapHashvalue(oldData, type);
	// 								} else {
	// 									setLoaderActive(false);
	// 								}
	// 							}
	// 						);
	// 					} else {
	// 						setLoaderActive(false);
	// 						mapHashvalue(oldData, type);
	// 					}
	// 				} else {
	// 					setLoaderActive(false);
	// 				}
	// 			}
	// 		);
	// 	} else if (professional.getAll('files').length > 0) {
	// 		setLoaderActive(true);
	// 		ApiGateway.postFiles(
	// 			'Employee/Recruitment/EmployeeApplicationControler/professionalExperienceFilesUpload',
	// 			professional,
	// 			(response) => {
	// 				setLoaderActive(false);
	// 				if (response.status === 'SUCCESS') {
	// 					oldData['professionalImgData'] = response.data.dto;
	// 					mapHashvalue(oldData, type);
	// 				} else {
	// 					setLoaderActive(false);
	// 				}
	// 			}
	// 		);
	// 	} else {
	// 		setLoaderActive(false);
	// 		mapHashvalue(oldData, type);
	// 	}
	// };

	// const mapHashvalue = (data, type) => {
	// 	const oldObj = { ...userDetails };
	// 	// if (oldObj.ResearchDetailsImg[0].Documents[0].fileName + '.png' === data.ProfileImgData[0].t1) {
	// 	// 	oldObj.ResearchDetailsImg[0].Documents[0].fileName = data.ProfileImgData[0].t2;
	// 	// }
	// 	if (data.ProfileImgData !== '') {
	// 		data.ProfileImgData.map((el) => {
	// 			oldObj.ResearchDetailsImg.map((item, index) => {
	// 				item.Documents.map((innerItem, idx) => {
	// 					if (innerItem.fileName + '.' + innerItem.extension === el.t1) {
	// 						oldObj.ResearchDetailsImg[index].Documents[idx].fileName = el.t2;
	// 					}
	// 					return '';
	// 				});
	// 				return '';
	// 			});
	// 			return '';
	// 		});
	// 	}

	// 	if (data.professionalImgData !== '') {
	// 		data.professionalImgData.map((el) => {
	// 			oldObj.CurrentExpDocuments.map((item, idx) => {
	// 				item.Documents.map((innerItem, id) => {
	// 					if (innerItem.fileName + '.' + innerItem.extension === el.t1) {
	// 						oldObj.CurrentExpDocuments[idx].Documents[id].fileName = el.t2;
	// 					}
	// 					return '';
	// 				});
	// 				return '';
	// 			});
	// 			return '';
	// 		});
	// 	}

	// 	if (data.professionalImgData !== '') {
	// 		data.professionalImgData.map((el) => {
	// 			oldObj.PrevExpDocuments.map((item, idx) => {
	// 				item.Documents.map((innerItem, id) => {
	// 					if (innerItem.fileName + '.' + innerItem.extension === el.t1) {
	// 						oldObj.PrevExpDocuments[idx].Documents[id].fileName = el.t2;
	// 					}
	// 					return '';
	// 				});
	// 				return '';
	// 			});
	// 			return '';
	// 		});
	// 	}

	// 	if (data.educationImgData !== '') {
	// 		data.educationImgData.map((el) => {
	// 			Object.keys(oldObj.EducationDetailsObj).map((item, idx) => {
	// 				oldObj.EducationDetailsObj[item].map((innerArray, idx) => {
	// 					innerArray.Documents.map((innerItem, id) => {
	// 						if (innerItem.fileName + '.png' === el.t1) {
	// 							oldObj.EducationDetailsObj[item][idx].Documents[id].fileName = el.t2;
	// 						}
	// 						return '';
	// 					});
	// 					return ''
	// 				})
	// 				return '';
	// 			});
	// 			return '';
	// 		});
	// 	}

	// 	// if (data.educationImgData !== '') {
	// 	// 	data.educationImgData.map((el) => {
	// 	// 		oldObj.Puc.map((item, idx) => {
	// 	// 			item.Documents.map((innerItem, id) => {
	// 	// 				if (innerItem.fileName + '.png' === el.t1) {
	// 	// 					oldObj.Puc[idx].Documents[id].fileName = el.t2;
	// 	// 				}
	// 	// 				return '';
	// 	// 			});
	// 	// 			return '';
	// 	// 		});
	// 	// 		return '';
	// 	// 	});
	// 	// }

	// 	// if (data.educationImgData !== '') {
	// 	// 	data.educationImgData.map((el) => {
	// 	// 		oldObj.UG.map((item, idx) => {
	// 	// 			item.Documents.map((innerItem, id) => {
	// 	// 				if (innerItem.fileName + '.png' === el.t1) {
	// 	// 					oldObj.UG[idx].Documents[id].fileName = el.t2;
	// 	// 				}
	// 	// 				return '';
	// 	// 			});
	// 	// 			return '';
	// 	// 		});
	// 	// 		return '';
	// 	// 	});
	// 	// }

	// 	// if (data.educationImgData !== '') {
	// 	// 	data.educationImgData.map((el) => {
	// 	// 		oldObj.PG.map((item, idx) => {
	// 	// 			item.Documents.map((innerItem, id) => {
	// 	// 				if (innerItem.fileName + '.png' === el.t1) {
	// 	// 					oldObj.PG[idx].Documents[id].fileName = el.t2;
	// 	// 				}
	// 	// 				return '';
	// 	// 			});
	// 	// 			return '';
	// 	// 		});
	// 	// 		return '';
	// 	// 	});
	// 	// }

	// 	// if (data.educationImgData !== '') {
	// 	// 	data.educationImgData.map((el) => {
	// 	// 		oldObj.Mphil.map((item, idx) => {
	// 	// 			item.Documents.map((innerItem, id) => {
	// 	// 				if (innerItem.fileName + '.png' === el.t1) {
	// 	// 					oldObj.Mphil[idx].Documents[id].fileName = el.t2;
	// 	// 				}
	// 	// 				return '';
	// 	// 			});
	// 	// 			return '';
	// 	// 		});
	// 	// 		return '';
	// 	// 	});
	// 	// }

	// 	// if (data.educationImgData !== '') {
	// 	// 	data.educationImgData.map((el) => {
	// 	// 		oldObj.Phd.map((item, idx) => {
	// 	// 			item.Documents.map((innerItem, id) => {
	// 	// 				if (innerItem.fileName + '.png' === el.t1) {
	// 	// 					oldObj.Phd[idx].Documents[id].fileName = el.t2;
	// 	// 				}
	// 	// 				return '';
	// 	// 			});
	// 	// 			return '';
	// 	// 		});
	// 	// 		return '';
	// 	// 	});
	// 	// }

	// 	if (data.educationImgData !== '') {
	// 		data.educationImgData.map((el) => {
	// 			oldObj.others.map((item, idx) => {
	// 				item.Documents.map((innerItem, id) => {
	// 					if (innerItem.fileName + '.png' === el.t1) {
	// 						oldObj.others[idx].Documents[id].fileName = el.t2;
	// 					}
	// 					return '';
	// 				});
	// 				return '';
	// 			});
	// 			return '';
	// 		});
	// 	}

	// 	if (data.educationImgData !== '') {
	// 		data.educationImgData.map((el) => {
	// 			oldObj.EligibilityTest.map((item, idx) => {
	// 				item.Documents.map((innerItem, id) => {
	// 					if (innerItem.fileName + '.png' === el.t1) {
	// 						oldObj.EligibilityTest[idx].Documents[id].fileName = el.t2;
	// 					}
	// 					return '';
	// 				});
	// 				return '';
	// 			});
	// 			return '';
	// 		});
	// 	}
	// 	setUserDetails(oldObj, () => {
	// 		FrameEducationData(type);
	// 	});
	// };

	// Once User clicks on save button:
	const onDataSave = () => {
		setIsSave(true);
		checkForValidationErrors('save');
		return '';
	};

	const saveDraft = () => {
		// checkForValidationErrors('save draft');
		FrameEducationData('save draft');
		return '';
	};

	const getSaveDraftIds = (heading, subHeading, type) => {
		let val = null;
		if (ERPUtils.isUndefinedOrNull(saveDraftData) === false) {
			if (ERPUtils.isUndefinedOrNull(saveDraftData.researchDetailDTO) === false) {
				if (ERPUtils.isUndefinedOrNull(saveDraftData.researchDetailDTO.researchEntries) === false) {
					if (
						type === 'entriesId' &&
						ERPUtils.isUndefinedOrNull(
							saveDraftData.researchDetailDTO.researchEntries.researchEntriesHeadings
						) === false
					) {
						saveDraftData.researchDetailDTO.researchEntries.researchEntriesHeadings.map((el) => {
							if (el.groupHeading === heading) {
								el.parameters.map((item) => {
									if (item.researchParameter === subHeading) {
										val = item.empApplnEntriesId;
									}
									return '';
								});
							}
							return '';
						});
					}
					if (
						type === 'addInfo' &&
						ERPUtils.isUndefinedOrNull(
							saveDraftData.researchDetailDTO.researchEntries.researchEntriesHeadings
						) === false
					) {
						saveDraftData.researchDetailDTO.researchEntries.researchEntriesHeadings.map((el) => {
							if (el.groupHeading === heading) {
								el.parameters.map((item) => {
									if (item.researchParameter === subHeading) {
										val = item.empApplnAddtnlInfoEntriesId;
									}
									return '';
								});
							}
							return '';
						});
					}
				}
			}
		}
		return val;
	};

	// const mapImageData = (data, type) => {
	// 	const newArray = [];
	// 	if (type === 'education') {
	// 		data?.map((el) => {
	// 			let obj = {
	// 				empApplnEducationalDetailsDocumentsId:
	// 					ERPUtils.isUndefinedOrNull(el.empApplnEducationalDetailsDocumentsId) === false
	// 						? el.empApplnEducationalDetailsDocumentsId
	// 						: null,
	// 				empApplnEducationalDetailsId:
	// 					ERPUtils.isUndefinedOrNull(el.empApplnEducationalDetailsId) === false
	// 						? el.empApplnEducationalDetailsId
	// 						: null,
	// 						uniqueFileName:
	// 						ERPUtils.isUndefinedOrNull(el.uniqueFileName) === false
	// 							? el.uniqueFileName
	// 							: null,
	// 						processCode:
	// 						ERPUtils.isUndefinedOrNull(el.processCode) === false
	// 							? el.processCode
	// 							: null,
	// 						newFile:
	// 						ERPUtils.isUndefinedOrNull(el.newFile) === false
	// 							? el.newFile
	// 							: null,
	// 						originalFileName:
	// 							ERPUtils.isUndefinedOrNull(el.originalFileName) === false
	// 								? el.originalFileName
	// 								: null,
	// 				educationalDocumentsUrl: el.educationalDocumentsUrl
	// 			};
	// 			newArray.push(obj);
	// 			return '';
	// 		});
	// 	}
	// 	if (type === 'Eligibilty') {
	// 		data.map((el) => {
	// 			let obj = {
	// 				empApplnEligibilityTestDocumentId:
	// 					ERPUtils.isUndefinedOrNull(el.empApplnEligibilityTestDocumentId) === false
	// 						? el.empApplnEligibilityTestDocumentId
	// 						: null,
	// 				empApplnEligibilityTestId:
	// 					ERPUtils.isUndefinedOrNull(el.empApplnEligibilityTestId) === false
	// 						? el.empApplnEligibilityTestId
	// 						: null,
	// 						processCode:
	// 					ERPUtils.isUndefinedOrNull(el.processCode) === false
	// 						? el.processCode
	// 						: null,
	// 						newFile:
	// 					ERPUtils.isUndefinedOrNull(el.newFile) === false
	// 						? el.newFile
	// 						: null,
	// 						uniqueFileName:
	// 					ERPUtils.isUndefinedOrNull(el.uniqueFileName) === false
	// 						? el.uniqueFileName
	// 						: null,
	// 						originalFileName:
	// 					ERPUtils.isUndefinedOrNull(el.originalFileName) === false
	// 						? el.originalFileName
	// 						: null,
	// 				eligibilityDocumentUrl: el.fileName
	// 			};
	// 			newArray.push(obj);
	// 			return '';
	// 		});
	// 	}
	// 	if (type === 'professional') {
	// 		data.map((el) => {
	// 			let obj = {
	// 				empApplnWorkExperienceDocumentId:
	// 					ERPUtils.isUndefinedOrNull(el.empApplnWorkExperienceDocumentId) === false
	// 						? el.empApplnWorkExperienceDocumentId
	// 						: null,
	// 				empApplnWorkExperienceId:
	// 					ERPUtils.isUndefinedOrNull(el.empApplnWorkExperienceId) === false
	// 						? el.empApplnWorkExperienceId
	// 						: null,
	// 						processCode:
	// 						ERPUtils.isUndefinedOrNull(el.processCode) === false
	// 							? el.processCode
	// 							: null,
	// 							newFile:
	// 						ERPUtils.isUndefinedOrNull(el.newFile) === false
	// 							? el.newFile
	// 							: null,
	// 							uniqueFileName:
	// 						ERPUtils.isUndefinedOrNull(el.uniqueFileName) === false
	// 							? el.uniqueFileName
	// 							: null,
	// 							originalFileName:
	// 						ERPUtils.isUndefinedOrNull(el.originalFileName) === false
	// 							? el.originalFileName
	// 							: null,
	// 				experienceDocumentsUrl: el.fileName
	// 			};
	// 			newArray.push(obj);
	// 			return '';
	// 		});
	// 	}
	// 	return newArray;
	// };


	// To frame the Api data object.
	const FrameEducationData = (type) => {
		let EducationDataList = [];
		let EligibiltyDataList = [];
		let OtherEducationDataList = [];
		let ProfessionalDataList = [];
		let ResearchDataList = [];
		let specializationObject = [];
		let preferredLocationList = [];

		const processCampusPreference = (list, order) => {
			if (list.length > 0) {
				list.forEach((el) => {
					const newObj = {
						empApplnCampusPrefId: !ERPUtils.isUndefinedOrNull(el.empApplnCampusPrefId)
							? el.empApplnCampusPrefId
							: null,
						empApplnEntriesId:
							!ERPUtils.isUndefinedOrNull(saveDraftData) && !ERPUtils.isUndefinedOrNull(saveDraftData.empApplnEntriesId)
								? saveDraftData.empApplnEntriesId
								: null,
						erpCampusId: el.value,
						campusPreferenceOrder: order,
					};
					if (newObj?.erpCampusId) {
						preferredLocationList.push(newObj);
					}
				});
			}
		};

		// Process each list with the respective order
		processCampusPreference(userDetails.empApplnCampusPrefDTOList1, 1);
		processCampusPreference(userDetails.empApplnCampusPrefDTOList2, 2);
		processCampusPreference(userDetails.empApplnCampusPrefDTOList3, 3);


		if (userDetails.category !== '') {
			let construct = {
				empApplnSubjSpecializationPrefId:
					ERPUtils.isNullOrEmpty(saveDraftData) === false
						? ERPUtils.isNullOrEmpty(saveDraftData.jobDetailDTO) === false
							? ERPUtils.isNullOrEmpty(saveDraftData.jobDetailDTO.empApplnSubjectCategoryDTO) === false
								? saveDraftData.jobDetailDTO.empApplnSubjectCategoryDTO.length > 0
									? ERPUtils.isNullOrEmpty(
										saveDraftData.jobDetailDTO.empApplnSubjectCategoryDTO[0]
											.empApplnSubjSpecializationPrefId
									) === false
										? saveDraftData.jobDetailDTO.empApplnSubjectCategoryDTO[0]
											.empApplnSubjSpecializationPrefId
										: null
									: null
								: null
							: null
						: null,
				empApplnEntriesId:
					ERPUtils.isNullOrEmpty(saveDraftData) === false
						? ERPUtils.isNullOrEmpty(saveDraftData.empApplnEntriesId) === false
							? saveDraftData.empApplnEntriesId
							: null
						: null,
				subjectCategoryId: userDetails.category.value,
				subjectCategorySpecializationId: null
			};
			specializationObject.push(construct);
		} else {
			if (userDetails.Subject.length >= 0 && userDetails.Specialization.length >= 0) {
				let withSpecialzation = [];
				userDetails.Specialization.map((el) => {
					userDetails.Subject.map((item) => {
						if (el.subjectCategoryId === item.value) {
							let construct = {
								empApplnSubjSpecializationPrefId:
									ERPUtils.isNullOrEmpty(el.empApplnSubjSpecializationPrefId) === false
										? el.empApplnSubjSpecializationPrefId
										: null,
								empApplnEntriesId:
									ERPUtils.isNullOrEmpty(saveDraftData) === false
										? ERPUtils.isNullOrEmpty(saveDraftData.empApplnEntriesId) === false
											? saveDraftData.empApplnEntriesId
											: null
										: null,
								subjectCategoryId: item.value,
								subjectCategorySpecializationId: el.value
							};
							withSpecialzation.push(item.value);
							specializationObject.push(construct);
						}
						return '';
					});
					return '';
				});

				userDetails.Subject.map((el) => {
					if (withSpecialzation.includes(el.value) === false) {
						let construct = {
							empApplnSubjSpecializationPrefId:
								ERPUtils.isNullOrEmpty(el.empApplnSubjSpecializationPrefId) === false
									? el.empApplnSubjSpecializationPrefId
									: null,
							empApplnEntriesId:
								ERPUtils.isNullOrEmpty(saveDraftData) === false
									? ERPUtils.isNullOrEmpty(saveDraftData.empApplnEntriesId) === false
										? saveDraftData.empApplnEntriesId
										: null
									: null,
							subjectCategoryId: el.value,
							subjectCategorySpecializationId: null
						};
						if (ERPUtils.isNullOrEmpty(saveDraftData) === false) {
							if (ERPUtils.isNullOrEmpty(saveDraftData.jobDetailDTO) === false) {
								if (
									ERPUtils.isNullOrEmpty(saveDraftData.jobDetailDTO.empApplnSubjectCategoryDTO) ===
									false
								) {
									saveDraftData.jobDetailDTO.empApplnSubjectCategoryDTO.map((item) => {
										if (parseInt(el.value) === parseInt(item.subjectCategoryId)) {
											construct.empApplnSubjSpecializationPrefId =
												item.empApplnSubjSpecializationPrefId;
										}
										return '';
									});
								}
							}
						}
						return specializationObject.push(construct);
					}
					return '';
				});
			}
		}

		if (ERPUtils.isNullorWhiteSpace(userDetails.HighestQualification) === false) {
			EducationList.map((item) => {
				if (
					item.qualificationLevelDegreeOrder <= userDetails.HighestQualification.qualificationLevelDegreeOrder
				) {
					userDetails?.EducationDetailsObj[item.value]?.map((el) => {
						if (
							ERPUtils.isNullorWhiteSpace(el.Status.value) === false ||
							ERPUtils.isNullorWhiteSpace(el.Course) === false ||
							ERPUtils.isNullorWhiteSpace(el.Specialization) === false ||
							ERPUtils.isNullorWhiteSpace(el.YearOfComp.value) === false ||
							ERPUtils.isNullorWhiteSpace(el.Percentage) === false ||
							ERPUtils.isNullorWhiteSpace(el.Institute) === false ||
							ERPUtils.isNullorWhiteSpace(el.erpBoardOrUniversity) === false ||
							ERPUtils.isNullorWhiteSpace(el.erpInstitute) === false ||
							ERPUtils.isNullorWhiteSpace(el.countryId) === false ||
							(ERPUtils.isNullorWhiteSpace(el.stateId) === false ||
								ERPUtils.isNullorWhiteSpace(el.stateOther) === false) ||
							ERPUtils.isNullorWhiteSpace(el.Board) === false
						) {
							EducationDataList.push({
								empApplnEducationalDetailsId:
									ERPUtils.isUndefinedOrNull(el.empApplnEducationalDetailsId) === false
										? el.empApplnEducationalDetailsId
										: null,
								empApplnEntriesId:
									ERPUtils.isUndefinedOrNull(saveDraftData) === false
										? ERPUtils.isUndefinedOrNull(saveDraftData.empApplnEntriesId) === false
											? saveDraftData.empApplnEntriesId
											: null
										: null,
								qualificationLevelId:
									ERPUtils.isNullorWhiteSpace(item.value) === false ? item.value : null,
								currentStatus:
									ERPUtils.isNullorWhiteSpace(el.Status.value) === false
										? el.Status.value
										: null,
								course:
									ERPUtils.isNullorWhiteSpace(el.Course) === false ? el.Course : null,
								specialization:
									ERPUtils.isNullorWhiteSpace(el.Specialization) === false
										? el.Specialization
										: null,
								yearOfCompletion:
									ERPUtils.isNullorWhiteSpace(el.YearOfComp.value) === false
										? el.YearOfComp.value
										: null,
								gradeOrPercentage:
									ERPUtils.isNullorWhiteSpace(el.Percentage) === false
										? el.Percentage
										: null,
								institute:
									ERPUtils.isNullorWhiteSpace(el.Institute) === false
										? el.Institute
										: null,
								countryId:
									ERPUtils.isNullorWhiteSpace(el.countryId) === false
										? el.countryId
										: null,
								stateId:
									ERPUtils.isNullorWhiteSpace(el.stateId) === false
										? el.stateId
										: null,
								stateOther:
									ERPUtils.isNullorWhiteSpace(el.stateOther) === false
										? el.stateOther
										: null,
								boardOrUniversity:
									ERPUtils.isNullorWhiteSpace(el.Board) === false ? el.Board : null,
								erpInstitute:
									ERPUtils.isNullorWhiteSpace(el.erpInstitute) === false ? el.erpInstitute : null,
								erpBoardOrUniversity:
									ERPUtils.isNullorWhiteSpace(el.erpBoardOrUniversity) === false ? el.erpBoardOrUniversity : null,
								// documentList: mapImageData(el.Documents, 'education')
								documentList: ERPUtils.isNullorWhiteSpace(el.Documents) === false ? el.Documents : null,
							});
						}
						return '';
					});
				}
				return '';
			});

			userDetails.EligibilityTest.map((el) => {
				if (
					ERPUtils.isNullorWhiteSpace(el?.EligibilityTestName?.value) === false ||
					ERPUtils.isNullorWhiteSpace(el?.EligibilityYearOfComp?.value) === false
				) {
					EligibiltyDataList.push({
						empApplnEligibilityTestId:
							ERPUtils.isUndefinedOrNull(el.empApplnEligibilityTestId) === false
								? el.empApplnEligibilityTestId
								: null,
						empApplnEntriesId:
							ERPUtils.isUndefinedOrNull(saveDraftData) === false
								? ERPUtils.isUndefinedOrNull(saveDraftData.empApplnEntriesId) === false
									? saveDraftData.empApplnEntriesId
									: null
								: null,
						eligibilityTestId:
							ERPUtils.isNullorWhiteSpace(el.EligibilityTestName.value) === false
								? el.EligibilityTestName.value
								: null,
						testYear:
							ERPUtils.isNullorWhiteSpace(el.EligibilityYearOfComp.value) === false
								? el.EligibilityYearOfComp.value
								: null,
						// processCode:
						// ERPUtils.isUndefinedOrNull(el.processCode) === false
						// ? el.processCode
						// : null,
						// newFile:
						// ERPUtils.isUndefinedOrNull(el.newFile) === false
						// ? el.newFile
						// : null,
						// originalFileName:
						// ERPUtils.isUndefinedOrNull(el.originalFileName) === false
						// 	? el.originalFileName
						// 	: null,
						// 	uniqueFileName:
						// ERPUtils.isUndefinedOrNull(el.uniqueFileName) === false
						// 	? el.uniqueFileName
						// 	: null,
						// eligibilityTestDocumentsList: mapImageData(el.Documents, 'Eligibilty')
						eligibilityTestDocumentsList: ERPUtils.isUndefinedOrNull(el.Documents) === false
							? el.Documents
							: null,
					});
				}
				return '';
			});

			userDetails.others.map((el) => {
				if (
					ERPUtils.isNullorWhiteSpace(el.otherQualification) === false ||
					ERPUtils.isNullorWhiteSpace(el.otherStatus.value) === false ||
					ERPUtils.isNullorWhiteSpace(el.otherCourse) === false ||
					ERPUtils.isNullorWhiteSpace(el.otherSpecialization) === false ||
					ERPUtils.isNullorWhiteSpace(el.otherYearOfComp.value) === false ||
					ERPUtils.isNullorWhiteSpace(el.otherPercentage) === false ||
					ERPUtils.isNullorWhiteSpace(el.otherInstitute) === false ||
					ERPUtils.isNullorWhiteSpace(el.othercountryId) === false ||
					ERPUtils.isNullorWhiteSpace(el.otherstateId) === false ||
					ERPUtils.isNullorWhiteSpace(el.otherstateOther) === false ||
					ERPUtils.isNullorWhiteSpace(el.otherBoard) === false
				) {
					OtherEducationDataList.push({
						empApplnEducationalDetailsId:
							ERPUtils.isUndefinedOrNull(el.empApplnEducationalDetailsId) === false
								? el.empApplnEducationalDetailsId
								: null,
						empApplnEntriesId:
							ERPUtils.isUndefinedOrNull(saveDraftData) === false
								? ERPUtils.isUndefinedOrNull(saveDraftData.empApplnEntriesId) === false
									? saveDraftData.empApplnEntriesId
									: null
								: null,
						qualificationOthers:
							ERPUtils.isNullorWhiteSpace(el.otherQualification) === false ? el.otherQualification : null,
						currentStatus:
							ERPUtils.isNullorWhiteSpace(el.otherStatus.value) === false ? el.otherStatus.value : null,
						course: ERPUtils.isNullorWhiteSpace(el.otherCourse) === false ? el.otherCourse : null,
						specialization:
							ERPUtils.isNullorWhiteSpace(el.otherSpecialization) === false
								? el.otherSpecialization
								: null,
						yearOfCompletion:
							ERPUtils.isNullorWhiteSpace(el.otherYearOfComp.value) === false
								? el.otherYearOfComp.value
								: null,
						othercountryId:
							ERPUtils.isNullorWhiteSpace(el.countryId) === false
								? el.othercountryId
								: null,
						otherstateId:
							ERPUtils.isNullorWhiteSpace(el.stateId) === false
								? el.otherstateId
								: null,
						otherstateOther:
							ERPUtils.isNullorWhiteSpace(el.otherstateOther) === false
								? el.otherstateOther
								: null,
						gradeOrPercentage:
							ERPUtils.isNullorWhiteSpace(el.otherPercentage) === false ? el.otherPercentage : null,
						institute: ERPUtils.isNullorWhiteSpace(el.otherInstitute) === false ? el.otherInstitute : null,
						boardOrUniversity: ERPUtils.isNullorWhiteSpace(el.otherBoard) === false ? el.otherBoard : null,
						// documentList: mapImageData(el.Documents, 'education')
						documentList: ERPUtils.isNullorWhiteSpace(el.Documents) === false ? el.Documents : null,
					});
				}
				return '';
			});
		}

		// professional Details:
		professionalDetails.map((el, idx) => {
			if (
				ERPUtils.isNullorWhiteSpace(el?.ExperienceType?.value) === false ||
				ERPUtils.isNullorWhiteSpace(el?.functionalArea?.value) === false ||
				ERPUtils.isNullorWhiteSpace(el?.OtherFunctionalArea) === false ||
				ERPUtils.isNullorWhiteSpace(el?.EmpType?.value) === false ||
				ERPUtils.isNullorWhiteSpace(el?.designation) === false ||
				ERPUtils.isNullorWhiteSpace(el?.fromDate) === false ||
				ERPUtils.isNullorWhiteSpace(el?.ToDate) === false ||
				ERPUtils.isNullorWhiteSpace(el?.institution) === false
			) {
				ProfessionalDataList.push({
					empApplnEntriesId:
						ERPUtils.isUndefinedOrNull(saveDraftData) === false
							? ERPUtils.isUndefinedOrNull(saveDraftData.empApplnEntriesId) === false
								? saveDraftData.empApplnEntriesId
								: null
							: null,
					empApplnWorkExperienceId:
						ERPUtils.isNullorWhiteSpace(el.empApplnWorkExperienceId) === false
							? el.empApplnWorkExperienceId
							: null,
					workExperienceTypeId:
						ERPUtils.isNullorWhiteSpace(el?.ExperienceType?.value) === false ? el?.ExperienceType?.value : null,
					functionalAreaId:
						el?.functionalArea !== '' || null || undefined
							? el?.functionalArea?.label === 'Others' ? null : el?.functionalArea?.value
							: null,
					functionalAreaOthers:
						ERPUtils.isNullorWhiteSpace(el.OtherFunctionalArea) === false ? el.OtherFunctionalArea : null,
					employmentType: ERPUtils.isNullorWhiteSpace(el?.EmpType?.value) === false ? el?.EmpType?.value : null,
					designation: ERPUtils.isNullorWhiteSpace(el?.designation) === false ? el?.designation : null,
					fromDate: ERPUtils.isNullorWhiteSpace(el?.fromDate) === false ? ERPUtils.convertDateObjToLocaleDate(el?.fromDate) : null,
					toDate: ERPUtils.isNullorWhiteSpace(el?.ToDate) === false ? ERPUtils.convertDateObjToLocaleDate(el?.ToDate) : null,
					years: ERPUtils.isNullorWhiteSpace(el?.TotalYears) === false ? el?.TotalYears : null,
					months: ERPUtils.isNullorWhiteSpace(el?.TotalMonths) === false ? el?.TotalMonths : null,
					institution: ERPUtils.isNullorWhiteSpace(el?.institution) === false ? el?.institution : null,
					experienceDocumentList: ERPUtils.isUndefinedOrNull(el?.experienceDocumentList) === false
						? el.experienceDocumentList
						: null,
					// processCode:
					// 			ERPUtils.isUndefinedOrNull(el.processCode) === false
					// 			? el.processCode
					// 			: null,
					// 			newFile:
					// 			ERPUtils.isUndefinedOrNull(el.newFile) === false
					// 			? el.newFile
					// 			: null,
					// 			originalFileName:
					// 			ERPUtils.isUndefinedOrNull(el.originalFileName) === false
					// 				? el.originalFileName
					// 				: null,
					// 				uniqueFileName:
					// 			ERPUtils.isUndefinedOrNull(el.uniqueFileName) === false
					// 				? el.uniqueFileName
					// 				: null,
					// experienceDocumentList: mapImageData(userDetails.PrevExpDocuments[idx].Documents, 'professional')
					// experienceDocumentList: ERPUtils.isUndefinedOrNull(el?.PrevExpDocuments[idx]?.Documents) === false /////////////////////////////////////CHANGE HEREEEEE ***
					// 				? el.PrevExpDocuments[idx]?.Documents
					// 				: null,
				});
			}
			return '';
		});

		// Research details:
		ResearchData.map((el) => {
			if (el.isTypeResearch === (true || 'true') && el.employeeCategoryId === userDetails.Post.value) {
				if (el.detailsDTO.length > 0) {
					let construct = {
						id: ERPUtils.isNullorWhiteSpace(el.value) === false ? el.value : null,
						isTypeResearch:
							ERPUtils.isNullorWhiteSpace(el.isTypeResearch) === false ? el.isTypeResearch : null,
						category: {
							id:
								ERPUtils.isNullorWhiteSpace(el.employeeCategoryId) === false
									? el.employeeCategoryId
									: null
						},
						groupHeading: ERPUtils.isNullorWhiteSpace(el.label) === false ? el.label : null,
						displayOrder:
							ERPUtils.isNullorWhiteSpace(el.headingDisplayOrder) === false
								? el.headingDisplayOrder
								: null,
						parameters: []
					};

					el.detailsDTO.map((item) => {
						if (ERPUtils.isNullorWhiteSpace(userDetails.ResearchDetailsData[el.label]) === false) {
							if (
								ERPUtils.isNullorWhiteSpace(userDetails.ResearchDetailsData[el.label][item.label]) ===
								false
							) {
								construct.parameters.push({
									id: item.value,
									empApplnAddtnlInfoEntriesId: getSaveDraftIds(el.label, item.label, 'addInfo'),
									empApplnEntriesId:
										ERPUtils.isUndefinedOrNull(saveDraftData) === false
											? ERPUtils.isUndefinedOrNull(saveDraftData.empApplnEntriesId) === false
												? saveDraftData.empApplnEntriesId
												: null
											: null,
									displayOrder:
										ERPUtils.isNullorWhiteSpace(item.parameterDisplayOrder) === false
											? item.parameterDisplayOrder
											: null,
									researchParameter:
										ERPUtils.isNullorWhiteSpace(item.headingDisplayOrder) === false
											? item.label
											: null,
									isDisplayInApplication:
										ERPUtils.isNullorWhiteSpace(item.isDisplayInApplication) === false
											? item.isDisplayInApplication
											: null,
									parameterValue:
										ERPUtils.isUndefinedOrNull(userDetails.ResearchDetailsData[el.label]) === false
											? userDetails.ResearchDetailsData[el.label][item.label]
											: null
								});
							}
						}
						return '';
					});
					return construct.parameters.length > 0 ? ResearchDataList.push(construct) : null;
				}
			}
			return '';
		});
		SendDataToApi(
			EducationDataList,
			EligibiltyDataList,
			OtherEducationDataList,
			ResearchDataList,
			ProfessionalDataList,
			specializationObject,
			type,
			preferredLocationList
		);
		return '';
	};

	// Sending Data to APi:
	const SendDataToApi = (
		EducationData,
		eligibiltiyData,
		otherEducationData,
		researchDataList,
		ProfessionalDataList,
		specializationObject,
		type,
		preferredLocationList
	) => {
		console.log(jobCode)
		const SaveDataObject = {
			saveMode: type,
			applicationNo: null,
			// empApplicationRegistrationId: sessionStorage.getItem('RegistrationId'),
			empApplicationRegistrationId: !ERPUtils.isNullorWhiteSpace(registrationId) ? registrationId : sessionStorage.getItem('registrationID'),
			empApplnEntriesId:
				ERPUtils.isUndefinedOrNull(saveDraftData) === false
					? ERPUtils.isUndefinedOrNull(saveDraftData.empApplnEntriesId) === false
						? saveDraftData.empApplnEntriesId
						: null
					: null,
			jobCategoryDTO:
				ERPUtils.isNullorWhiteSpace(userDetails.jobCategoryDTO?.value) === false
					? userDetails.jobCategoryDTO
					: null,
			jobDetailDTO:
				ERPUtils.isNullorWhiteSpace(userDetails.Post.value) === false ||
					userDetails.Subject.length > 0 ||
					userDetails.Specialization.length > 0 ||
					specializationObject.length > 0 ||
					preferredLocationList.length > 0
					? {
						advertisementNo: !ERPUtils.isNullorWhiteSpace(jobCode) ?
							jobCode : null,
						postAppliedFor:
							ERPUtils.isNullorWhiteSpace(userDetails.Post.value) === false
								? userDetails.Post.value
								: null,
						subjectCategoryIds:
							userDetails.Subject.length > 0
								? [
									userDetails.Subject.map((el) => {
										return el.value;
									})
								]
								: userDetails.category !== '' ? [userDetails.category.value] : null,
						specializationIds:
							userDetails.Specialization.length > 0
								? [
									userDetails.Specialization.map((el) => {
										return el.value;
									})
								]
								: null,
						empApplnSubjectCategoryDTO:
							specializationObject.length > 0 ? [...specializationObject] : null,
						// preferredLocationIds: preferredLocationList.length > 0 ? [...preferredLocationList] : null
						empApplnCampusPrefDTOList: preferredLocationList.length > 0 ? [...preferredLocationList] : null

					}
					: null,
			// PersonalDetails:
			empApplnPersonalDataDTO:
				ERPUtils.isNullorWhiteSpace(userDetails.Name) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.Gender.value) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.FatherName) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.motherName) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.DOB) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.Email) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.mobileNo) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.AltNo) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.AadharNo) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.marital.value) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.Nationality.value) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.PassportNo) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.Religion.value) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.Minority) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.Reservation.value) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.BloodGroup.value) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.DiffAbled) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.DifferentlyAbledType.value) === false
					? {
						empApplnPersonalDataId:
							ERPUtils.isUndefinedOrNull(saveDraftData) === false
								? ERPUtils.isUndefinedOrNull(saveDraftData.empApplnPersonalDataDTO) === false
									? saveDraftData.empApplnPersonalDataDTO.empApplnPersonalDataId
									: null
								: null,
						empApplnEntriesId:
							ERPUtils.isUndefinedOrNull(saveDraftData) === false
								? ERPUtils.isUndefinedOrNull(saveDraftData.empApplnEntriesId) === false
									? saveDraftData.empApplnEntriesId
									: null
								: null,
						// profilePhotoUrl:
						// 	userDetails.ResearchDetailsImg[0].Documents.length > 0
						// 		? userDetails.ResearchDetailsImg[0].Documents[0].fileName !==
						// 			(undefined && null && '')
						// 			? userDetails.ResearchDetailsImg[0].Documents[0].fileName
						// 			: null
						// 		: null,
						originalFileName:
							userDetails.profilePhoto?.length > 0
								? userDetails.profilePhoto[0].originalFileName !==
									(undefined && null && '')
									? userDetails.profilePhoto[0].originalFileName
									: null
								: null,
						uniqueFileName:
							userDetails.profilePhoto?.length > 0
								? userDetails.profilePhoto[0].uniqueFileName !==
									(undefined && null && '')
									? userDetails.profilePhoto[0].uniqueFileName
									: null
								: null,
						newFile:
							userDetails.profilePhoto?.length > 0
								? userDetails.profilePhoto[0].newFile !==
									(undefined && null && '')
									? userDetails.profilePhoto[0].newFile
									: null
								: null,
						preSignedUrl:
							userDetails.profilePhoto?.length > 0
								? userDetails.profilePhoto[0].preSignedUrl !==
									(undefined && null && '')
									? userDetails.profilePhoto[0].preSignedUrl
									: null
								: null,
						processCode:
							userDetails.profilePhoto?.length > 0
								? userDetails.profilePhoto[0].processCode !==
									(undefined && null && '')
									? userDetails.profilePhoto[0].processCode
									: null
								: null,
						tempPath:
							userDetails.profilePhoto?.length > 0
								? userDetails.profilePhoto[0].tempPath !==
									(undefined && null && '')
									? userDetails.profilePhoto[0].tempPath
									: null
								: null,

						resumeUploadDTO:
							userDetails.resume?.length > 0
								? {
									originalFileName: userDetails.resume[0]?.originalFileName ?? null,
									uniqueFileName: userDetails.resume[0]?.uniqueFileName ?? null,
									newFile: userDetails.resume[0]?.newFile ?? null,
									preSignedUrl: userDetails.resume[0]?.preSignedUrl ?? null,
									processCode: userDetails.resume[0]?.processCode ?? null,
									tempPath: userDetails.resume[0]?.tempPath ?? null,
								}
								: null,


						applicantName:
							ERPUtils.isNullorWhiteSpace(userDetails.Name) === false ? userDetails.Name : null,
						genderId:
							ERPUtils.isNullorWhiteSpace(userDetails.Gender.value) === false
								? userDetails.Gender.value
								: null,
						fatherName:
							ERPUtils.isNullorWhiteSpace(userDetails.FatherName) === false
								? userDetails.FatherName
								: null,
						motherName:
							ERPUtils.isNullorWhiteSpace(userDetails.MotherName) === false
								? userDetails.MotherName
								: null,
						dateOfBirth: ERPUtils.isNullorWhiteSpace(userDetails.DOB) === false ? userDetails.DOB : null,
						emailId: ERPUtils.isNullorWhiteSpace(userDetails.Email) === false ? userDetails.Email : null,
						mobileNoCountryCode:
							userDetails.CountryCodeEnt !== '' || userDetails.CountryCode?.value === "Other"
								? userDetails.CountryCodeEnt
								: userDetails.CountryCode.value,
						mobileNo:
							ERPUtils.isNullorWhiteSpace(userDetails.mobileNo) === false ? userDetails.mobileNo : null,
						alternateNo:
							ERPUtils.isNullorWhiteSpace(userDetails.AltNo) === false ? userDetails.AltNo : null,
						aadharNo:
							ERPUtils.isNullorWhiteSpace(userDetails.AadharNo) === false ? userDetails.AadharNo : null,
						maritalStatusId:
							ERPUtils.isNullorWhiteSpace(userDetails.marital.value) === false
								? userDetails.marital.value
								: null,
						nationalityId:
							ERPUtils.isNullorWhiteSpace(userDetails.Nationality.value) === false
								? userDetails.Nationality.value
								: null,
						passportNo:
							ERPUtils.isNullorWhiteSpace(userDetails.PassportNo) === false
								? userDetails.PassportNo
								: null,
						religionId:
							ERPUtils.isNullorWhiteSpace(userDetails.Religion.value) === false
								? userDetails.Religion.value
								: null,
						isMinority:
							ERPUtils.isNullorWhiteSpace(userDetails.Minority) === false ? userDetails.Minority : null,
						reservationCategoryId:
							ERPUtils.isNullorWhiteSpace(userDetails.Reservation.value) === false
								? userDetails.Reservation.value
								: null,
						bloodGroupId:
							ERPUtils.isNullorWhiteSpace(userDetails.BloodGroup.value) === false
								? userDetails.BloodGroup.value
								: null,
						isDifferentlyAbled:
							ERPUtils.isNullorWhiteSpace(userDetails.DiffAbled) === false
								? userDetails.DiffAbled
								: null,
						differentlyAbledId:
							ERPUtils.isNullorWhiteSpace(userDetails.DifferentlyAbledType.value) === false
								? userDetails.DifferentlyAbledType.value
								: null,
						differentlyAbledDetails: null
					}
					: null,
			// Address details:
			addressDetailDTO:
				ERPUtils.isNullorWhiteSpace(userDetails.currentLine1) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.currentLine2) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.currentCountry.value) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.currentState.value) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.otherCurrState) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.currentCity.value) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.otherCurrCity) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.currentPincode) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.permanentLine1) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.permanentLine2) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.permanentCountry.value) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.otherPermState) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.permanentState.value) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.otherPermCity) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.permanentCity.value) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.permanentPincode) === false
					? {
						empApplnPersonalDataId:
							ERPUtils.isUndefinedOrNull(saveDraftData) === false
								? ERPUtils.isUndefinedOrNull(saveDraftData.addressDetailDTO) === false
									? saveDraftData.addressDetailDTO.empApplnPersonalDataId
									: null
								: null,
						empApplnEntriesId:
							ERPUtils.isUndefinedOrNull(saveDraftData) === false
								? ERPUtils.isUndefinedOrNull(saveDraftData.empApplnEntriesId) === false
									? saveDraftData.empApplnEntriesId
									: null
								: null,
						currentAddressLine1:
							ERPUtils.isNullorWhiteSpace(userDetails.currentLine1) === false
								? userDetails.currentLine1
								: null,
						currentAddressLine2:
							ERPUtils.isNullorWhiteSpace(userDetails.currentLine2) === false
								? userDetails.currentLine2
								: null,
						currentCountryId:
							ERPUtils.isNullorWhiteSpace(userDetails.currentCountry.value) === false
								? userDetails.currentCountry.value
								: null,
						currentStateId:
							ERPUtils.isNullorWhiteSpace(userDetails.currentState) === false
								? userDetails.currentState.value === 'Others' ? null : typeof (userDetails.currentState) === 'object' ? userDetails.currentState.value : userDetails.currentState
								: null,
						currentStateOthers:
							ERPUtils.isNullorWhiteSpace(userDetails.otherCurrState) === false
								? userDetails.otherCurrState
								: null,
						currentCityId:
							ERPUtils.isNullorWhiteSpace(userDetails.currentCity) === false
								? userDetails.currentCity.value === 'Others' ? null : typeof (userDetails.currentCity) === 'object' ? userDetails.currentCity.value : userDetails.currentCity
								: null,
						currentCityOthers:
							ERPUtils.isNullorWhiteSpace(userDetails.otherCurrCity) === false
								? userDetails.otherCurrCity
								: null,
						currentPincode:
							ERPUtils.isNullorWhiteSpace(userDetails.currentPincode) === false
								? userDetails.currentPincode
								: null,
						isPermanentEqualsCurrent:
							ERPUtils.isNullorWhiteSpace(userDetails.curAddSameAsPer) === false
								? userDetails.curAddSameAsPer
								: null,
						permanentAddressLine1:
							ERPUtils.isNullorWhiteSpace(userDetails.permanentLine1) === false
								? userDetails.permanentLine1
								: null,
						permanentAddressLine2:
							ERPUtils.isNullorWhiteSpace(userDetails.permanentLine2) === false
								? userDetails.permanentLine2
								: null,
						permanentCountryId:
							ERPUtils.isNullorWhiteSpace(userDetails.permanentCountry.value) === false
								? userDetails.permanentCountry.value
								: null,
						permanentStateOthers:
							ERPUtils.isNullorWhiteSpace(userDetails.otherPermState) === false
								? userDetails.otherPermState
								: null,
						permanentStateId:
							ERPUtils.isNullorWhiteSpace(userDetails.permanentState) === false
								? userDetails.permanentState.value === 'Others'
									? null
									: typeof (userDetails.permanentState) === 'object' ? userDetails.permanentState.value : userDetails.permanentState
								: null,
						permanentCityOthers:
							ERPUtils.isNullorWhiteSpace(userDetails.otherPermCity) === false
								? userDetails.otherPermCity
								: null,
						permanentCityId:
							ERPUtils.isNullorWhiteSpace(userDetails.permanentCity) === false
								? userDetails.permanentCity.value === 'Others'
									? null
									: typeof (userDetails.permanentCity) === 'object' ? userDetails.permanentCity.value : userDetails.permanentCity
								: null,
						permanentPincode:
							ERPUtils.isNullorWhiteSpace(userDetails.permanentPincode) === false
								? userDetails.permanentPincode
								: null
					}
					: null,
			// Educational details:
			educationalDetailDTO:
				ERPUtils.isNullorWhiteSpace(userDetails.HighestQualification.value) === false
					? {
						highestQualificationLevelId:
							ERPUtils.isNullorWhiteSpace(userDetails.HighestQualification.value) === false
								? userDetails.HighestQualification.value
								: null,
						qualificationLevelsList: EducationData.length > 0 ? [...EducationData] : null,
						eligibilityTestList: eligibiltiyData.length > 0 ? [...eligibiltiyData] : null,
						otherQualificationLevelsList: otherEducationData.length > 0 ? [...otherEducationData] : null
					}
					: null,
			professionalExperienceDTO:
				ERPUtils.isNullorWhiteSpace(userDetails.currentWorking) === false ||
					ProfessionalDataList.length > 0 ||
					ERPUtils.isNullorWhiteSpace(userDetails.majorAchievements) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.expSalary) === false
					? {
						isCurrentlyWorking:
							ERPUtils.isNullorWhiteSpace(userDetails.currentWorking) === false
								? userDetails.currentWorking
								: null,
						currentExperience:
							ERPUtils.isNullorWhiteSpace(userDetails.currentWorking) === false
								? userDetails.currentWorking === 'Yes'
									? ERPUtils.isNullorWhiteSpace(userDetails.currentExperienceType.value) === false ||
										ERPUtils.isNullorWhiteSpace(userDetails.currentFunctionalArea.label) === false ||
										ERPUtils.isNullorWhiteSpace(userDetails.currentOtherFunctionalArea) === false ||
										ERPUtils.isNullorWhiteSpace(userDetails.currentEmpType.value) === false ||
										ERPUtils.isNullorWhiteSpace(userDetails.currentFromDate) === false ||
										ERPUtils.isNullorWhiteSpace(userDetails.currentNoticePeriod) === false ||
										ERPUtils.isNullorWhiteSpace(userDetails.currentSalary) === false ||
										ERPUtils.isNullorWhiteSpace(userDetails.institution) === false
										? {
											empApplnWorkExperienceId:
												ERPUtils.isUndefinedOrNull(saveDraftData) === false
													? ERPUtils.isUndefinedOrNull(userDetails.CurrentEmpApplnWorkExperienceId) ===
														false
														? userDetails.CurrentEmpApplnWorkExperienceId
														: null
													: null,
											empApplnEntriesId:
												ERPUtils.isUndefinedOrNull(saveDraftData) === false
													? ERPUtils.isUndefinedOrNull(saveDraftData.empApplnEntriesId) ===
														false
														? saveDraftData.empApplnEntriesId
														: null
													: null,
											workExperienceTypeId:
												ERPUtils.isNullorWhiteSpace(userDetails.currentExperienceType.value) ===
													false
													? userDetails.currentExperienceType.value
													: null,
											functionalAreaId:
												ERPUtils.isNullorWhiteSpace(userDetails.currentFunctionalArea) === false
													? userDetails.currentFunctionalArea.label === 'Others'
														? null
														: userDetails.currentFunctionalArea.value
													: null,
											functionalAreaOthers:
												ERPUtils.isNullorWhiteSpace(userDetails.currentOtherFunctionalArea) ===
													false
													? userDetails.currentOtherFunctionalArea
													: null,
											employmentType:
												ERPUtils.isNullorWhiteSpace(userDetails.currentEmpType.value) === false
													? userDetails.currentEmpType.value
													: null,
											designation:
												ERPUtils.isNullorWhiteSpace(userDetails.currentDesignation) === false
													? userDetails.currentDesignation
													: null,
											fromDate:
												ERPUtils.isNullorWhiteSpace(userDetails.currentFromDate) === false
													? ERPUtils.convertDateObjToLocaleDate(userDetails.currentFromDate)
													: null,
											toDate:
												ERPUtils.isNullorWhiteSpace(userDetails.currentToDate) === false
													? ERPUtils.convertDateObjToLocaleDate(userDetails.currentToDate)
													: null,
											years:
												ERPUtils.isNullorWhiteSpace(userDetails.currentTotalYears) === false
													? userDetails.currentTotalYears
													: null,
											months:
												ERPUtils.isNullorWhiteSpace(userDetails.currentTotalMonths) === false
													? userDetails.currentTotalMonths
													: null,
											noticePeriod:
												ERPUtils.isNullorWhiteSpace(userDetails.currentNoticePeriod) === false
													? userDetails.currentNoticePeriod
													: null,
											currentSalary:
												ERPUtils.isNullorWhiteSpace(userDetails.currentSalary) === false
													? userDetails.currentSalary
													: null,
											institution:
												ERPUtils.isNullorWhiteSpace(userDetails.currentInstitute) === false
													? userDetails.currentInstitute
													: null,
											// uniqueFileName:
											// ERPUtils.isUndefinedOrNull(userDetails.uniqueFileName) === false
											// 	? userDetails.uniqueFileName
											// 	: null,
											// processCode:
											// ERPUtils.isUndefinedOrNull(userDetails.processCode) === false
											// 	? userDetails.processCode
											// 	: null,
											// newFile:
											// ERPUtils.isUndefinedOrNull(userDetails.newFile) === false
											// 	? userDetails.newFile
											// 	: null,
											// originalFileName:
											// 	ERPUtils.isUndefinedOrNull(userDetails.originalFileName) === false
											// 		? userDetails.originalFileName
											// 		: null,
											// experienceDocumentList: mapImageData(
											// 	userDetails.CurrentExpDocuments[0].Documents,
											// 	'professional'
											// )
											experienceDocumentList: ERPUtils.isUndefinedOrNull(userDetails?.CurrentExpDocuments) === false
												? userDetails?.CurrentExpDocuments
												: [],
										}
										: null
									: null
								: null,
						professionalExperienceList:
							ProfessionalDataList.length > 0 ?
								[...ProfessionalDataList]
								: null,
						totalPreviousExperienceYears:
							ERPUtils.isNullorWhiteSpace(userDetails.currentFromDate) === false ||
								ProfessionalDataList.length > 0
								? ERPUtils.isNullorWhiteSpace(userDetails.TotalFullTimeYearsExp) === false
									? userDetails.TotalFullTimeYearsExp
									: null
								: null,
						totalPreviousExperienceMonths:
							ERPUtils.isNullorWhiteSpace(userDetails.currentFromDate) === false ||
								ProfessionalDataList.length > 0
								? ERPUtils.isNullorWhiteSpace(userDetails.TotalFullTimeMonthsExp) === false
									? userDetails.TotalFullTimeMonthsExp
									: null
								: null,
						totalPartTimePreviousExperienceYears:
							ERPUtils.isNullorWhiteSpace(userDetails.currentFromDate) === false ||
								ProfessionalDataList.length > 0
								? ERPUtils.isNullorWhiteSpace(userDetails.TotalPartTimeYearsExp) === false
									? userDetails.TotalPartTimeYearsExp
									: null
								: null,
						totalPartTimePreviousExperienceMonths:
							ERPUtils.isNullorWhiteSpace(userDetails.currentFromDate) === false ||
								ProfessionalDataList.length > 0
								? ERPUtils.isNullorWhiteSpace(userDetails.TotalPartTimeMonthsExp) === false
									? userDetails.TotalPartTimeMonthsExp
									: null
								: null,
						majorAchievements:
							ERPUtils.isNullorWhiteSpace(userDetails.majorAchievements) === false
								? userDetails.majorAchievements
								: null,
						expectedSalary:
							ERPUtils.isNullorWhiteSpace(userDetails.expSalary) === false
								? userDetails.expSalary
								: null
					}
					: null,
			researchDetailDTO:
				ERPUtils.isNullorWhiteSpace(userDetails.ResearchExperience) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.orcidId) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.vidwanId) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.scopusPaperNumber) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.hIndex) === false ||
					researchDataList.length > 0 ||
					ERPUtils.isNullorWhiteSpace(userDetails.interviewedBefore) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.InterviewedDept) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.InterviewedYear) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.InterviewedApplNo) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.InterviewedSubject) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.vacancySource.value) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.SourceOthers) === false ||
					ERPUtils.isNullorWhiteSpace(userDetails.OtherInformation) === false
					? {
						isResearchExperience:
							ERPUtils.isNullorWhiteSpace(userDetails.ResearchExperience) === false
								? userDetails.ResearchExperience
								: null,
						orcidId:
							ERPUtils.isNullorWhiteSpace(userDetails.orcidId) === false ? userDetails.orcidId : null,
						inflibnetVidwanNo:
							ERPUtils.isNullorWhiteSpace(userDetails.vidwanId) === false ? userDetails.vidwanId : null,
						scopusId:
							ERPUtils.isNullorWhiteSpace(userDetails.scopusPaperNumber) === false
								? userDetails.scopusPaperNumber
								: null,
						hIndex: ERPUtils.isNullorWhiteSpace(userDetails.hIndex) === false ? userDetails.hIndex : null,
						researchEntries: {
							researchEntriesHeadings: researchDataList.length > 0 ? [...researchDataList] : null
						},
						isInterviewedBefore:
							ERPUtils.isNullorWhiteSpace(userDetails.interviewedBefore) === false
								? userDetails.interviewedBefore
								: null,
						interviewedBeforeDepartment:
							ERPUtils.isNullorWhiteSpace(userDetails.InterviewedDept) === false
								? userDetails.InterviewedDept
								: null,
						interviewedBeforeYear:
							ERPUtils.isNullorWhiteSpace(userDetails.InterviewedYear) === false
								? userDetails.InterviewedYear
								: null,
						interviewedBeforeApplicationNo:
							ERPUtils.isNullorWhiteSpace(userDetails.InterviewedApplNo) === false
								? userDetails.InterviewedApplNo
								: null,
						interviewedBeforeSubject:
							ERPUtils.isNullorWhiteSpace(userDetails.InterviewedSubject) === false
								? userDetails.InterviewedSubject
								: null,
						vacancyInformationId:
							ERPUtils.isNullorWhiteSpace(userDetails.vacancySource.value) === false
								? userDetails.vacancySource.value
								: null,
						// Newly added vacancyInformationCode for Job advertisement selection..
						// vacancyInformationCode:
						// 	(ERPUtils.isNullorWhiteSpace(userDetails.vacancySource?.value) === false && userDetails.vacancySource?.value === "1")
						// 		? "ADV" : null,
						aboutVacancyOthers:
							ERPUtils.isNullorWhiteSpace(userDetails.SourceOthers) === false
								? userDetails.SourceOthers
								: null,
						otherInformation:
							ERPUtils.isNullorWhiteSpace(userDetails.OtherInformation) === false
								? userDetails.OtherInformation
								: null
					}
					: null
		};
		setLoaderActive(true);
		ApiGateway.post(
			'Employee/Recruitment/EmployeeApplicationControler/submitEmployeeApplication',
			SaveDataObject,
			(response) => {
				try {
					if (ERPUtils.isNullorWhiteSpace(response?.data?.failureMessage)) {
						if (response?.data?.success === true) {
							if (type === 'save draft') {
								console.log("first")
								// CallafterSaveDraft(response.data.dto.empApplnEntriesId); 
								setSaveTheData(false);
								callSaveDraftApi(commonApiResponse, true, response.data.dto?.identityRow)
								popupOnDraftSuccess(true);
								setLoaderActive(false);
								// THIS NEED TO BE CHANGED AS NO UPDATED IDS ARE STORED
							}
							if (type === 'save') {
								SubmitSuccess();
								setCallDraft(false);
								setCallDraftApplNo('');
							}
						} else {
							setErrorMsg('Error occurred while saving the data, please try again!');
							AlertError();
							setLoaderActive(false);
						}
					} else {
						setErrorMsg(response?.data?.failureMessage);
						AlertError();
						setLoaderActive(false);
					}
				} catch (ex) {
					setLoaderActive(false);
					setErrorMsg('Error occurred while saving the data, please try again!');
					AlertError();
				}
			}
		);
		return '';
	};

	// For calling save draft after the savedraft is done
	// const CallafterSaveDraft = (id) => {
	// 	setLoaderActive(true);
	// 	ApiGateway.post(
	// 		'Employee/Recruitment/EmployeeApplicationControler/getEmployeeApplication?empApplnEntriesId=' + id,
	// 		{},
	// 		(response) => {
	// 			try {
	// 				if (ERPUtils.isNullorWhiteSpace(response.data.failureMessage)) {
	// 					if (response.data.success === true) {
	// 						setSaveDraftData(response.data.dto);
	// 						popupOnDraftSuccess(true);
	// 					} else {
	// 						ApplicationLoadingError('SaveDraft', 'Error! Failed to get the data.');
	// 					}
	// 				} else {
	// 					ApplicationLoadingError('SaveDraft', response.data.failureMessage);
	// 				}
	// 				setLoaderActive(false);
	// 			} catch (ex) {
	// 				setLoaderActive(false);
	// 				ApplicationLoadingError('SaveDraft', 'Error! Failed to get the data.');
	// 			} finally {
	// 				setLoaderActive(false);
	// 			}
	// 		}
	// 	);
	// };

	// For calling save draft Api from the dashboard
	// const [data,setData]=useS
	const callSaveDraftApi = (responses, isSaveDraftFromScreen, entriesID) => {
		if (CallDraft || isSaveDraftFromScreen) {
			const ID = !ERPUtils.isNullorWhiteSpace(entriesID) ? entriesID : CallDraftApplNo
			setLoaderActive(true);
			ApiGateway.post(
				'Employee/Recruitment/EmployeeApplicationControler/getEmployeeApplication?empApplnEntriesId=' +
				ID,
				{},
				(response) => {
					try {
						// let newSavedData = ERPUtils.isNullorWhiteSpace(saveDraftData)
						if (ERPUtils.isNullorWhiteSpace(response?.data?.failureMessage)) {
							if (response?.data?.success === true) {
								// newSavedData = response.data.dto
								// newSavedData.jobDetailDTO.advertisementNo = ERPUtils.isNullOrEmpty(response.data.dto?.jobDetailDTO?.advertisementNo) ?
								// 	jobCode?.id : response.data.dto?.jobDetailDTO?.advertisementNo
								// console.log(newSavedData, "news")
								setSaveDraftData(response.data.dto);
								saveProfessionalData(response.data.dto, responses, isSaveDraftFromScreen);
							} else {
								ApplicationLoadingError('SaveDraft', 'Error! Failed to get the data.');
							}
						} else {
							ApplicationLoadingError('SaveDraft', response?.data?.failureMessage);
						}
						setLoaderActive(false);
					} catch (ex) {
						setLoaderActive(false);
						ApplicationLoadingError('SaveDraft', 'Error! Failed to get the data.');
					}
				}
			);
		}
	};
	//for calling prev data api:
	const LoadPrevData = (responses) => {
		if (applyNew) {
			// let id = !ERPUtils.isNullorWhiteSpace(registrationId)?registrationId:sessionStorage.getItem('registrationID')
			setLoaderActive(true);
			ApiGateway.post(
				'Employee/Recruitment/EmployeeApplicationControler/getApplicantDetailsFromPrevApplication',
				{},
				(response) => {
					try {
						if (ERPUtils.isNullorWhiteSpace(response?.data?.failureMessage)) {
							if (response.data.success === true) {
								if (ERPUtils.isNullorWhiteSpace(response?.data?.dto) === false) {
									setEditable(
										ERPUtils.isNullorWhiteSpace(response?.data?.dto?.empApplnPersonalDataDTO) === false
											? ERPUtils.isNullorWhiteSpace(
												response?.data?.dto?.empApplnPersonalDataDTO?.applicantName
											) === false
												? false
												: true
											: true
									);
									// saveProfessionalData(response.data.dto, responses);
								} else {
									setParseResumeData(true)
									setLoaderActive(false);
								}
								setLoaderActive(false);
								setSaveDraftData(response?.data?.dto);
								saveProfessionalData(response?.data?.dto, responses);
							} else {
								setLoaderActive(false);
								setErrorMsg('Something went wrong, Please try again!');
								AlertError();
							}
						} else {
							setLoaderActive(false);
							setErrorMsg(response?.data?.failureMessage);
							AlertError();
						}
					} catch (ex) {
						setLoaderActive(false);
						setErrorMsg(response?.data?.failureMessage);
						AlertError();
					}
				}
			);
		}
	};



	const MatchDataFunction = (value, data, type) => {
		let match;
		if (type === 'SingleSelect') {
			let stateData = '';
			if (!ERPUtils.isNullorWhiteSpace(data)) {
				data.map((el) => {
					if (el.value === value) {
						stateData = el;
					}
					return '';
				})
			}
			match = stateData;
		}
		if (type === 'nationalitySelect') {
			let newObj = {
				value: '',
				label: ''
			};
			data.map((el) => {
				if (el.value === value) {
					newObj.value = el.value;
					newObj.label = el.nationality;
				}
				return '';
			});
			match = newObj;
		}
		if (type === 'empApplnCampusPrefDTOList') {
			let stateData = [];
			data.map((el) => {
				value.map((item) => {
					if (parseInt(el.value) === parseInt(item.erpCampusId)) {
						let newObj = { ...el };
						newObj.empApplnEntriesId = item.empApplnEntriesId;
						newObj.empApplnCampusPrefId = item.empApplnCampusPrefId;
						stateData.push(newObj);
					}
					return ' ';
				});
				return ' ';
			});
			match = stateData;
		}
		// if (type === 'Location') {
		// 	let stateData = [];
		// 	data.map((el) => {
		// 		value.map((item) => {
		// 			if (parseInt(el.value) === parseInt(item.erpLocationId)) {
		// 				let newObj = { ...el };
		// 				newObj.empApplnEntriesId = item.empApplnEntriesId;
		// 				newObj.empApplnLocationPrefId = item.empApplnLocationPrefId;
		// 				stateData.push(newObj);
		// 			}
		// 			return ' ';
		// 		});
		// 		return ' ';
		// 	});
		// 	match = stateData;
		// }
		if (type === 'countryCodes') {
			const countryCodesData = [];
			let stateData = '';
			data.map((el, index) => {
				let newObj = {
					value: '',
					label: ''
				};
				if (!ERPUtils.isNullorWhiteSpace(el.phoneCode)) {
					newObj.value = el.phoneCode;
					newObj.label = el.phoneCode;
					return (countryCodesData[index] = newObj);
				}
				return data
			});
			countryCodesData.push({ value: 'Other', label: 'Other' });
			stateData = countryCodesData.filter((item) => item.value === value)
			match = ERPUtils.isNullOrEmpty(stateData) ? { value: value, label: value } : stateData[0];
		}
		if (type === 'countryCodeEnt') {
			let stateData = '';
			match = stateData;
		}
		return match === (null || undefined) ? '' : match;
	};

	// // eslint-disable-next-line no-unused-vars
	// const FrameImageObject = (imgData, type) => {
	// 	let newArray = [];
	// 	if (type === 'Education') {
	// 		imgData.map((el) => {
	// 			let newObj = { ...el };
	// 			newObj.url = '';
	// 			newObj.fileName = el.educationalDocumentsUrl;
	// 			newArray.push(newObj);
	// 			return '';
	// 		});
	// 	}
	// 	if (type === 'Eligibility') {
	// 		imgData.map((el) => {
	// 			let newObj = { ...el };
	// 			newObj.url = '';
	// 			newObj.fileName = el.eligibilityDocumentUrl;
	// 			newArray.push(newObj);
	// 			return '';
	// 		});
	// 	}
	// 	if (type === 'professional') {
	// 		imgData.map((el) => {
	// 			let newObj = { ...el };
	// 			newObj.url = '';
	// 			newObj.fileName = el.experienceDocumentsUrl;
	// 			newArray.push(newObj);
	// 			return '';
	// 		});
	// 	}
	// 	if (type === 'profile') {
	// 		let newObj = {};
	// 		newObj.url = '';
	// 		newObj.fileName = imgData;
	// 		newArray.push(newObj);
	// 	}
	// 	return newArray;
	// };

	const mapEducationData = (responseData, dropDownData, stateName) => {
		let mappedData;
		if (stateName === 'EligibilityTest') {
			let EligibilityTestData = [];
			responseData.map((el) => {
				EligibilityTestData.push({
					empApplnEligibilityTestId: el.empApplnEligibilityTestId,
					empApplnEntriesId: el.empApplnEntriesId,
					EligibilityTestName:
						ERPUtils.isUndefinedOrNull(el.eligibilityTestId) === false
							? MatchDataFunction(el.eligibilityTestId, dropDownData[0], 'SingleSelect')
							: '',
					EligibilityYearOfComp:
						ERPUtils.isUndefinedOrNull(el.testYear) === false
							? MatchDataFunction(el.testYear, dropDownData[1], 'SingleSelect')
							: '',
					// Documents: FrameImageObject(el.eligibilityTestDocumentsList,'Eligibility')
					Documents: ERPUtils.isUndefinedOrNull(el.eligibilityTestDocumentsList) === false
						? el.eligibilityTestDocumentsList
						: [],
				});
				return '';
			});
			mappedData = EligibilityTestData;
		}
		if (stateName === 'Others') {
			let OthersData = [];
			responseData.map((el) => {
				OthersData.push({
					empApplnEducationalDetailsId: el.empApplnEducationalDetailsId,
					empApplnEntriesId: el.empApplnEntriesId,
					otherQualification:
						ERPUtils.isUndefinedOrNull(el.qualificationOthers) === false ? el.qualificationOthers : '',
					otherStatus:
						ERPUtils.isUndefinedOrNull(el.currentStatus) === false
							? MatchDataFunction(el.currentStatus, dropDownData[0], 'SingleSelect')
							: '',
					otherCourse: ERPUtils.isUndefinedOrNull(el.course) === false ? el.course : '',
					otherSpecialization:
						ERPUtils.isUndefinedOrNull(el.specialization) === false ? el.specialization : '',
					otherYearOfComp:
						ERPUtils.isUndefinedOrNull(el.yearOfCompletion) === false
							? MatchDataFunction(el.yearOfCompletion, dropDownData[1], 'SingleSelect')
							: '',
					othercountryId:
						ERPUtils.isNullorWhiteSpace(el.othercountryId) === false
							? el.countryId
							: null,
					otherstateId:
						ERPUtils.isNullorWhiteSpace(el.otherstateId) === false
							? el.stateId
							: null,
					otherstateOther:
						ERPUtils.isNullorWhiteSpace(el.otherstateOther) === false
							? el.otherstateOther
							: null,
					otherPercentage:
						ERPUtils.isUndefinedOrNull(el.gradeOrPercentage) === false ? el.gradeOrPercentage : '',
					otherInstitute: ERPUtils.isUndefinedOrNull(el.institute) === false ? el.institute : '',
					otherBoard: ERPUtils.isUndefinedOrNull(el.boardOrUniversity) === false ? el.boardOrUniversity : '',
					// Documents: FrameImageObject(el.documentList,'Education')
					Documents: ERPUtils.isUndefinedOrNull(el.documentList) === false ? el.documentList : []
				});
				return '';
			});
			mappedData = OthersData;
		}
		if (stateName === 'Research') {
			let arrayObj = { ...userDetails.ResearchDetailsData };
			responseData?.map((el) => {
				const modify = { ...arrayObj[el?.groupHeading] };
				el?.parameters?.map((item) => {
					modify[item?.researchParameter] = item?.parameterValue;
					arrayObj[el?.groupHeading] = modify;
					return '';
				});
				return '';
			});
			mappedData = arrayObj;
		}

		if (stateName === 'EducationalData') {
			let allDataObj = {};
			dropDownData[0].map((el) => {
				let LevelArray = [];
				if (
					el.qualificationLevelDegreeOrder <= responseData.qualificationLevelDegreeOrder) {
					// if (responseData.qualificationLevelDegreeOrder === el.qualificationLevelDegreeOrder) {
					// 	el.isMandatory = true
					// }
					let targetEducationalObjFiltered = dropDownData[1].filter(items => {
						return items?.qualificationLevelId === el.value
					});
					if (targetEducationalObjFiltered?.length > 0) {
						for (let index = 0; index < targetEducationalObjFiltered.length; index++) {
							let item = targetEducationalObjFiltered[index];
							callEducationStateApi(item.countryId)
							// getBoardOrInstitueList("", item, null, "Country", "", el, true)
							LevelArray.push({
								empApplnEducationalDetailsId: item.empApplnEducationalDetailsId,
								empApplnEntriesId: item.empApplnEntriesId,
								Qualification:
									ERPUtils.isUndefinedOrNull(item.qualificationLevelId) === false
										? item.qualificationLevelId
										: '',
								Status:
									ERPUtils.isUndefinedOrNull(item.currentStatus) === false
										? MatchDataFunction(item.currentStatus, dropDownData[2], 'SingleSelect')
										: '',
								Course: ERPUtils.isUndefinedOrNull(item.course) === false ? item.course : '',
								Specialization:
									ERPUtils.isUndefinedOrNull(item.specialization) === false
										? item.specialization
										: '',
								YearOfComp:
									ERPUtils.isUndefinedOrNull(item.yearOfCompletion) === false
										? MatchDataFunction(item.yearOfCompletion, dropDownData[3], 'SingleSelect')
										: '',
								Percentage:
									ERPUtils.isUndefinedOrNull(item.gradeOrPercentage) === false
										? item.gradeOrPercentage
										: '',
								countryId:
									ERPUtils.isNullorWhiteSpace(item.countryId) === false
										? item.countryId
										: null,
								stateId:
									ERPUtils.isNullorWhiteSpace(item.stateId) === false
										? item.stateId
										: null,
								stateOther:
									ERPUtils.isNullorWhiteSpace(item.stateOther) === false
										? item.stateOther
										: null,
								Institute:
									ERPUtils.isUndefinedOrNull(item.institute) === false ? item.institute : '',
								Board:
									ERPUtils.isUndefinedOrNull(item.boardOrUniversity) === false
										? item.boardOrUniversity
										: '',
								erpBoardOrUniversity:
									ERPUtils.isUndefinedOrNull(item.erpBoardOrUniversity) === false
										? item.erpBoardOrUniversity
										: '',
								erpInstitute:
									ERPUtils.isUndefinedOrNull(item.erpInstitute) === false
										? item.erpInstitute
										: '',
								// Documents: FrameImageObject(item.documentList,"Education")
								Documents: ERPUtils.isUndefinedOrNull(item.documentList) === false
									? item.documentList
									: [],
							});
							if (index > 0) {
								if (ERPUtils.isNullorWhiteSpace(addReqErrors[item.qualificationLevelId])) {
									addReqErrors[item.qualificationLevelId] = []
									addReqErrors[item.qualificationLevelId].push(index);
								} else {
									addReqErrors[item.qualificationLevelId].push(index);
								}
							}
						}
					} else {
						// getBoardOrInstitueList("", item, null, "Country", "", el, true)
						LevelArray.push({
							empApplnEducationalDetailsId: "",
							empApplnEntriesId: "",
							Qualification:
								ERPUtils.isUndefinedOrNull(el.value) === false
									? el?.value
									: '',
							Status: '',
							Course: '',
							Specialization: '',
							YearOfComp: '',
							Percentage: '',
							countryId: null,
							stateId: null,
							stateOther: null,
							Institute: '',
							Board: '',
							erpBoardOrUniversity: '',
							erpInstitute: '',
							// Documents: FrameImageObject(item.documentList,"Education")
							Documents: [],
						});
					}
					// dropDownData[1].map((item, index) => {
					// 	if (item.qualificationLevelId === el.value) {
					// 		callEducationStateApi(item.countryId)
					// 									// getBoardOrInstitueList("", item, null, "Country", "", el, true)
					// 		LevelArray.push({
					// 			empApplnEducationalDetailsId: item.empApplnEducationalDetailsId,
					// 			empApplnEntriesId: item.empApplnEntriesId,
					// 			Qualification:
					// 				ERPUtils.isUndefinedOrNull(item.qualificationLevelId) === false
					// 					? item.qualificationLevelId
					// 					: '',
					// 			Status:
					// 				ERPUtils.isUndefinedOrNull(item.currentStatus) === false
					// 					? MatchDataFunction(item.currentStatus, dropDownData[2], 'SingleSelect')
					// 					: '',
					// 			Course: ERPUtils.isUndefinedOrNull(item.course) === false ? item.course : '',
					// 			Specialization:
					// 				ERPUtils.isUndefinedOrNull(item.specialization) === false
					// 					? item.specialization
					// 					: '',
					// 			YearOfComp:
					// 				ERPUtils.isUndefinedOrNull(item.yearOfCompletion) === false
					// 					? MatchDataFunction(item.yearOfCompletion, dropDownData[3], 'SingleSelect')
					// 					: '',
					// 			Percentage:
					// 				ERPUtils.isUndefinedOrNull(item.gradeOrPercentage) === false
					// 					? item.gradeOrPercentage
					// 					: '',
					// 			countryId: 
					// 				ERPUtils.isNullorWhiteSpace(item.countryId) === false
					// 					? item.countryId
					// 					: null,
					// 			stateId:
					// 				ERPUtils.isNullorWhiteSpace(item.stateId) === false
					// 					? item.stateId
					// 					: null,
					// 			stateOther:
					// 				ERPUtils.isNullorWhiteSpace(item.stateOther) === false
					// 					? item.stateOther
					// 					: null,
					// 			Institute:
					// 				ERPUtils.isUndefinedOrNull(item.institute) === false ? item.institute : '',
					// 			Board:
					// 				ERPUtils.isUndefinedOrNull(item.boardOrUniversity) === false
					// 					? item.boardOrUniversity
					// 					: '',
					// 			erpBoardOrUniversity:
					// 				ERPUtils.isUndefinedOrNull(item.erpBoardOrUniversity) === false
					// 					? item.erpBoardOrUniversity
					// 					: '',
					// 			erpInstitute:
					// 				ERPUtils.isUndefinedOrNull(item.erpInstitute) === false
					// 					? item.erpInstitute
					// 					: '',
					// 			// Documents: FrameImageObject(item.documentList,"Education")
					// 			Documents: ERPUtils.isUndefinedOrNull(item.documentList) === false
					// 					? item.documentList
					// 					: [],
					// 		});
					// 		if (index > 0) {
					// 			if (ERPUtils.isNullorWhiteSpace(addReqErrors[item.qualificationLevelId])) {
					// 				addReqErrors[item.qualificationLevelId] = []
					// 				addReqErrors[item.qualificationLevelId].push(index);
					// 			} else {
					// 				addReqErrors[item.qualificationLevelId].push(index);
					// 			}
					// 		}
					// 	}
					// 	return '';
					// });
					if (el.isMandatory) {
						saveDraftMand[el.value] = true;
					}
				}
				allDataObj[el.value] = LevelArray;
				return '';
			});
			mappedData = Object.keys(allDataObj).length > 0 ? allDataObj : userDetails.EducationDetailsObj;
		}

		// if (stateName === 'tenth') {
		// 	let tenthData = [];
		// 	dropDownData[0].map((el) => {
		// 		if (
		// 			el.qualificationLevelDegreeOrder <= responseData.qualificationLevelDegreeOrder &&
		// 			el.value === ('1' || 1)
		// 		) {
		// 			dropDownData[1].map((item, index) => {
		// 				if (item.qualificationLevelId === el.value) {
		// 					tenthData.push({
		// 						empApplnEducationalDetailsId: item.empApplnEducationalDetailsId,
		// 						empApplnEntriesId: item.empApplnEntriesId,
		// 						TenthQualification:
		// 							ERPUtils.isUndefinedOrNull(item.qualificationLevelId) === false
		// 								? item.qualificationLevelId
		// 								: '',
		// 						TenthStatus:
		// 							ERPUtils.isUndefinedOrNull(item.currentStatus) === false
		// 								? MatchDataFunction(item.currentStatus, dropDownData[2], 'SingleSelect')
		// 								: '',
		// 						TenthCourse: ERPUtils.isUndefinedOrNull(item.course) === false ? item.course : '',
		// 						TenthSpecialization:
		// 							ERPUtils.isUndefinedOrNull(item.specialization) === false
		// 								? item.specialization
		// 								: '',
		// 						TenthYearOfComp:
		// 							ERPUtils.isUndefinedOrNull(item.yearOfCompletion) === false
		// 								? MatchDataFunction(item.yearOfCompletion, dropDownData[3], 'SingleSelect')
		// 								: '',
		// 						TenthPercentage:
		// 							ERPUtils.isUndefinedOrNull(item.gradeOrPercentage) === false
		// 								? item.gradeOrPercentage
		// 								: '',
		// 						TenthInstitute:
		// 							ERPUtils.isUndefinedOrNull(item.institute) === false ? item.institute : '',
		// 						TenthBoard:
		// 							ERPUtils.isUndefinedOrNull(item.boardOrUniversity) === false
		// 								? item.boardOrUniversity
		// 								: '',
		// 						// Documents: FrameImageObject(item.documentList,"Education")
		// 						Documents: []
		// 					});
		// 					if (index > 0) {
		// 						if(ERPUtils.isNullorWhiteSpace(addReqErrors[item.qualificationLevelId])){
		// 							addReqErrors[item.qualificationLevelId] = [];
		// 							addReqErrors[item.qualificationLevelId].push(index);
		// 						}else {
		// 							addReqErrors[item.qualificationLevelId].push(index);
		// 						}
		// 					}
		// 				}
		// 				return '';
		// 			});
		// 			if (el.isMandatory) {
		// 				let target = 'CheckTenth';
		// 				saveDraftMand[target] = true;
		// 			}
		// 		}
		// 		return '';
		// 	});
		// 	mappedData = tenthData.length > 0 ? tenthData : userDetails.Tenth;
		// }	
		return mappedData;
	};

	const getSyncData = async (DraftData, stateData, url, type, stateName, nestedState, id) => {
		const data = await ApiGateway.request(stateData, url);
		let finalData = [];
		// if (data.success === true) {
		//COMMENTED AS PICODE BASED FETCHING IS USED INSTEAD
		if (type === 'states') {
			// let newdata = '';
			if (stateName === 'current') {
				let dropData = data.dto !== null ? data.dto : [];
				setCurStates(dropData);
			}
			if (stateName === 'permanent') {
				let dropData = data.dto !== null ? data.dto : [];
				setPerStates(dropData);
			}
		}
		if (type === 'getJobCategory') {
			let dropData = data.dto !== null ? data.dto : [];
			setJobCategory(dropData)
			data?.dto?.map((item) => {
				if (DraftData.value === item.value) {
					finalData = item;
				}
				return finalData;
			})
		}
		// 	if (data.dto !== null) {
		// 		data.dto.map((el) => {
		// 			if (el.value === DraftData) {
		// 				newdata = el;
		// 			}
		// 			return '';
		// 		});
		// 	}
		// 	finalData = newdata;
		// }
		if (type === 'cities') {
			// let newdata = '';
			if (stateName === 'current') {
				let dropData = data.dto !== null ? data.dto : [];
				setCurrentCities(dropData);
			}
			if (stateName === 'permanent') {
				let dropData = data.dto !== null ? data.dto : [];
				setPermanentCities(dropData);
			}
			// if (data.dto !== null) {
			// 	data.dto.map((el) => {
			// 		if (el.value === DraftData) {
			// 			newdata = el;
			// 		}
			// 		return '';
			// 	});
			// }
			// finalData = newdata;
		}

		if (type === 'withoutSubData') {
			setSubjects(data.dto !== null ? data.dto : []);
		}

		if (type === 'withoutSpecData') {
			setSpecialize(data.dto !== null ? data.dto : []);
			// sessionStorage.setItem('specs', data.dto !== null ? true : false); //CHANGED FOR TESTING
			if (data.dto === null) {
				ChangeSpecStatus();
			}
		}

		if (type === 'getSub') {
			setSubjects(data.dto !== null ? data.dto : []);
			let newdata = [];
			if (data?.dto !== null) {
				DraftData?.map((el) => {
					data?.dto?.map((item) => {
						if (el === (parseInt(item.value) || item.value)) {
							let newObj = { ...item };
							newObj.empApplnEntriesId = el.empApplnEntriesId;
							newObj.empApplnSubjSpecializationPrefId = el.empApplnSubjSpecializationPrefId;
							newdata.push(newObj);
						}
						return '';
					});
					return '';
				});
			}
			finalData = newdata;
		}

		if (type === 'getSpec') {
			setSpecialize(data.dto !== null ? data.dto : []);
			// sessionStorage.setItem('specs', data.dto !== null ? true : false);  NEED TO CHECK THIS LATERRR

			let newdata = [];
			if (data.dto !== null) {
				DraftData.map((el) => {
					data.dto.map((item) => {
						if (el.subjectCategorySpecializationId === (parseInt(item.value) || item.value)) {
							let newObj = { ...item };
							newObj.empApplnEntriesId = el.empApplnEntriesId;
							newObj.empApplnSubjSpecializationPrefId = el.empApplnSubjSpecializationPrefId;
							newdata.push(newObj);
						}
						return '';
					});
					return '';
				});
			}
			ChangeSpecStatus(data.dto !== null ? true : false);
			finalData = newdata;
		}

		if (type === 'getCat') {
			setSubjects(data.dto !== null ? data.dto : []);
			let newdata = '';
			if (data.dto !== null) {
				DraftData.map((el) => {
					data.dto.map((item) => {
						if (el.subjectCategoryId === (parseInt(item.value) || item.value)) {
							let newObj = { ...item };
							newObj.empApplnEntriesId = el.empApplnEntriesId;
							newObj.empApplnSubjSpecializationPrefId = el.empApplnSubjSpecializationPrefId;
							newdata = newObj;
						}
						return '';
					});
					return '';
				});
			}
			finalData = newdata;
		}

		if (type === 'getFunctionlArea') {
			if (stateName === 'FunctionalArea') {
				setFunctionalAreas(prev => {
					const newArr = data.dto !== null ? [...data.dto] : [];
					newArr.push({ value: 'Others', label: 'Others' });
					return { ...prev, [nestedState]: newArr };
				});
			}
			if (stateName === 'PreviousFunctionalArea') {
				setFunctionalAreas(prev => {
					const newPrev = [...prev[nestedState]];
					newPrev[id] = data.dto !== null ? [...data.dto] : [];
					newPrev[id].push({ value: 'Others', label: 'Others' });
					return { ...prev, [nestedState]: newPrev };
				});
			}
			let newdata = '';
			if (data.dto !== null) {
				data.dto.map((item) => {
					if (DraftData === item.value) {
						newdata = item;
					}
					return '';
				});
			}
			finalData = newdata;
		}

		return finalData;
	};

	//*******************************SAVING DATA FROM API IN STATES **************************************************************
	const saveProfessionalData = async (resData, prevData, isSaveDraftFromScreen, resumeData) => {
		let professionalData = [...professionalDetails];
		if (ERPUtils.isNullorWhiteSpace(resData?.professionalExperienceDTO) === false) {
			if (ERPUtils.isNullorWhiteSpace(resData.professionalExperienceDTO.professionalExperienceList) === false) {
				if (resData.professionalExperienceDTO.professionalExperienceList.length > 0) {
					let ProfData = [];
					resData.professionalExperienceDTO.professionalExperienceList.map(async (el, index) => {
						let experienceType =
							ERPUtils.isNullorWhiteSpace(el.workExperienceTypeId) === false
								? MatchDataFunction(el.workExperienceTypeId, prevData[10].data.dto, 'SingleSelect')
								: '';
						ProfData.push({
							empApplnWorkExperienceId: el.empApplnWorkExperienceId,
							ExperienceType: experienceType,
							functionalArea:
								ERPUtils.isNullorWhiteSpace(el.functionalAreaOthers) === false
									? await getSyncData(
										'Others',
										experienceType.isExperienceTypeAcademic,
										'Employee/CommonEmployee/getApplnSubjectCategory?isAcademic=',
										'getFunctionlArea',
										'PreviousFunctionalArea',
										'PreviousFunctional',
										index
									)
									: experienceType !== ''
										? await getSyncData(
											el.functionalAreaId,
											experienceType.isExperienceTypeAcademic,
											'Employee/CommonEmployee/getApplnSubjectCategory?isAcademic=',
											'getFunctionlArea',
											'PreviousFunctionalArea',
											'PreviousFunctional',
											index
										)
										: '',
							EmpType:
								ERPUtils.isNullorWhiteSpace(el.employmentType) === false
									? await MatchDataFunction(el.employmentType, employmentType, 'SingleSelect')
									: '',
							fromDate:
								ERPUtils.isNullorWhiteSpace(el.fromDate) === false ? ERPUtils.convertLocalDateToDateObj(el.fromDate) : '',
							ToDate: ERPUtils.isNullorWhiteSpace(el.toDate) === false ? ERPUtils.convertLocalDateToDateObj(el.toDate) : '',
							TotalYears: ERPUtils.isNullorWhiteSpace(el.years) === false ? el.years : 0,
							TotalMonths: ERPUtils.isNullorWhiteSpace(el.months) === false ? el.months : 0,
							designation: ERPUtils.isNullorWhiteSpace(el.designation) === false ? el.designation : '',
							institution: ERPUtils.isNullorWhiteSpace(el.institution) === false ? el.institution : '',
							OtherFunctionalArea:
								ERPUtils.isNullorWhiteSpace(el.functionalAreaOthers) === false
									? el.functionalAreaOthers
									: '',
							experienceDocumentList: ERPUtils.isNullorWhiteSpace(el.experienceDocumentList) === false ? el.experienceDocumentList : [],
						});
						// el.experienceDocumentList.map(item => {
						// 	let newObj = {...item};
						// 	newObj.url = ""
						// 	newObj.fileName = item.experienceDocumentsUrl
						// 	newArray[index].Documents.push(newObj);
						// })
						// newArray.push({
						// 	Documents: []
						// });
						if (index > 0) {
							if (ERPUtils.isUndefinedOrNull(addReqErrors?.professionalDetails)) {
								addReqErrors = { ...addReqErrors, professionalDetails: [] }
							}
							addReqErrors?.professionalDetails?.push(index);
						}
						return '';
					});
					professionalData = ProfData;
				}
			}
		}
		setProfessionalDetails(professionalData, () => {
			setSaveTheData(false)
			setDraftedData(resData, prevData, isSaveDraftFromScreen, resumeData);
		});
	};

	const getProfessionalImagesData = (data) => {
		let ProfData = [];
		if (ERPUtils.isUndefinedOrNull(data) === false) {
			if (ERPUtils.isUndefinedOrNull(data.professionalExperienceDTO) === false) {
				if (
					ERPUtils.isUndefinedOrNull(data.professionalExperienceDTO.professionalExperienceList) === false &&
					data.professionalExperienceDTO.professionalExperienceList.length > 0
				) {
					data.professionalExperienceDTO.professionalExperienceList.map((el, index) => {
						ProfData.push({
							Documents: []
						});

						// el.experienceDocumentList.map(item => {
						// 	let newObj = {...item};
						// 	newObj.url = ""
						// 	newObj.fileName = item.experienceDocumentsUrl
						// 	newArray[index].Documents.push(newObj);
						// })
						return '';
					});
				}
			}
		}
		return ProfData.length > 0 ? ProfData : userDetails.PrevExpDocuments;
	};

	//*********************** SETTING THE DATA FORMAT FOR SCREEN FUNCTIONING **************************************
	const setDraftedData = async (resData, prevData, isSaveDraftFromScreen, resumeData) => {
		const SaveData = { ...userDetails };
		if (resumeData) {
			SaveData.resume = resumeData;
		}
		// Personal Details:
		if (ERPUtils.isUndefinedOrNull(resData?.empApplnPersonalDataDTO) === false) {
			SaveData.Name = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.applicantName)
				? ''
				: resData.empApplnPersonalDataDTO.applicantName;
			SaveData.Gender = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.genderId)
				? ''
				: MatchDataFunction(resData.empApplnPersonalDataDTO.genderId, prevData[0].data.dto, 'SingleSelect');
			SaveData.FatherName = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.fatherName)
				? ''
				: resData.empApplnPersonalDataDTO.fatherName;
			SaveData.MotherName = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.motherName)
				? ''
				: resData.empApplnPersonalDataDTO.motherName;
			SaveData.DOB = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.dateOfBirth)
				? ''
				: ERPUtils.validateDate(resData.empApplnPersonalDataDTO.dateOfBirth);
			SaveData.Email = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.emailId)
				? ''
				: resData.empApplnPersonalDataDTO.emailId;
			SaveData.CountryCode = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.mobileNoCountryCode)
				? ''
				: MatchDataFunction(
					resData.empApplnPersonalDataDTO.mobileNoCountryCode,
					prevData[1].data.dto,
					'countryCodes'
				);
			//check
			SaveData.CountryCodeEnt = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.mobileNoCountryCode)
				? ''
				: resData.empApplnPersonalDataDTO.mobileNoCountryCode;
			SaveData.mobileNo = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.mobileNo)
				? ''
				: resData.empApplnPersonalDataDTO.mobileNo;
			SaveData.AltNo = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.alternateNo)
				? ''
				: resData.empApplnPersonalDataDTO.alternateNo;
			SaveData.AadharNo = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.aadharNo)
				? ''
				: resData.empApplnPersonalDataDTO.aadharNo;
			SaveData.marital = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.maritalStatusId)
				? ''
				: MatchDataFunction(
					resData.empApplnPersonalDataDTO.maritalStatusId,
					prevData[2].data.dto,
					'SingleSelect'
				);
			SaveData.Nationality = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.nationalityId)
				? ''
				: MatchDataFunction(
					resData.empApplnPersonalDataDTO.nationalityId,
					prevData[1].data.dto,
					'nationalitySelect'
				);
			await passportCountryMendatoryFlag(SaveData.Nationality)
			SaveData.PassportNo = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.passportNo)
				? ''
				: resData.empApplnPersonalDataDTO.passportNo;
			SaveData.Religion = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.religionId)
				? ''
				: MatchDataFunction(resData.empApplnPersonalDataDTO.religionId, prevData[3].data.dto, 'SingleSelect');
			SaveData.Minority = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.isMinority)
				? ''
				: resData.empApplnPersonalDataDTO.isMinority;
			SaveData.Reservation = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.reservationCategoryId)
				? ''
				: MatchDataFunction(
					resData.empApplnPersonalDataDTO.reservationCategoryId,
					prevData[4].data.dto,
					'SingleSelect'
				);
			SaveData.BloodGroup = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.bloodGroupId)
				? ''
				: MatchDataFunction(resData.empApplnPersonalDataDTO.bloodGroupId, prevData[5].data.dto, 'SingleSelect');
			SaveData.DiffAbled = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO.isDifferentlyAbled)
				? ''
				: resData.empApplnPersonalDataDTO.isDifferentlyAbled;
			SaveData.DifferentlyAbledType = ERPUtils.isUndefinedOrNull(
				resData.empApplnPersonalDataDTO.differentlyAbledId
			) ? ''
				: MatchDataFunction(
					resData.empApplnPersonalDataDTO.differentlyAbledId,
					prevData[6].data.dto,
					'SingleSelect'
				);
			SaveData.profilePhoto = ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO?.actualPath) && ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO?.tempPath)
				? ''
				: [{
					originalFileName: resData.empApplnPersonalDataDTO?.originalFileName,
					uniqueFileName: resData.empApplnPersonalDataDTO?.uniqueFileName,
					newFile: resData.empApplnPersonalDataDTO?.newFile,
					tempPath: resData.empApplnPersonalDataDTO?.tempPath,
					actualPath: resData.empApplnPersonalDataDTO?.actualPath,
					preSignedUrl: "",
					processCode: resData.empApplnPersonalDataDTO?.processCode
				}];

			if (!resumeData && ERPUtils.isUndefinedOrNull(resData.empApplnPersonalDataDTO?.resumeUploadDTO) === false) {
				SaveData.resume = [{
					originalFileName: resData.empApplnPersonalDataDTO?.resumeUploadDTO?.originalFileName,
					uniqueFileName: resData.empApplnPersonalDataDTO?.resumeUploadDTO?.uniqueFileName,
					newFile: resData.empApplnPersonalDataDTO?.resumeUploadDTO?.newFile,
					tempPath: resData.empApplnPersonalDataDTO?.resumeUploadDTO?.tempPath,
					actualPath: resData.empApplnPersonalDataDTO?.resumeUploadDTO?.actualPath,
					preSignedUrl: "",
					processCode: resData.empApplnPersonalDataDTO?.resumeUploadDTO?.processCode
				}];
			}
		}
		// SaveData.ResearchDetailsImg[0].Documents = ERPUtils.isUndefinedOrNull(
		// 	resData.professionalExperienceDTO.profilePhotoUrl
		// ) ? [] : FrameImageObject(resData.professionalExperienceDTO.profilePhotoUrl,'profile')
		// SaveData.ResearchDetailsImg[0].Documents = [];

		// Address details:
		if (ERPUtils.isUndefinedOrNull(resData?.addressDetailDTO) === false) {
			// if(!ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.currentStateId)){
			// 	callStateApi("current",resData.addressDetailDTO.currentStateId)
			// }
			// if(!ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.permanentStateId)){
			// 	callStateApi("permanent",resData.addressDetailDTO.permanentStateId)
			// }
			SaveData.currentLine1 = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.currentAddressLine1)
				? ''
				: resData.addressDetailDTO.currentAddressLine1;
			SaveData.currentLine2 = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.currentAddressLine2)
				? ''
				: resData.addressDetailDTO.currentAddressLine2;
			SaveData.currentCountry = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.currentCountryId)
				? ''
				: MatchDataFunction(resData.addressDetailDTO.currentCountryId, prevData[1].data.dto, 'SingleSelect');
			SaveData.currentState = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.currentStateOthers)
				? ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.currentStateId)
					? ''
					: resData.addressDetailDTO.currentStateId
				: "";
			if (!ERPUtils.isNullorWhiteSpace(resData.addressDetailDTO.currentPincode) && (SaveData.currentCountry.nationality === "Indian")) {
				SaveData.addressDetailDTO = getCityandStateFromPincode(resData.addressDetailDTO.currentPincode, "currentPincode", resData, SaveData)
				// if(!ERPUtils.isNullorWhiteSpace(resData.addressDetailDTO.currentCountryId)){
				// 	await getSyncData(
				// 		resData.addressDetailDTO.currentStateId,
				// 		resData.addressDetailDTO.currentCountryId,
				// 		'Common/getStatesByCountry?countryId=',
				// 		'states',
				// 		'current',
				// 		'',
				// 		''
				// 	)
				// }
			}
			SaveData.otherCurrState = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.currentStateOthers)
				? ''
				: resData.addressDetailDTO.currentStateOthers;
			SaveData.currentCity = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.currentCityOthers)
				? ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.currentCityId)
					? ''
					: resData.addressDetailDTO.currentCityId
				: // : MatchDataFunction(resData.addressDetailDTO.currentCityId, prevData[16].data.dto, 'SingleSelect')
				"";
			// 			if(!ERPUtils.isNullorWhiteSpace(resData.addressDetailDTO.currentCityId)){
			// 	await getSyncData(
			// 		resData.addressDetailDTO.currentCityId,
			// 		resData.addressDetailDTO.currentStateId,
			// 		'Common/getCity?stateId=',
			// 		'cities',
			// 		'current',
			// 		'',
			// 		''
			// 	)
			// }

			SaveData.otherCurrCity = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.currentCityOthers)
				? ''
				: resData.addressDetailDTO.currentCityOthers;
			SaveData.currentPincode = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.currentPincode)
				? ''
				: resData.addressDetailDTO.currentPincode;
			SaveData.curAddSameAsPer = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.isPermanentEqualsCurrent)
				? ''
				: resData.addressDetailDTO.isPermanentEqualsCurrent;
			if (SaveData.curAddSameAsPer === "Yes") { RemoveReqFieldErrors('CurAddSameAsPerAdd', '', '') }
			SaveData.permanentLine1 = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.permanentAddressLine1)
				? ''
				: resData.addressDetailDTO.permanentAddressLine1;
			SaveData.permanentLine2 = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.permanentAddressLine2)
				? ''
				: resData.addressDetailDTO.permanentAddressLine2;
			SaveData.permanentCountry = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.permanentCountryId)
				? ''
				: MatchDataFunction(resData.addressDetailDTO.permanentCountryId, prevData[1].data.dto, 'SingleSelect');

			SaveData.permanentState = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.permanentStateOthers)
				? ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.permanentStateId)
					? ''
					: resData.addressDetailDTO.permanentStateId
				: "";
			if (!ERPUtils.isNullorWhiteSpace(resData.addressDetailDTO.permanentPincode) && (SaveData.permanentCountry.nationality === "Indian")) {
				SaveData.addressDetailDTO = getCityandStateFromPincode(resData.addressDetailDTO.permanentPincode, "permanentPincode", resData)
				// await getSyncData(
				// 	resData.addressDetailDTO.permanentStateId,
				// 	resData.addressDetailDTO.permanentCountryId,
				// 	'Common/getStatesByCountry?countryId=',
				// 	'states',
				// 	'permanent',
				// 	'',
				// 	''
				// )
			}
			SaveData.otherPermState = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.permanentStateOthers)
				? ''
				: resData.addressDetailDTO.permanentStateOthers;
			SaveData.permanentCity = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.permanentCityOthers)
				? ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.permanentCityId)
					? ''
					: resData.addressDetailDTO.permanentCityId
				: "";
			// if(!ERPUtils.isNullorWhiteSpace(resData.addressDetailDTO.permanentCityId)){
			// 	await getSyncData(
			// 		resData.addressDetailDTO.permanentCityId,
			// 		resData.addressDetailDTO.permanentStateId,
			// 		'Common/getCity?stateId=',
			// 		'cities',
			// 		'permanent',
			// 		'',
			// 		''
			// 	)
			// }
			SaveData.otherPermCity = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.permanentCityOthers)
				? ''
				: resData.addressDetailDTO.permanentCityOthers;
			SaveData.permanentPincode = ERPUtils.isUndefinedOrNull(resData.addressDetailDTO.permanentPincode)
				? ''
				: resData.addressDetailDTO.permanentPincode;
		}

		// Education Details:
		if (ERPUtils.isUndefinedOrNull(resData?.educationalDetailDTO) === false) {
			SaveData.HighestQualification = ERPUtils.isUndefinedOrNull(
				resData.educationalDetailDTO.highestQualificationLevelId
			)
				? ''
				: MatchDataFunction(
					resData.educationalDetailDTO.highestQualificationLevelId,
					prevData[7].data.dto,
					'SingleSelect'
				);
			SaveData.EducationDetailsObj = ERPUtils.isUndefinedOrNull(resData.educationalDetailDTO.qualificationLevelsList) ?
				SaveData.EducationDetailsObj : mapEducationData(
					SaveData.HighestQualification,
					[
						prevData[7].data.dto,
						resData.educationalDetailDTO.qualificationLevelsList,
						EducationStatus,
						prevData[11].data.dto
					],
					'EducationalData'
				);

			SaveData.EligibilityTest = ERPUtils.isUndefinedOrNull(resData.educationalDetailDTO.eligibilityTestList)
				? userDetails.EligibilityTest
				: mapEducationData(
					resData.educationalDetailDTO.eligibilityTestList,
					[prevData[8].data.dto, prevData[11].data.dto],
					'EligibilityTest'
				);
			SaveData.others = ERPUtils.isUndefinedOrNull(resData.educationalDetailDTO.otherQualificationLevelsList)
				? userDetails.others
				: mapEducationData(
					resData.educationalDetailDTO.otherQualificationLevelsList,
					[EducationStatus, prevData[11].data.dto],
					'Others'
				);
		}
		// Professional Details:
		if (ERPUtils.isNullorWhiteSpace(resData?.professionalExperienceDTO) === false) {
			SaveData.currentWorking = ERPUtils.isUndefinedOrNull(resData.professionalExperienceDTO.isCurrentlyWorking)
				? ''
				: resData.professionalExperienceDTO.isCurrentlyWorking;
			if (ERPUtils.isNullorWhiteSpace(resData.professionalExperienceDTO.currentExperience) === false) {
				SaveData.currentExperienceType = ERPUtils.isUndefinedOrNull(
					resData.professionalExperienceDTO.currentExperience.workExperienceTypeId
				)
					? ''
					: MatchDataFunction(
						resData.professionalExperienceDTO.currentExperience.workExperienceTypeId,
						prevData[10].data.dto,
						'SingleSelect'
					);
				SaveData.currentFunctionalArea =
					ERPUtils.isUndefinedOrNull(
						resData.professionalExperienceDTO.currentExperience.functionalAreaOthers
					) === false
						? await getSyncData(
							'Others',
							SaveData.currentExperienceType.isExperienceTypeAcademic,
							'Employee/CommonEmployee/getApplnSubjectCategory?isAcademic=',
							'getFunctionlArea',
							'FunctionalArea',
							'CurrentFunctional'
						)
						: await getSyncData(
							resData.professionalExperienceDTO.currentExperience.functionalAreaId,
							SaveData.currentExperienceType.isExperienceTypeAcademic,
							'Employee/CommonEmployee/getApplnSubjectCategory?isAcademic=',
							'getFunctionlArea',
							'FunctionalArea',
							'CurrentFunctional'
						);
				SaveData.currentOtherFunctionalArea = ERPUtils.isUndefinedOrNull(
					resData.professionalExperienceDTO.currentExperience.functionalAreaOthers
				)
					? ''
					: resData.professionalExperienceDTO.currentExperience.functionalAreaOthers;
				SaveData.currentEmpType = ERPUtils.isUndefinedOrNull(
					resData.professionalExperienceDTO.currentExperience.employmentType
				)
					? ''
					: MatchDataFunction(
						resData.professionalExperienceDTO.currentExperience.employmentType,
						employmentType,
						'SingleSelect'
					);
				SaveData.CurrentEmpApplnWorkExperienceId = ERPUtils.isUndefinedOrNull(
					resData.professionalExperienceDTO.currentExperience.empApplnWorkExperienceId
				)
					? ''
					: resData.professionalExperienceDTO.currentExperience.empApplnWorkExperienceId;

				SaveData.currentDesignation = ERPUtils.isUndefinedOrNull(
					resData.professionalExperienceDTO.currentExperience.designation
				)
					? ''
					: resData.professionalExperienceDTO.currentExperience.designation;
				SaveData.currentFromDate = ERPUtils.isUndefinedOrNull(
					resData.professionalExperienceDTO.currentExperience.fromDate
				)
					? ''
					: ERPUtils.convertLocalDateToDateObj(resData.professionalExperienceDTO.currentExperience.fromDate);

				SaveData.currentToDate = ERPUtils.isUndefinedOrNull(
					resData.professionalExperienceDTO.currentExperience.toDate
				)
					? userDetails.currentToDate
					: ERPUtils.convertLocalDateToDateObj(resData.professionalExperienceDTO.currentExperience.toDate);

				SaveData.currentTotalYears = ERPUtils.isUndefinedOrNull(
					resData.professionalExperienceDTO.currentExperience.years
				)
					? 0
					: resData.professionalExperienceDTO.currentExperience.years;
				SaveData.currentTotalMonths = ERPUtils.isUndefinedOrNull(
					resData.professionalExperienceDTO.currentExperience.months
				)
					? 0
					: resData.professionalExperienceDTO.currentExperience.months;

				SaveData.currentNoticePeriod = ERPUtils.isUndefinedOrNull(
					resData.professionalExperienceDTO.currentExperience.noticePeriod
				)
					? ''
					: resData.professionalExperienceDTO.currentExperience.noticePeriod;
				SaveData.currentSalary = ERPUtils.isUndefinedOrNull(
					resData.professionalExperienceDTO.currentExperience.currentSalary
				)
					? ''
					: resData.professionalExperienceDTO.currentExperience.currentSalary;
				SaveData.currentInstitute = ERPUtils.isUndefinedOrNull(
					resData.professionalExperienceDTO.currentExperience.institution
				)
					? ''
					: resData.professionalExperienceDTO.currentExperience.institution;
				// 	SaveData.CurrentExpDocuments[0].Documents = ERPUtils.isUndefinedOrNull(
				// 		resData.professionalExperienceDTO.currentExperience.experienceDocumentList
				// 	)
				// 		? userDetails.CurrentExpDocuments
				// 		: FrameImageObject(resData.professionalExperienceDTO.currentExperience.experienceDocumentList,'professional');
				SaveData.CurrentExpDocuments = ERPUtils.isUndefinedOrNull(
					resData?.professionalExperienceDTO?.currentExperience?.experienceDocumentList
				)
					? []
					: resData?.professionalExperienceDTO?.currentExperience?.experienceDocumentList;

			}
			SaveData.TotalFullTimeYearsExp =
				ERPUtils.isUndefinedOrNull(resData.professionalExperienceDTO.totalPreviousExperienceYears) === false &&
					resData.professionalExperienceDTO.totalPreviousExperienceYears >= 0
					? resData.professionalExperienceDTO.totalPreviousExperienceYears
					: 0;
			SaveData.TotalFullTimeMonthsExp =
				ERPUtils.isUndefinedOrNull(resData.professionalExperienceDTO.totalPreviousExperienceMonths) === false &&
					resData.professionalExperienceDTO.totalPreviousExperienceMonths >= 0
					? resData.professionalExperienceDTO.totalPreviousExperienceMonths
					: 0;
			SaveData.TotalPartTimeYearsExp =
				ERPUtils.isUndefinedOrNull(resData.professionalExperienceDTO.totalPartTimePreviousExperienceYears) ===
					false && resData.professionalExperienceDTO.totalPartTimePreviousExperienceYears >= 0
					? resData.professionalExperienceDTO.totalPartTimePreviousExperienceYears
					: 0;
			SaveData.TotalPartTimeMonthsExp =
				ERPUtils.isUndefinedOrNull(resData.professionalExperienceDTO.totalPartTimePreviousExperienceMonths) ===
					false && resData.professionalExperienceDTO.totalPartTimePreviousExperienceMonths >= 0
					? resData.professionalExperienceDTO.totalPartTimePreviousExperienceMonths
					: 0;
			SaveData.majorAchievements =
				ERPUtils.isNullorWhiteSpace(resData.professionalExperienceDTO.majorAchievements) === false
					? resData.professionalExperienceDTO.majorAchievements
					: '';
			SaveData.expSalary =
				ERPUtils.isNullorWhiteSpace(resData.professionalExperienceDTO.expectedSalary) === false
					? resData.professionalExperienceDTO.expectedSalary
					: '';
			// SaveData.PrevExpDocuments = prevExpImgData.length === 0 ? userDetails.PrevExpDocuments : prevExpImgData
			SaveData.PrevExpDocuments = getProfessionalImagesData(resData);
		}
		//Research details:
		if (ERPUtils.isNullorWhiteSpace(resData?.researchDetailDTO) === false) {
			SaveData.ResearchExperience =
				ERPUtils.isUndefinedOrNull(resData?.researchDetailDTO?.isResearchExperience)
					? ''
					: resData.researchDetailDTO.isResearchExperience;
			SaveData.orcidId =
				ERPUtils.isUndefinedOrNull(resData.researchDetailDTO.orcidId) === false
					? resData.researchDetailDTO.orcidId
					: '';
			SaveData.vidwanId =
				resData.researchDetailDTO.inflibnetVidwanNo === null ? '' : resData.researchDetailDTO.inflibnetVidwanNo;
			SaveData.scopusPaperNumber =
				resData.researchDetailDTO.scopusId === null ? '' : resData.researchDetailDTO.scopusId;
			SaveData.hIndex = resData?.researchDetailDTO?.hIndex === null ? '' : resData.researchDetailDTO.hIndex;
			SaveData.ResearchDetailsData = ERPUtils.isUndefinedOrNull(resData.researchDetailDTO.researchEntries)
				? userDetails.ResearchDetailsData
				: mapEducationData(
					resData.researchDetailDTO.researchEntries.researchEntriesHeadings,
					[prevData[13].data.dto],
					'Research'
				);
			SaveData.interviewedBefore =
				resData.researchDetailDTO.isInterviewedBefore === null
					? ''
					: resData.researchDetailDTO.isInterviewedBefore;
			SaveData.InterviewedDept =
				resData.researchDetailDTO.interviewedBeforeDepartment === null
					? ''
					: resData.researchDetailDTO.interviewedBeforeDepartment;
			SaveData.InterviewedYear =
				resData.researchDetailDTO.interviewedBeforeYear === null
					? ''
					: resData.researchDetailDTO.interviewedBeforeYear;
			SaveData.InterviewedApplNo =
				resData.researchDetailDTO.interviewedBeforeApplicationNo === null
					? ''
					: resData.researchDetailDTO.interviewedBeforeApplicationNo;
			SaveData.InterviewedSubject =
				resData.researchDetailDTO.interviewedBeforeSubject === null
					? ''
					: resData.researchDetailDTO.interviewedBeforeSubject;
			SaveData.vacancySource =
				resData.researchDetailDTO.vacancyInformationId === null
					? ''
					: MatchDataFunction(
						resData.researchDetailDTO.vacancyInformationId,
						prevData[12].data.dto,
						'SingleSelect'
					);
			SaveData.SourceOthers =
				resData.researchDetailDTO.aboutVacancyOthers === null
					? ''
					: resData.researchDetailDTO.aboutVacancyOthers;
			SaveData.OtherInformation =
				resData.researchDetailDTO.otherInformation === null ? '' : resData.researchDetailDTO.otherInformation;
		}
		SetJobDetailsData(resData, prevData, SaveData, isSaveDraftFromScreen);
	};
	const hideSpecDropdown = () => {
		let data = [];
		ChangeSpecStatus(false);
		return data;
	};

	const SetJobDetailsData = async (resData, prevData, State, isSaveDraftFromScreen) => {
		// JOB CATEGORY TO BE ADDED HERE ************
		let SaveData = State;
		// Job details:
		if (ERPUtils.isNullorWhiteSpace(resData?.jobDetailDTO) === false) {
			SaveData.Post = MatchDataFunction(
				resData.jobDetailDTO.postAppliedFor,
				prevData[9]?.data?.dto,
				'SingleSelect'
			);
			SaveData.jobCategoryDTO = ERPUtils.isUndefinedOrNull(resData?.jobCategoryDTO)
				? []
				: await getSyncData(
					resData.jobCategoryDTO,
					SaveData.Post.value,
					'Employee/CommonEmployee/getEmployeeJobCategory?employeeCategoryID=',
					'getJobCategory'
				);
			if (SaveData.Post.isEmployeeCategoryAcademic === false) {
				ChangeRequiredStatus('Non-Teaching');
				SaveData.category = ERPUtils.isUndefinedOrNull(resData.jobDetailDTO.empApplnSubjectCategoryDTO)
					? []
					: await getSyncData(
						resData.jobDetailDTO.empApplnSubjectCategoryDTO,
						SaveData.Post.isEmployeeCategoryAcademic,
						'Employee/CommonEmployee/getApplnSubjectCategory?isAcademic=',
						'getCat'
					);
			} else {
				ChangeRequiredStatus('Teaching');
				SaveData.Subject = ERPUtils.isUndefinedOrNull(resData.jobDetailDTO.subjectCategoryIds)
					? ERPUtils.isUndefinedOrNull(resData.jobDetailDTO.postAppliedFor) === false
						? await getSyncData(
							'',
							SaveData.Post.isEmployeeCategoryAcademic,
							'Employee/CommonEmployee/getApplnSubjectCategory?isAcademic=',
							'withoutSubData'
						)
						: []
					: await getSyncData(
						resData.jobDetailDTO.subjectCategoryIds,
						SaveData.Post.isEmployeeCategoryAcademic,
						'Employee/CommonEmployee/getApplnSubjectCategory?isAcademic=',
						'getSub'
					);
				if (!ERPUtils.isNullOrEmpty(SaveData.Subject)) {
					ChangeRequiredStatus("validateSubject");
				}
				SaveData.Specialization = ERPUtils.isUndefinedOrNull(resData.jobDetailDTO.specializationIds)
					? ERPUtils.isUndefinedOrNull(resData.jobDetailDTO.subjectCategoryIds) === false
						? resData.jobDetailDTO.subjectCategoryIds.length > 0
							? await getSyncData(
								'',
								resData.jobDetailDTO.subjectCategoryIds,
								'Employee/CommonEmployee/getApplnSubjectCategorySpecialization?subjectCategoryId=',
								'withoutSpecData'
							)
							: hideSpecDropdown()
						: hideSpecDropdown()
					: await getSyncData(
						resData.jobDetailDTO.empApplnSubjectCategoryDTO,
						// resData.jobDetailDTO.specializationIds,
						resData.jobDetailDTO.subjectCategoryIds,
						'Employee/CommonEmployee/getApplnSubjectCategorySpecialization?subjectCategoryId=',
						'getSpec'
					);
				if (!ERPUtils.isNullOrEmpty(SaveData.Specialization)) {
					ChangeRequiredStatus("specialization");
				}
			}
			// SaveData.Location = ERPUtils.isUndefinedOrNull(resData.jobDetailDTO.preferredLocationIds)
			// 	? []
			// 	: MatchDataFunction(resData.jobDetailDTO.preferredLocationIds, prevData[10].data.dto, 'Location');
			SaveData.empApplnCampusPrefDTOList = ERPUtils.isUndefinedOrNull(resData.jobDetailDTO.empApplnCampusPrefDTOList)
				? []
				: MatchDataFunction(resData.jobDetailDTO.empApplnCampusPrefDTOList, prevData[10].data.dto, 'empApplnCampusPrefDTOList');
		}

		AddReqErrorsForSaveDrftData(SaveData, resData, prevData, isSaveDraftFromScreen);
	};

	const AddReqErrorsForSaveDrftData = (SaveData, resData, prevData, isSaveDraftFromScreen) => {
		let reqErrors = { ...requiredFields };
		reqErrors.eduReq = false
		if (ERPUtils.isUndefinedOrNull(resData?.professionalExperienceDTO) === false) {
			if (ERPUtils.isUndefinedOrNull(resData.professionalExperienceDTO.professionalExperienceList) === false) {
				if (resData.professionalExperienceDTO.professionalExperienceList.length > 0) {
					resData.professionalExperienceDTO.professionalExperienceList.map((el, index) => {
						if (index > 0) {
							reqErrors['profReq'].push({
								otherFunctAreaReqError: false
							});
						}
						return '';
					});
				}
			}
		}
		// setEducationMandatory(saveDraftMand);
		setRequiredFields(reqErrors, () => {
			setUserDetails(SaveData, () => {
				// setLoaderActive(false);
				if (ERPUtils.isUndefinedOrNull(isSaveDraftFromScreen) || !isSaveDraftFromScreen) {
					openPendingTab(resData, SaveData.Post.isEmployeeCategoryAcademic, isSaveDraftFromScreen);
				}
				getBoardOrUniversityOnLoad(SaveData, prevData);
			});
		});
		// setTimerRunning(true)
	};

	const openPendingTab = (data, isAcademic) => {
		//
		const tabs = {
			RoleDetails: false,
			PersonalDetails: false,
			AddressDetails: false,
			EducationDetails: false,
			ProfessionalExperience: false,
			ResearchDetails: false
		};
		// Job Details
		if (ERPUtils.isNullorWhiteSpace(data?.jobDetailDTO) === false) {
			Object.keys(data.jobDetailDTO).map((el) => {
				if (el !== 'empApplnEntriesId') {
					if (el === 'specializationIds') {
						if (isAcademic) {
							// if (sessionStorage.getItem('specs') === 'true') { //Testing
							if (specialize) {
								if (data.jobDetailDTO[el] === null) {
									tabs.RoleDetails = true;
								}
							}
							// }
						}
					} else {
						if (data.jobDetailDTO[el] === null) {
							tabs.RoleDetails = true;
						}
					}
				}
				return ''
			});
		}
		// Personal Details
		if (ERPUtils.isNullorWhiteSpace(data?.empApplnPersonalDataDTO) === false && tabs.RoleDetails === false) {
			if (
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.applicantName) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.genderId) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.fatherName) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.motherName) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.dateOfBirth) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.emailId) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.mobileNoCountryCode) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.mobileNo) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.alternateNo) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.aadharNo) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.maritalStatusId) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.nationalityId) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.passportNo) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.religionId) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.isMinority) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.reservationCategoryId) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.bloodGroupId) ||
				ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.isDifferentlyAbled)
			) {
				tabs.PersonalDetails = true;
			}
			if (ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.isDifferentlyAbled) === false) {
				if (data.empApplnPersonalDataDTO.isDifferentlyAbled === 'Yes') {
					if (ERPUtils.isNullorWhiteSpace(data.empApplnPersonalDataDTO.DifferentlyAbledType)) {
						tabs.PersonalDetails = true;
					}
				}
			}
		}
		// Address Details:
		if (
			ERPUtils.isNullorWhiteSpace(data?.addressDetailDTO) === false &&
			tabs.RoleDetails === false &&
			tabs.PersonalDetails === false
		) {
			if (
				ERPUtils.isNullorWhiteSpace(data.addressDetailDTO.currentAddressLine1) ||
				ERPUtils.isNullorWhiteSpace(data.addressDetailDTO.currentAddressLine2) ||
				ERPUtils.isNullorWhiteSpace(data.addressDetailDTO.currentCountryId) ||
				ERPUtils.isNullorWhiteSpace(data.addressDetailDTO.currentStateId) ||
				// ERPUtils.isNullorWhiteSpace(data.addressDetailDTO.currentStateOthers) ||
				ERPUtils.isNullorWhiteSpace(data.addressDetailDTO.currentCityId) ||
				// ERPUtils.isNullorWhiteSpace(data.addressDetailDTO.currentCityOthers) ||
				ERPUtils.isNullorWhiteSpace(data.addressDetailDTO.currentPincode) ||
				ERPUtils.isNullorWhiteSpace(data.addressDetailDTO.permanentAddressLine1) ||
				ERPUtils.isNullorWhiteSpace(data.addressDetailDTO.permanentAddressLine2) ||
				ERPUtils.isNullorWhiteSpace(data.addressDetailDTO.permanentCountryId) ||
				// ERPUtils.isNullorWhiteSpace(data.addressDetailDTO.permanentStateOthers) ||
				ERPUtils.isNullorWhiteSpace(data.addressDetailDTO.permanentStateId) ||
				ERPUtils.isNullorWhiteSpace(data.addressDetailDTO.permanentCityId) ||
				// ERPUtils.isNullorWhiteSpace(data.addressDetailDTO.permanentCityOthers) ||
				ERPUtils.isNullorWhiteSpace(data.addressDetailDTO.permanentPincode)
			) {
				tabs.AddressDetails = true;
			}
		}

		// Educational Details
		if (
			ERPUtils.isNullorWhiteSpace(data?.educationalDetailDTO) === false &&
			tabs.RoleDetails === false &&
			tabs.PersonalDetails === false &&
			tabs.AddressDetails === false
		) {
			if (ERPUtils.isNullorWhiteSpace(data?.educationalDetailDTO?.highestQualificationLevelId)) {
				tabs.educational = true;
			} else {
				if (ERPUtils.isNullorWhiteSpace(data.educationalDetailDTO.qualificationLevelsList) === false) {
					if (data.educationalDetailDTO.qualificationLevelsList.length > 0) {
						data.educationalDetailDTO.qualificationLevelsList.map((el) => {
							if (
								ERPUtils.isNullorWhiteSpace(el.qualificationLevelId) ||
								ERPUtils.isNullorWhiteSpace(el.currentStatus) ||
								ERPUtils.isNullorWhiteSpace(el.course) ||
								ERPUtils.isNullorWhiteSpace(el.specialization) ||
								ERPUtils.isNullorWhiteSpace(el.yearOfCompletion) ||
								ERPUtils.isNullorWhiteSpace(el.gradeOrPercentage) ||
								ERPUtils.isNullorWhiteSpace(el.institute) ||
								ERPUtils.isNullorWhiteSpace(el.boardOrUniversity)
							) {
								tabs.EducationDetails = true;
							}
							return ''
						});
						return ''
					}
				} else {
					tabs.EducationDetails = true;
				}

				if (ERPUtils.isNullorWhiteSpace(data?.educationalDetailDTO.eligibilityTestList) === false) {
					if (data.educationalDetailDTO.eligibilityTestList.length > 0) {
						data.educationalDetailDTO.eligibilityTestList.map((el) => {
							if (
								ERPUtils.isNullorWhiteSpace(el.eligibilityTestId) ||
								ERPUtils.isNullorWhiteSpace(el.testYear)
							) {
								tabs.EducationDetails = true;
							}
							return ''
						});
					}
				}

				if (ERPUtils.isNullorWhiteSpace(data.educationalDetailDTO.otherQualificationLevelsList) === false) {
					if (data.educationalDetailDTO.otherQualificationLevelsList.length > 0) {
						data.educationalDetailDTO.otherQualificationLevelsList.map((el) => {
							if (
								ERPUtils.isNullorWhiteSpace(el.qualificationOthers) ||
								ERPUtils.isNullorWhiteSpace(el.currentStatus) ||
								ERPUtils.isNullorWhiteSpace(el.course) ||
								ERPUtils.isNullorWhiteSpace(el.specialization) ||
								ERPUtils.isNullorWhiteSpace(el.yearOfCompletion) ||
								ERPUtils.isNullorWhiteSpace(el.gradeOrPercentage) ||
								ERPUtils.isNullorWhiteSpace(el.institute) ||
								ERPUtils.isNullorWhiteSpace(el.boardOrUniversity)
							) {
								tabs.EducationDetails = true;
							}
							return ''
						});
					}
				}
			}
		}

		// professional Details:
		if (ERPUtils.isNullorWhiteSpace(data?.professionalExperienceDTO) === false &&
			tabs.RoleDetails === false &&
			tabs.PersonalDetails === false &&
			tabs.AddressDetails === false &&
			tabs.EducationDetails === false) {
			if (ERPUtils.isNullorWhiteSpace(data.professionalExperienceDTO.isCurrentlyWorking)) {
				tabs.professional = true;
			} else {
				if (data.professionalExperienceDTO.isCurrentlyWorking === 'Yes') {
					if (data.professionalExperienceDTO.currentExperience !== null) {
						if (ERPUtils.isNullorWhiteSpace(data.professionalExperienceDTO.currentExperience.workExperienceTypeId) ||
							ERPUtils.isNullorWhiteSpace(data.professionalExperienceDTO.currentExperience.employmentType) ||
							ERPUtils.isNullorWhiteSpace(data.professionalExperienceDTO.currentExperience.designation) ||
							ERPUtils.isNullorWhiteSpace(data.professionalExperienceDTO.currentExperience.fromDate) ||
							ERPUtils.isNullorWhiteSpace(data.professionalExperienceDTO.currentExperience.toDate) ||
							ERPUtils.isNullorWhiteSpace(data.professionalExperienceDTO.currentExperience.noticePeriod) ||
							// ERPUtils.isNullorWhiteSpace(data.professionalExperienceDTO.currentExperience.currentSalary) ||
							ERPUtils.isNullorWhiteSpace(data.professionalExperienceDTO.currentExperience.institution)) {
							tabs.ProfessionalExperience = true;
						}

						if (ERPUtils.isNullorWhiteSpace(data.professionalExperienceDTO.currentExperience.functionalAreaId)) {
							if (ERPUtils.isNullorWhiteSpace(data.professionalExperienceDTO.currentExperience.functionalAreaOthers)) {
								tabs.ProfessionalExperience = true;
							}
						}
					}
					else {
						tabs.ProfessionalExperience = true;
					}
				}
			}

			if (ERPUtils.isNullorWhiteSpace(data.professionalExperienceDTO.professionalExperienceList) === false) {
				if (data.professionalExperienceDTO.professionalExperienceList.length > 0) {
					data.professionalExperienceDTO.professionalExperienceList.map(el => {
						if (ERPUtils.isNullorWhiteSpace(el.workExperienceTypeId) ||
							ERPUtils.isNullorWhiteSpace(el.employmentType) ||
							ERPUtils.isNullorWhiteSpace(el.designation) ||
							ERPUtils.isNullorWhiteSpace(el.fromDate) ||
							ERPUtils.isNullorWhiteSpace(el.toDate) ||
							ERPUtils.isNullorWhiteSpace(el.institution)) {
							tabs.ProfessionalExperience = true;
						}
						return ''
					})

					data.professionalExperienceDTO.professionalExperienceList.map(el => {
						if (ERPUtils.isNullorWhiteSpace(el.functionalAreaId)) {
							if (ERPUtils.isNullorWhiteSpace(el.functionalAreaOthers)) {
								tabs.ProfessionalExperience = true;
							}
						}
						return ''
					})
				}
			}
			else {
				tabs.ProfessionalExperience = true;
			}

			if (ERPUtils.isNullorWhiteSpace(data.professionalExperienceDTO.majorAchievements) ||
				ERPUtils.isNullorWhiteSpace(data.professionalExperienceDTO.expectedSalary)) {
				tabs.ProfessionalExperience = true;
			}
		}

		// Research details
		if (tabs.RoleDetails === false &&
			tabs.PersonalDetails === false &&
			tabs.AddressDetails === false &&
			tabs.EducationDetails === false &&
			tabs.ProfessionalExperience === false) {
			tabs.ResearchDetails = true
		}

		if (tabs.RoleDetails === false &&
			tabs.PersonalDetails === false &&
			tabs.AddressDetails === false &&
			tabs.EducationDetails === false &&
			tabs.ProfessionalExperience === false &&
			(ERPUtils.isNullOrEmpty(data?.researchDetailDTO) || ERPUtils.isNullorWhiteSpace(data?.researchDetailDTO))
		) {
			tabs.RoleDetails = true;
		}

		if (tabs.RoleDetails) {
			ChangeToPendingTab('RoleDetails')
		} else if (tabs.PersonalDetails) {
			ChangeToPendingTab('PersonalDetails')
		} else if (tabs.AddressDetails) {
			ChangeToPendingTab('AddressDetails')
		} else if (tabs.EducationDetails) {
			ChangeToPendingTab('EducationDetails')
		} else if (tabs.ProfessionalExperience) {
			ChangeToPendingTab('ProfessionalExperience')
		} else {
			ChangeToPendingTab('ResearchDetails')
		}
	};

	const ChangeToPendingTab = (name) => {
		const val = name;
		let newobj = {};
		Object.keys(renderComp).map((el) => {
			if (el === val) {
				newobj[el] = true;
			} else {
				newobj[el] = false;
			}
			return '';
		});
		setRenderComp(newobj);
		AddClass(val);
		topFunction();
		closeDropDown();
		if (saveTheData) {
			saveDraft();
		}
		return '';
	};

	const validateEmail = (val) => {
		// eslint-disable-next-line
		const EmailCheck = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		const validEmail = val === '' ? '' : val.match(EmailCheck);
		if (validEmail !== null) {
			ValidationErrorHandler("Email", false);
			// checkUserEmailOnBlur();
		} else {
			// setEmailVerifyMsg(null);
			ValidationErrorHandler("Email", true);
		}
	}

	const loadDataFromResume = (meta, apiResponse) => {
		try {
			const parsedData = typeof apiResponse === 'string' ? JSON.parse(apiResponse) : apiResponse;
			if (parsedData && parsedData.success && parsedData.data) {
				const resumeData = parsedData.data;
				let newState = Utils.cloneState(userDetails);
				newState.resume = meta; // Add this line to prevent losing the uploaded resume file metadata

				// Reset fields that might have been populated by a previous resume
				newState.Name = props.username || '';
				newState.Email = props.Email || '';
				newState.mobileNo = '';
				newState.CountryCode = '';
				newState.Gender = '';
				newState.marital = '';
				newState.currentLine1 = '';
				newState.currentLine2 = '';
				newState.currentCountry = '';
				newState.curAddSameAsPer = false;
				newState.permanentLine1 = '';
				newState.permanentLine2 = '';
				newState.permanentCountry = '';
				newState.HighestQualification = '';
				newState.EducationDetailsObj = {};
				newState.currentWorking = '';
				newState.currentExperienceType = '';
				newState.currentEmpType = '';
				newState.currentDesignation = '';
				newState.currentNoticePeriod = '';
				newState.currentInstitute = '';
				newState.currentFromDate = '';
				newState.OtherInformation = '';
				newState.majorAchievements = '';
				setProfessionalDetails([
					{
						ExperienceType: '',
						functionalArea: '',
						EmpType: '',
						fromDate: '',
						ToDate: '',
						TotalYears: 0,
						TotalMonths: 0,
						designation: '',
						institution: '',
						OtherFunctionalArea: ''
					}
				]);

				// Personal Data Mapping
				if (resumeData.empApplnPersonalDataDTO) {
					const personal = resumeData.empApplnPersonalDataDTO;
					if (personal.applicantName) newState.Name = personal.applicantName;
					if (personal.emailId) newState.Email = personal.emailId;
					if (personal.mobileNo) newState.mobileNo = personal.mobileNo;
					if (personal.mobileNoCountryCode) {
						let codeMatch = CountryCodes.find(c => c?.value === personal.mobileNoCountryCode.replace("+", ""));
						if (!codeMatch && personal.mobileNoCountryCode.includes("91")) {
							codeMatch = CountryCodes.find(c => c?.value === "91");
						}
						if (codeMatch) newState.CountryCode = codeMatch;
					}
					if (personal.genderId) {
						const gMatch = Genders.find(g => g?.value == personal.genderId);
						if (gMatch) newState.Gender = gMatch;
					}
					if (personal.maritalStatusId) {
						const mMatch = maritalStatus.find(m => m?.value == personal.maritalStatusId);
						if (mMatch) newState.marital = mMatch;
					}
				}

				// Address Mapping
				if (resumeData.addressDetailDTO) {
					const address = resumeData.addressDetailDTO;
					if (address.currentAddressLine1) newState.currentLine1 = address.currentAddressLine1;
					if (address.currentAddressLine2) newState.currentLine2 = address.currentAddressLine2;
					if (address.currentCountryId) {
						const cMatch = countries.find(c => c?.value == address.currentCountryId);
						if (cMatch) {
							newState.currentCountry = cMatch;
							callStateApi("current", cMatch);
						}
					}
					if (address.isPermanentEqualsCurrent) {
						newState.curAddSameAsPer = address.isPermanentEqualsCurrent;
					}
					if (address.permanentAddressLine1) newState.permanentLine1 = address.permanentAddressLine1;
					if (address.permanentAddressLine2) newState.permanentLine2 = address.permanentAddressLine2;
					if (address.permanentCountryId) {
						const cMatch = countries.find(c => c?.value == address.permanentCountryId);
						if (cMatch) {
							newState.permanentCountry = cMatch;
							callStateApi("permanent", cMatch);
						}
					}
				}

				// Educational Details Mapping
				if (resumeData.educationalDetailDTO) {
					const edu = resumeData.educationalDetailDTO;
					if (edu.highestQualificationLevelId) {
						const qMatch = EducationList.find(q => q?.value == edu.highestQualificationLevelId);
						if (qMatch) newState.HighestQualification = qMatch;
					}
					if (edu.qualificationLevelsList && edu.qualificationLevelsList.length > 0) {
						edu.qualificationLevelsList.forEach(q => {
							if (q.qualificationLevelId) {
								const levelId = q.qualificationLevelId;
								if (!newState.EducationDetailsObj[levelId]) {
									newState.EducationDetailsObj[levelId] = [];
								}
								if (newState.EducationDetailsObj[levelId].length === 0) {
									newState.EducationDetailsObj[levelId].push({
										Qualification: levelId,
										Status: q.currentStatus || '',
										Course: q.course || '',
										Specialization: q.specialization || '',
										YearOfComp: q.yearOfCompletion || '',
										Percentage: q.gradeOrPercentage || '',
										Institute: q.institute || '',
										Board: q.boardOrUniversity || '',
										countryId: q.countryId || '',
										stateId: q.stateId || '',
										stateOther: q.stateOther || '',
										Documents: []
									});
								} else {
									const item = newState.EducationDetailsObj[levelId][0];
									if (q.currentStatus) item.Status = q.currentStatus;
									if (q.course) item.Course = q.course;
									if (q.specialization) item.Specialization = q.specialization;
									if (q.yearOfCompletion) item.YearOfComp = q.yearOfCompletion;
									if (q.gradeOrPercentage) item.Percentage = q.gradeOrPercentage;
									if (q.institute) item.Institute = q.institute;
									if (q.boardOrUniversity) item.Board = q.boardOrUniversity;
									if (q.countryId) item.countryId = q.countryId;
									if (q.stateId) item.stateId = q.stateId;
								}
							}
						});
					}
				}

				// Professional Experience Mapping
				if (resumeData.professionalExperienceDTO) {
					const prof = resumeData.professionalExperienceDTO;
					if (prof.isCurrentlyWorking) newState.currentWorking = prof.isCurrentlyWorking;
					
					if (prof.currentExperience && prof.isCurrentlyWorking === "Yes") {
						const curr = prof.currentExperience;
						if (curr.workExperienceTypeId) {
							const expMatch = experiences.find(e => e?.value == curr.workExperienceTypeId);
							if (expMatch) newState.currentExperienceType = expMatch;
						}
						if (curr.employmentType) {
							const empMatch = employmentType.find(e => e?.value == curr.employmentType);
							if (empMatch) newState.currentEmpType = empMatch;
						}
						if (curr.designation) newState.currentDesignation = curr.designation;
						if (curr.noticePeriod) newState.currentNoticePeriod = curr.noticePeriod;
						if (curr.institution) newState.currentInstitute = curr.institution;
						if (curr.fromDate && Array.isArray(curr.fromDate)) newState.currentFromDate = new Date(curr.fromDate[0], curr.fromDate[1] - 1, curr.fromDate[2] || 1);
					}

					if (prof.professionalExperienceList && prof.professionalExperienceList.length > 0) {
						let profList = [];
						prof.professionalExperienceList.forEach(p => {
							let expType = '';
							let empType = '';
							if (p.workExperienceTypeId) {
								const match = experiences.find(e => e?.value == p.workExperienceTypeId);
								if (match) expType = match;
							}
							if (p.employmentType) {
								const match = employmentType.find(e => e?.value == p.employmentType);
								if (match) empType = match;
							}
							profList.push({
								ExperienceType: expType,
								functionalArea: '',
								EmpType: empType,
								fromDate: p.fromDate && Array.isArray(p.fromDate) ? new Date(p.fromDate[0], p.fromDate[1] - 1, p.fromDate[2] || 1) : '',
								ToDate: p.toDate && Array.isArray(p.toDate) ? new Date(p.toDate[0], p.toDate[1] - 1, p.toDate[2] || 1) : '',
								TotalYears: p.years || 0,
								TotalMonths: p.months || 0,
								designation: p.designation || '',
								institution: p.institution || '',
								OtherFunctionalArea: ''
							});
						});
						setProfessionalDetails(profList);
					}
				}

				// Additional info
				if (resumeData.additionalInformations) {
					const addInfo = resumeData.additionalInformations;
					if (addInfo.profile_summary) {
						newState.OtherInformation = addInfo.profile_summary;
					}
					if (addInfo.skills && addInfo.skills.length > 0) {
						newState.majorAchievements = "Skills: " + addInfo.skills.join(", ");
						if (addInfo.awards && addInfo.awards.length > 0) {
							newState.majorAchievements += "\nAwards: " + addInfo.awards.join(", ");
						}
					}
				}

				setUserDetails(newState);
				toast.success("Resume parsed and data loaded successfully!");
			}
		} catch (ex) {
			console.error("Error loading resume data", ex);
		}
	};

	// UseEffect to load data from Api:
	useEffect(() => {
		getDropDownsDataFromApi();

		// if (optionValue.length > 0) {
		// 	camPrefApi(optionValue);
		// }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (timePeriodOver === true) {
			saveDraft()
			setTimeout(() => {
				setTimePeriodOver(false)
			}, 200)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [timePeriodOver])

	useEffect(() => {
		let optionValue = "";
		if (Array.isArray(userDetails?.Subject) && userDetails.Subject.length > 0) {
			optionValue = []
			userDetails.Subject.map((el) => {
				optionValue.push(el.value)
			}); // Use `map` directly
		} else {
			optionValue = userDetails?.category?.value;
		}
		if (optionValue) {
			camPrefApi(optionValue)
		}
	}, [userDetails.category, userDetails.Subject])

	useEffect(() => {
		if(applyNew && !LockDashboard && !parseResumeData){
			setParseResumeData(true);
		}
		// if(applyNew && !LockDashboard && !showResumePopup){
		// 	setShowResumePopup(true);
		// }
	}, []);

	return (
		<div>
			<div className="mainFormHeaderDiv">
				<div className='row' style={{ width: "100%" }}>
					{window.innerWidth < 768 &&
						<div className='col-md-9 border-bottom pb-1'>
							<h3 className="mainHeaderText ">Job Application Form</h3>
						</div>
					}
					<div className='col-md-3 d-flex justify-content-start pt-1 pb-1'>
						<button
							className={LockDashboard ? 'disabledDashboardBtn' : 'backtoDashboardBtn'}
							onClick={dashboardHandler}
							disabled={LockDashboard}
						>
							<i className="fa fa-arrow-left backIcon" />Back to Dashboard
						</button>
					</div>
					{window.innerWidth >= 768 &&
						<div className='col-md-9'>
							<h3 className="mainHeaderText ">Job Application Form</h3>
						</div>
					}
				</div>
			</div>
			<div className="applicationForm">
				<div className="row">
					<div className="col-md-3 removePaddingRight">
						<nav className="navbar navFix navbar-expand-md">
							<div className="container-fluid">
								<div className="navbar-header">
									<button
										className="navbar-toggler BurgerIcon collapsed"
										id="burgerBtn"
										type="button"
										data-toggle="collapse"
										data-target="#collapsibleNavbar"
									>
										<span> </span>
										<span> </span>
										<span> </span>
									</button>
								</div>
								<div className="collapse navbar-collapse" id="collapsibleNavbar">
									<ul className="nav navpills">
										<li
											className={renderComp.RoleDetails ? 'nav-item navLink' : 'nav-item navLink'}
											id="RoleDetails"
										>
											<div
												className={
													ReqTabsStyle.jobDetails ? (
														'nav-link menuTabItems invalidTab emp-appl-custom-link'
													) : (
														'nav-link menuTabItems active emp-appl-custom-link'
													)
												}
												data-toggle="pill"
												name="RoleDetails"
												onClick={() => handleRenderComp("RoleDetails")}
												tabIndex={0}
												role='button'
												onKeyDown={(e) => {
													if ((e.key !== "Tab") && ERPUtils.isKeyBoardEnterPressed(e))
														handleRenderComp("RoleDetails")
												}}
											>
												<i
													className="fa fa-briefcase SpanIcon"
													style={{ marginRight: 8 }}
													title="RoleDetails"
													onClick={IconClick}
												/>
												<span>
													Job Details
												</span>
											</div>
										</li>
										<li
											className={
												renderComp.PersonalDetails ? 'nav-item navLink' : 'nav-item navLink'
											}
											id="PersonalDetails"
										>
											<div

												className={
													ReqTabsStyle.PersonalDetails ? (
														'nav-link menuTabItems invalidTab emp-appl-custom-link'
													) : (
														'nav-link menuTabItems emp-appl-custom-link'
													)
												}
												data-toggle="pill"
												name="PersonalDetails"
												onClick={() => handleRenderComp("PersonalDetails")}
												tabIndex={0}
												role='button'
												onKeyDown={(e) => {
													if ((e.key !== "Tab") && ERPUtils.isKeyBoardEnterPressed(e))
														handleRenderComp("PersonalDetails")
												}}
											>
												<i
													className="fa fa-user-tie SpanIcon"
													style={{ marginRight: 8, fontSize: 16 }}
													title="PersonalDetails"
													onClick={IconClick}
												/>
												<span>
													Personal Details
												</span>
											</div>
										</li>
										<li
											className={
												renderComp.AddressDetails ? 'nav-item navLink' : 'nav-item navLink'
											}
											id="AddressDetails"
										>
											<div

												className={
													ReqTabsStyle.AddressDetails ? (
														'nav-link menuTabItems invalidTab emp-appl-custom-link'
													) : (
														'nav-link menuTabItems emp-appl-custom-link'
													)
												}
												data-toggle="pill"
												name="AddressDetails"
												onClick={() => handleRenderComp("AddressDetails")}
												tabIndex={0}
												role='button'
												onKeyDown={(e) => {
													if ((e.key !== "Tab") && ERPUtils.isKeyBoardEnterPressed(e))
														handleRenderComp("AddressDetails")
												}}
											>
												<i
													className="fa fa-address-card SpanIcon"
													style={{ marginRight: 8 }}
													title="AddressDetails"
													onClick={IconClick}
												/>
												Address Details
											</div>
										</li>
										<li
											className={
												renderComp.EducationDetails ? 'nav-item navLink' : 'nav-item navLink'
											}
											id="EducationDetails"
										>
											<div
												className={
													ReqTabsStyle.EducationalDetails ? (
														'nav-link menuTabItems invalidTab emp-appl-custom-link'
													) : (
														'nav-link menuTabItems emp-appl-custom-link'
													)
												}
												data-toggle="pill"
												name="EducationDetails"
												onClick={() => handleRenderComp("EducationDetails")}
												tabIndex={0}
												role='button'
												onKeyDown={(e) => {
													if ((e.key !== "Tab") && ERPUtils.isKeyBoardEnterPressed(e))
														handleRenderComp("EducationDetails")
												}}
											>
												<i
													className="fa fa-graduation-cap SpanIcon"
													style={{ marginRight: 8 }}
													title="EducationDetails"
													onClick={IconClick}
												/>
												Educational Details
											</div>
										</li>
										<li
											className={
												renderComp.ProfessionalExperience ? (
													'nav-item navLink'
												) : (
													'nav-item navLink'
												)
											}
											id="ProfessionalExperience"
										>
											<div
												className={
													ReqTabsStyle.ProfessionalDetails ? (
														'nav-link menuTabItems invalidTab emp-appl-custom-link'
													) : (
														'nav-link menuTabItems emp-appl-custom-link'
													)
												}
												data-toggle="pill"
												name="ProfessionalExperience"
												onClick={() => handleRenderComp("ProfessionalExperience")}
												tabIndex={0}
												role='button'
												onKeyDown={(e) => {
													if ((e.key !== "Tab") && ERPUtils.isKeyBoardEnterPressed(e))
														handleRenderComp("ProfessionalExperience")
												}}
											>
												<i
													className="fa fa-industry SpanIcon"
													style={{ marginRight: 8 }}
													title="ProfessionalExperience"
													onClick={IconClick}
												/>
												<span>
													Professional Experience
												</span>
											</div>
										</li>
										<li
											className={
												renderComp.ResearchDetails ? 'nav-item navLink' : 'nav-item navLink'
											}
											id="ResearchDetails"
										>
											<div
												className={
													ReqTabsStyle.ResearchDetails ? (
														'nav-link menuTabItems invalidTab emp-appl-custom-link'
													) : (
														'nav-link menuTabItems emp-appl-custom-link'
													)
												}
												data-toggle="pill"
												name="ResearchDetails"
												onClick={() => handleRenderComp("ResearchDetails")}
												tabIndex={0}
												role='button'
												onKeyDown={(e) => {
													if ((e.key !== "Tab") && ERPUtils.isKeyBoardEnterPressed(e))
														handleRenderComp("ResearchDetails")
												}}
											>
												<i
													className="fa fa-book SpanIcon "
													style={{ marginRight: 8 }}
													title="ResearchDetails"
													onClick={IconClick}
												/>
												Research & Other Details
											</div>
										</li>

									</ul>
								</div>
							</div>
						</nav>
					</div>
					<div className="col-md-9 removePaddingLeft form-area-container">

						{renderComp.RoleDetails ? (
							<RoleSection
								toggle={toggle}
								toggleHandler={toggleHandler}
								userDetails={userDetails}
								posts={posts}
								jobCode={jobCode}
								jobCategory={jobCategory}
								subjects={subjects}
								specialize={specialize}
								Locations={Campus}
								onChangeHandler={onChangeHandler}
								handleRenderComp={handleRenderComp}
								popupOnDraftSuccess={popupOnDraftSuccess}
								SelectHandler={SelectHandler}
								topFunction={topFunction}
								scrollToBottom={scrollToBottom}
								requiredFields={requiredFields}
								showSpecialization={showSpecialization}
								saveDraft={saveDraft}
								savedJobCode={saveDraftData?.jobDetailDTO?.advertisementNo}
								JobDetailsSubjectSelect={JobDetailsSubjectSelect}
								LockDashboard={LockDashboard}
								dashboardHandler={dashboardHandler}
								scrollHandler={scrollHandler}
								campusPref={campusPref}
								UploadData={UploadData}
								setSaveTheData={setSaveTheData}
								setUserDetails={setUserDetails}
								parseResumeData={parseResumeData}
								loadDataFromResume={loadDataFromResume}
							/>
						) : null}

						{renderComp.PersonalDetails ? (
							<PersonalDetails
								isPassportRequired={isPassportRequired}
								onChangeHandler={onChangeHandler}
								userDetails={userDetails}
								Genders={Genders}
								maritalStatus={maritalStatus}
								Nationalities={Nationalities}
								Religions={Religions}
								bloodGroups={bloodGroups}
								Reservations={Reservations}
								DifferentlyAbledOpt={DifferentlyAbledOpt}
								checkboxHandler={checkboxHandler}
								handleRenderComp={handleRenderComp}
								popupOnDraftSuccess={popupOnDraftSuccess}
								DateChangeHandler={DateChangeHandler}
								SelectHandler={SelectHandler}
								ValidationError={ValidationError}
								topFunction={topFunction}
								scrollToBottom={scrollToBottom}
								requiredFields={requiredFields}
								CountryCodes={CountryCodes}
								CloseCountryCodeInput={CloseCountryCodeInput}
								GenerateRemovePopup={GenerateRemovePopup}
								saveDraft={saveDraft}
								editable={editable}
								LockDashboard={LockDashboard}
								dashboardHandler={dashboardHandler}
								validateEmail={validateEmail}
								scrollHandler={scrollHandler}
								UploadData={UploadData}
							/>
						) : null}

						{renderComp.AddressDetails ? (
							<AddressDetails
								userDetails={userDetails}
								onChangeHandler={onChangeHandler}
								checkboxHandler={checkboxHandler}
								handleRenderComp={handleRenderComp}
								popupOnDraftSuccess={popupOnDraftSuccess}
								ValidationError={ValidationError}
								statesCur={statesCur}
								statesPer={statesPer}
								countries={countries}
								SelectHandler={SelectHandler}
								topFunction={topFunction}
								scrollToBottom={scrollToBottom}
								requiredFields={requiredFields}
								saveDraft={saveDraft}
								GenerateRemovePopup={GenerateRemovePopup}
								currentCities={currentCities}
								permanentCities={permanentCities}
								LockDashboard={LockDashboard}
								dashboardHandler={dashboardHandler}
								scrollHandler={scrollHandler}
							/>
						) : null}
						{renderComp.EducationDetails ? (
							<EducationalDetails
								userDetails={userDetails}
								setUserDetails={setUserDetails}
								EducationDetailsHandler={EducationDetailsHandler}
								EducationDetailsSelectHandler={EducationDetailsSelectHandler}
								getBoardOrInstitueList={getBoardOrInstitueList}
								EducationList={EducationList}
								HighestQualification={userDetails.HighestQualification}
								addComponent={addComponent}
								removeHandler={removeHandler}
								handleRenderComp={handleRenderComp}
								popupOnDraftSuccess={popupOnDraftSuccess}
								SelectHandler={SelectHandler}
								EducationalDetailsDropDownHandler={EducationalDetailsDropDownHandler}
								topFunction={topFunction}
								scrollToBottom={scrollToBottom}
								requiredFields={requiredFields}
								YearsDropDownData={Years}
								EligibilityTests={EligibilityTests}
								EducationStatus={EducationStatus}
								GenerateRemovePopup={GenerateRemovePopup}
								saveDraft={saveDraft}
								// onFileChange={onFileChange}
								imageRemoveHandler={imageRemoveHandler}
								openImageInTab={openImageInTab}
								checkDecimal={educationDecimalCheck}
								EducationOtherDetailsHandler={EducationOtherDetailsHandler}
								ValidationError={ValidationError}
								LockDashboard={LockDashboard}
								dashboardHandler={dashboardHandler}
								states={states}
								countries={countries}
								boardList={boardList}
								institutionList={institutionList}
								scrollHandler={scrollHandler}
								UploadData={UploadData}
								setSaveTheData={setSaveTheData}
							/>
						) : null}

						{renderComp.ProfessionalExperience ? (
							<ProfessionalDetails
								userDetails={userDetails}
								setUserDetails={setUserDetails}
								addComponent={addComponent}
								professionalDetails={professionalDetails}
								setProfessionalDetails={setProfessionalDetails}
								functionalAreas={functionalAreas}
								ProfessionalDetailsHandler={ProfessionalDetailsHandler}
								onChangeHandler={onChangeHandler}
								experiences={experiences}
								removeHandler={removeHandler}
								handleRenderComp={handleRenderComp}
								popupOnDraftSuccess={popupOnDraftSuccess}
								ProfessionalDetailsDropDownHandler={ProfessionalDetailsDropDownHandler}
								DateChangeHandler={DateChangeHandler}
								addMaxValue={addMaxValue}
								addEnteredValue={addEnteredValue}
								ValidationError={ValidationError}
								topFunction={topFunction}
								scrollToBottom={scrollToBottom}
								requiredFields={requiredFields}
								GenerateRemovePopup={GenerateRemovePopup}
								SelectHandler={SelectHandler}
								employmentType={employmentType}
								saveDraft={saveDraft}
								// onFileChange={onFileChange}
								imageRemoveHandler={imageRemoveHandler}
								openImageInTab={openImageInTab}
								ProfesionalSelectHandler={ProfesionalSelectHandler}
								checkDecimal={checkDecimal}
								LockDashboard={LockDashboard}
								dashboardHandler={dashboardHandler}
								scrollHandler={scrollHandler}
								UploadData={UploadData}
								setSaveTheData={setSaveTheData}
							/>
						) : null}
						{renderComp.ResearchDetails ? (

							<ResearchDetails
								onChangeHandler={onChangeHandler}
								userDetails={userDetails}
								setUserDetails={setUserDetails}
								vacancySources={vacancySources}
								popupOnDraftSuccess={popupOnDraftSuccess}
								SelectHandler={SelectHandler}
								ResearchData={ResearchData}
								ResearchDetailsHandler={ResearchDetailsHandler}
								ValidationError={ValidationError}
								ResearchDetailsData={userDetails.ResearchDetailsData}
								addInfoEnteredVal={addInfoEnteredVal}
								addInfoMaxVal={addInfoMaxVal}
								handleRenderComp={handleRenderComp}
								topFunction={topFunction}
								scrollToBottom={scrollToBottom}
								requiredFields={requiredFields}
								onDataSave={onDataSave}
								saveDraft={saveDraft}
								// onFileChange={onFileChange}
								imageRemoveHandler={imageRemoveHandler}
								openImageInTab={openImageInTab}
								loadOrcidData={loadOrcidData}
								LockDashboard={LockDashboard}
								dashboardHandler={dashboardHandler}
								scrollHandler={scrollHandler}
								UploadData={UploadData}
								setSaveTheData={setSaveTheData}
							/>
						) : null}
					</div>
				</div>
			</div>

{/* Resume Uplaoda Popup  */}
			{/* {
				showResumePopup ? (
					<ResumePopup
						open={showResumePopup}
						onClose={closeResumePopup}
						/>
				) : null
			}						 */}
			{/* Required fileds Popup */}
			{
				ReqFieldsAlert ? (
					<Popup
						open={ReqFieldsAlert}
						close={closeReqFieldAlert}
						msg="Please check, Some of the required fields are missing in your application"
						title="Sorry!"
						icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
						success={false}
						hint="Note: You can find the missing fields in the tabs that are highlighted with the red text"
						tabName="RequiredFieldsAlert"
					/>
				) : null
			}

			{/* validation Error popup */}
			{
				ValidationAlert ? (
					<Popup
						open={ValidationAlert}
						close={closeReqFieldAlert}
						msg="Hang on, You have few invalid error fields in the form"
						title="Sorry!"
						icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
						success={false}
						hint="Note: Please review your form and submit"
						tabName="validationAlert"
					/>
				) : null
			}

			{/* popup for Curr same as Per Address */}
			{
				showAddressPopup ? (
					<Popup
						open={showAddressPopup}
						close={closeReqFieldAlert}
						msg="Please fill in the required fields in current address and click the check box"
						title="Sorry!"
						icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
						success={false}
						// hint="Note: You click this checkbox again, once the current address part is filled."
						tabName="AddressNote"
					/>
				) : null
			}

			{
				OpenConfirmPopup ? (
					<ConfirmPopup
						open={OpenConfirmPopup}
						icon={<i className="fa fa-exclamation ConfirmWarningIcon" />}
						confirm={DoItHandler}
						cancel={CancelHandler}
						//title="Are you sure?"
						msg="Do you want to delete the record ?"

						tabName="professional"
					/>
				) : null
			}

			{/* {
				CountryCodePopup ? (
					<Popup
						open={CountryCodePopup}
						close={closeReqFieldAlert}
						msg="Please enter the valid country code in the respective input field"
						icon={
							<i
								className="fa fa-info-circle"
								aria-hidden="true"
								style={{ color: '#eea236', fontSize: '50px' }}
							/>
						}
						success={false}
						hint="Note: If you want select the country code from the list provided then click on the close icon next to input field"
						tabName="CountryCodeHelper"
					/>
				) : null
			} */}

			{
				countryCodeConfirmPopup ? (
					<ConfirmPopup
						open={countryCodeConfirmPopup}
						icon={<i className="fa fa-exclamation ConfirmWarningIcon" />}
						confirm={DoItHandler}
						cancel={CancelHandler}
						//title="Are you sure?"
						msg="Do you want to delete the record ?"
						tabName="CountryCode"
					/>
				) : null
			}

			{
				wrongPincode ? (
					<Popup
						open={wrongPincode}
						close={closeReqFieldAlert}
						msg="You have entered an invalid pincode"
						title="Sorry!"
						icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
						success={false}
						hint="Note: Please provide a valid pincode"
						tabName="incorrectPincode"
					/>
				) : null
			}

			{/* popups for other state and city */}
			{
				showCurrStatePopup ? (
					<Popup
						open={showCurrStatePopup}
						close={closeReqFieldAlert}
						msg="Please enter the valid current state in the respective input field"
						icon={
							<i
								className="fa fa-info-circle"
								aria-hidden="true"
								style={{ color: '#eea236', fontSize: '50px' }}
							/>
						}
						success={false}
						hint="Note: If you want select the state from the list provided then click on the close icon next to input field"
						tabName="currState"
					/>
				) : null
			}

			{
				currStateConfirmPopup ? (
					<ConfirmPopup
						open={currStateConfirmPopup}
						icon={<i className="fa fa-exclamation ConfirmWarningIcon" />}
						confirm={DoItHandler}
						cancel={CancelHandler}
						//title="Are you sure?"
						msg="Do you want to delete the record ?"
						tabName="currStateConfirm"
					/>
				) : null
			}

			{
				showCurrCityPopup ? (
					<Popup
						open={showCurrCityPopup}
						close={closeReqFieldAlert}
						msg="Please enter the valid current city in the respective input field"
						icon={
							<i
								className="fa fa-info-circle"
								aria-hidden="true"
								style={{ color: '#eea236', fontSize: '50px' }}
							/>
						}
						success={false}
						hint="Note: If you want select the city from the list provided then click on the close icon next to input field"
						tabName="currCity"
					/>
				) : null
			}

			{
				currCityConfirmPoup ? (
					<ConfirmPopup
						open={currCityConfirmPoup}
						icon={<i className="fa fa-exclamation ConfirmWarningIcon" />}
						confirm={DoItHandler}
						cancel={CancelHandler}
						//title="Are you sure?"
						msg="Do you want to delete the record ?"
						tabName="currCityConfirm"
					/>
				) : null
			}

			{
				showPermStatePopup ? (
					<Popup
						open={showPermStatePopup}
						close={closeReqFieldAlert}
						msg="Please enter the valid Permanent state in the respective input field"
						icon={
							<i
								className="fa fa-info-circle"
								aria-hidden="true"
								style={{ color: '#eea236', fontSize: '50px' }}
							/>
						}
						success={false}
						hint="Note: If you want select the state from the list provided then click on the close icon next to input field"
						tabName="permState"
					/>
				) : null
			}

			{
				permStateConfirmPopup ? (
					<ConfirmPopup
						open={permStateConfirmPopup}
						icon={<i className="fa fa-exclamation ConfirmWarningIcon" />}
						confirm={DoItHandler}
						cancel={CancelHandler}
						//title="Are you sure?"
						msg="Do you want to delete the record ?"
						tabName="permStateConfirm"
					/>
				) : null
			}

			{
				showPermCityPopup ? (
					<Popup
						open={showPermCityPopup}
						close={closeReqFieldAlert}
						msg="Please enter the valid permanent city in the respective input field"
						icon={
							<i
								className="fa fa-info-circle"
								aria-hidden="true"
								style={{ color: '#eea236', fontSize: '50px' }}
							/>
						}
						success={false}
						hint="Note: If you want select the city from the list provided then click on the close icon next to input field"
						tabName="permCity"
					/>
				) : null
			}

			{
				permCityConfirmPoup ? (
					<ConfirmPopup
						open={permCityConfirmPoup}
						icon={<i className="fa fa-exclamation ConfirmWarningIcon" />}
						confirm={DoItHandler}
						cancel={CancelHandler}
						//title="Are you sure?"
						msg="Do you want to delete the record ?"

						tabName="permCityConfirm"
					/>
				) : null
			}
			{
				orcidState.openWindow && (
					<OrcidPopup
						orcidId={orcidState.changedOrcidId}
						closeWindowPortal={closeWindowPortal}
						updateId={updateId}
						updateIdValue={orcidState.updateId}
					/>
				)
			}
			{
				ErrorPopup ? (
					<Popup
						open={ErrorPopup}
						close={ErrorPopupHandler}
						msg={ErrorMsg}
						icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
						title="Error!"
						success={false}
					/>
				) : null
			}
			{
				EmpTypeAlert ? (
					<Popup
						open={EmpTypeAlert}
						close={EmpTypeAlertPopupHandler}
						msg={"Please choose Employment Type "}
						icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
						success={false}
					/>
				) : null
			}
			{LoaderActive ? <Loader open={LoaderActive} LoaderType={1} /> : null}
		</div>
	);
};
export default FormContainer;